import axios from 'axios'
import store from './index.js'
// import router from '../router/index.js'
import settings from '../settings/config.js'
import { getAPIURL } from '@/store/getters.js'
import moment from 'moment'

export const loginState = ({ commit }) => {
  store.state.login.state = false
}

export const login = ({ commit }, user) => {
  const params = {
    'name': user.name,
    'password': user.password
  }
  axios({
    method: 'post',
    params: params,
    url: getAPIURL() + '/api/v1/users/sign_in',
    withCredentials: true
  }).then(response => {
    console.log(response)
    axios({
      method: 'get',
      url: getAPIURL() + '/api/v1/user/',
      withCredentials: true
    }).then(response => {
      console.log(response)
      store.state.login.state = true
      store.state.item.user = response.data
      // alert('LogInしました')
    }).catch(error => {
      console.log(error)
      // alert('getに失敗しました')
      store.dispatch('loginState')
    })
  }).catch(error => {
    console.log(error)
    alert('LogInに失敗しました')
  })
}

export const logout = ({ commit }) => {
  if (window.confirm('LogOutしますか？')) {
    axios({
      method: 'delete',
      url: getAPIURL() + '/api/v1/users/sign_out/',
      withCredentials: true
    }).then(response => {
      console.log(response)
      store.state.login.state = false
      store.state.item.user = ''
      // location.reload()
      // alert('LogOutしました')
    }).catch(error => {
      console.log(error)
      alert('LogOutできませんでした')
    })
  } else {
    return
  }
}

export const back = ({ commit }) => {
  history.back()
}

export const incrementAsync = ({ commit }) => {
  setTimeout(() => {
    commit('increment')
  }, 1000)
}

export const BACK = ({ commit }) => {
  history.back()
}

export const getBanks = ({ commit }, data) => {
  const url = 'https://bank.teraren.com/banks/search.json?name=' + data.bank_name
  axios({
    method: 'get',
    url: url
  }).then(response => {
    console.log(response)
    store.state.list.banks = response.data
  }).catch(error => {
    console.log(error)
    // alert('error')
    store.dispatch('loginstate')
  })
}

export const getBranches = ({ commit }, data) => {
  // const url = 'https://bank.teraren.com/banks/' + data.bank_code + '/branches/search.json?'
  const url = 'https://bank.teraren.com/banks/' + data.bank_code + '/branches.json'
  axios({
    method: 'get',
    url: url
  }).then(response => {
    console.log(response)
    store.state.list.branches = response.data
  }).catch(error => {
    console.log(error)
    // alert('error')
    store.dispatch('loginstate')
  })
}

export const getBranchesSearch = ({ commit }, data) => {
  const url = 'https://bank.teraren.com/banks/' + data.bank_code + '/branches/search.json?name=' + data.branch_name
  axios({
    method: 'get',
    url: url
  }).then(response => {
    console.log(response)
    store.state.list.branches = response.data
  }).catch(error => {
    console.log(error)
    // alert('error')
    store.dispatch('loginstate')
  })
}

export const getDocuments = ({ commit }) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/documents/search?limit=' + settings.LIMIT,
    withCredentials: true
  }).then(response => {
    // console.log(response)
    store.state.list.documents = response.data.document
    store.state.max = response.data.max
  }).catch(error => {
    console.log(error)
    // alert('error')
    store.dispatch('loginstate')
  })
}

export const getDocument = ({ commit }, id) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/documents/' + id,
    withCredentials: true
  }).then(response => {
    // console.log(response)
    store.state.item.document = response.data
  }).catch(error => {
    console.log(error)
    // alert('error')
    store.dispatch('loginState')
  })
}

export const postDocument = ({ commit }, data) => {
  let document_id
  const params = {
    // 'category': data.document.category,
    // 'title': data.document.title,
    // 'note': data.document.note
    'category': 0,
    'title': '',
    'note': ''
  }
  axios({
    method: 'post',
    params: params,
    url: getAPIURL() + '/api/v1/documents/',
    withCredentials: true
  }).then(response => {
    console.log(response)
    document_id = response.data.id
    axios({
      method: 'get',
      url: getAPIURL() + '/api/v1/documents/search?limit=' + settings.LIMIT,
      withCredentials: true
    }).then(response => {
      console.log(response)
      store.state.list.documents = response.data.document
      axios({
        method: 'get',
        url: getAPIURL() + '/api/v1/documents/' + document_id,
        withCredentials: true
      }).then(response => {
        console.log(response)
        store.state.item.document = response.data
        data.this.$router.push({name: 'documentindex', params: { id: document_id }})
      }).catch(error => {
        console.log(error)
        alert('documentを登録できませんでした。')
        store.dispatch('loginState')
      })
    }).catch(error => {
      console.log(error)
      alert('documentを登録できませんでした。')
      store.dispatch('loginState')
    })
  }).catch(error => {
    console.log(error)
    alert('documentを登録できませんでした。')
    store.dispatch('loginState')
  })
}

export const deleteDocument = ({ commit }, data) => {
  console.log(data)
  if (window.confirm('documentを削除しますか？')) {
    axios({
      method: 'delete',
      url: getAPIURL() + '/api/v1/documents/' + data.document.id,
      withCredentials: true
    }).then(response => {
      console.log(response)
      axios({
        method: 'get',
        url: getAPIURL() + '/api/v1/documents/search?limit=' + settings.LIMIT,
        withCredentials: true
      }).then(response => {
        console.log(response)
        store.state.list.documents = response.data.document
        data.this.$router.push({name: 'documentsindex'})
        alert('documentを削除しました')
      }).catch(error => {
        console.log(error)
        alert('documentを削除できませんでした。')
        store.dispatch('loginState')
      })
    }).catch(error => {
      console.log(error)
      alert('documentを削除できませんでした。')
      store.dispatch('loginState')
    })
  } else {
    return
  }
}

export const patchDocument = ({ commit }, data) => {
  let document_id
  const params = {
    // multiselect
    // 'category': data.document.category.value,
    'category': data.document.category,
    'title': data.document.title,
    'note': data.document.note
  }
  console.log(params)
  axios({
    method: 'patch',
    params: params,
    url: getAPIURL() + '/api/v1/documents/' + data.document.id,
    withCredentials: true
  }).then(response => {
    console.log(response)
    document_id = response.data.id
    axios({
      method: 'get',
      url: getAPIURL() + '/api/v1/documents/search?limit=' + settings.LIMIT,
      withCredentials: true
    }).then(response => {
      console.log(response)
      store.state.list.documents = response.data.document
      data.this.$router.push({name: 'documentindex', params: { id: document_id }})
      data.edit.edit = !data.edit.edit
    }).catch(error => {
      console.log(error)
      alert('documentを更新できませんでした。')
      store.dispatch('loginState')
    })
  }).catch(error => {
    console.log(error)
    alert('documentを更新できませんでした。')
    store.dispatch('loginState')
  })
}

export const cancelDocument = ({ commit }, data) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/documents/' + store.state.item.document.id,
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.item.document = response.data
    data.edit_id.document_id = ''
    // alert('editキャンセルしました')
  })
}

export const getGeo = ({ commit }, data) => {
  // console.log(data)
  let url
  if (/^appointment/.test(data.this.$route.name)) {
    url = 'https://maps.googleapis.com/maps/api/geocode/json?address=' + data.pref[data.appointment.pref].name + data.appointment.address1 + '&key=AIzaSyCrtvovqd2wcsQ2kmd3RSjN9yJq1vun5eA'
  } else if (/^family/.test(data.this.$route.name)) {
    url = 'https://maps.googleapis.com/maps/api/geocode/json?address=' + data.pref[data.family.pref].name + data.family.address1 + '&key=AIzaSyCrtvovqd2wcsQ2kmd3RSjN9yJq1vun5eA'
  } else if (/^student/.test(data.this.$route.name)) {
    url = 'https://maps.googleapis.com/maps/api/geocode/json?address=' + data.pref[data.student.family.pref].name + data.student.family.address1 + '&key=AIzaSyCrtvovqd2wcsQ2kmd3RSjN9yJq1vun5eA'
  } else if (/^tutor/.test(data.this.$route.name)) {
    url = 'https://maps.googleapis.com/maps/api/geocode/json?address=' + data.pref[data.tutor.pref].name + data.tutor.address1 + '&key=AIzaSyCrtvovqd2wcsQ2kmd3RSjN9yJq1vun5eA'
  }
  axios({
    method: 'get',
    url: url
    // withCredentials: true
  }).then(response => {
    // console.log(response)
    if (response.data.results.length === 0) {
      if (/^appointment/.test(data.this.$route.name)) {
        // alert('Google Mapから住所を取得できませんでした。\n' + data.pref[data.appointment.pref].name + data.appointment.address1)
      } else if (/^family/.test(data.this.$route.name)) {
        // alert('Google Mapから住所を取得できませんでした。\n' + data.pref[data.family.pref].name + data.family.address1)
      } else if (/^student/.test(data.this.$route.name)) {
        // alert('Google Mapから住所を取得できませんでした。\n' + data.pref[data.student.pref].name + data.student.address1)
      } else if (/^tutor/.test(data.this.$route.name)) {
        // alert('Google Mapから住所を取得できませんでした。\n' + data.pref[data.tutor.pref].name + data.tutor.address1)
      }
    }
    const params = {
      'lat': response.data.results[0].geometry.location.lat,
      'lng': response.data.results[0].geometry.location.lng
    }
    // console.log(params)
    let url
    if (/^appointment/.test(data.this.$route.name)) {
      url = getAPIURL() + '/api/v1/appointments/' + data.appointment.id
    } else if (/^family/.test(data.this.$route.name)) {
      url = getAPIURL() + '/api/v1/families/' + data.family.id
    } else if (/^student/.test(data.this.$route.name)) {
      url = getAPIURL() + '/api/v1/students/' + data.student.id
    } else if (/^tutor/.test(data.this.$route.name)) {
      url = getAPIURL() + '/api/v1/tutors/' + data.tutor.id
    }
    axios({
      method: 'patch',
      params: params,
      url: url,
      withCredentials: true
    }).then(response => {
      // console.log(response)
      axios({
        method: 'get',
        url: url,
        withCredentials: true
      }).then(response => {
        // console.log(response)
        if (/^appointment/.test(data.this.$route.name)) {
          store.state.item.appointment = response.data
        } else if (/^family/.test(data.this.$route.name)) {
          store.state.item.family = response.data
        } else if (/^student/.test(data.this.$route.name)) {
          store.state.item.student = response.data
        } else if (/^tutor/.test(data.this.$route.name)) {
          store.state.item.tutor = response.data
        }
        // alert('ok')
      }).catch(error => {
        console.log(error)
        alert('error')
      })
    }).catch(error => {
      console.log(error)
      alert('error')
    })
  }).catch(error => {
    console.log(error)
    alert('error')
  })
}

export const getGeoRoot = ({ commit }, data) => {
  let url
  url = 'https://maps.googleapis.com/maps/api/geocode/json?address=' + data.pref[data.tutor.pref].name + data.tutor.address1 + '&key=AIzaSyCrtvovqd2wcsQ2kmd3RSjN9yJq1vun5eA'
  axios({
    method: 'get',
    url: url
    // withCredentials: true
  }).then(response => {
    console.log(response)
    if (response.data.results.length === 0) {
      // alert('Google Mapから住所を取得できませんでした。\n' + data.pref[data.tutor.pref].name + data.tutor.address1)
    }
    const params = {
      'lat': response.data.results[0].geometry.location.lat,
      'lng': response.data.results[0].geometry.location.lng
    }
    console.log(params)
    let url
    url = getAPIURL() + '/api/v1/tutors/' + data.tutor.id
    axios({
      method: 'patch',
      params: params,
      url: url,
      withCredentials: true
    }).then(response => {
      console.log(response)
      axios({
        method: 'get',
        url: url,
        withCredentials: true
      }).then(response => {
        store.state.item.tutor = response.data
        // alert('ok')

        let url
        url = 'https://maps.googleapis.com/maps/api/geocode/json?address=' + data.to + '&key=AIzaSyCrtvovqd2wcsQ2kmd3RSjN9yJq1vun5eA'
        axios({
          method: 'get',
          url: url
          // withCredentials: true
        }).then(response => {
          console.log(response)
          store.state.lat2 = response.data.results[0].geometry.location.lat
          store.state.lng2 = response.data.results[0].geometry.location.lng
        }).catch(error => {
          console.log(error)
          alert('error')
        })
      }).catch(error => {
        console.log(error)
        alert('error')
      })
    }).catch(error => {
      console.log(error)
      alert('error')
    })
  }).catch(error => {
    console.log(error)
    alert('error')
  })
}

export const getAggregateAppointment = ({ commit }) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/aggregate_appointments',
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.item.aggregate_appointment = response.data
    // alert('success')
  }).catch(error => {
    console.log(error)
    // alert('error')
  })
}

export const getAggregateContract = ({ commit }) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/aggregate_contracts',
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.item.aggregate_contract = response.data
    // alert('success')
  }).catch(error => {
    console.log(error)
    // alert('error')
  })
}

export const getAggregateAgreement = ({ commit }) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/aggregate_agreements',
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.item.aggregate_agreement = response.data
    // alert('success')
  }).catch(error => {
    console.log(error)
    // alert('error')
  })
}

export const getAggregateContractMonth = ({ commit }) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/aggregate_contracts_month',
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.item.aggregate_contract_month = response.data
    // alert('success')
  }).catch(error => {
    console.log(error)
    // alert('error')
  })
}

export const getAggregatePaymentdetail = ({ commit }) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/aggregate_paymentdetails',
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.item.aggregate_paymentdetail = response.data
    // alert('success')
  }).catch(error => {
    console.log(error)
    // alert('error')
  })
}

export const getAggregateTutorChannel = ({ commit }) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/aggregate_tutor_channels',
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.item.aggregate_tutor_channel = response.data
    // alert('success')
  }).catch(error => {
    console.log(error)
    // alert('error')
  })
}

export const getVersions = ({ commit }) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/versions/search?limit=' + settings.LIMIT,
    withCredentials: true
  }).then((response) => {
    console.log(response)
    store.state.list.versions = response.data.version
    store.state.max = response.data.max
  }).catch(error => {
    console.log(error)
    store.dispatch('loginState')
  })
}

// item_type と item_id で filter
export const getVersionsAgreement = ({ commit }, item_id) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/versions/search?item_type=Agreement&event=update&item_id=' + item_id,
    withCredentials: true
  }).then(res => {
    console.log(res)
    store.state.list.versionsAgreement = res.data.version
    store.state.max = res.data.max
  }).catch(error => {
    console.log(error)
    store.dispatch('loginState')
  })
}

export const getCompanies = ({ commit }) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/companies/search?',
    withCredentials: true
  }).then(response => {
    // console.log(response)
    store.state.list.companies = response.data.company
    store.state.max = response.data.max
  }).catch(error => {
    console.log(error)
    // alert('getに失敗しました')
    store.dispatch('loginState')
  })
}

export const getCompany = ({ commit }, id) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/companies/' + id,
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.item.company = response.data
  }).catch(error => {
    console.log(error)
    // alert('getUserに失敗しました')
    store.dispatch('loginState')
  })
}

export const getOffices = ({ commit }) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/offices/search?',
    withCredentials: true
  }).then(response => {
    // console.log(response)
    store.state.list.offices = response.data.office
    store.state.max = response.data.max
  }).catch(error => {
    console.log(error)
    // alert('getに失敗しました')
    store.dispatch('loginState')
  })
}

export const getOffice = ({ commit }, id) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/offices/' + id,
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.item.office = response.data
  }).catch(error => {
    console.log(error)
    // alert('getUserに失敗しました')
    store.dispatch('loginState')
  })
}

export const getUsers = ({ commit }) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/users/search?',
    withCredentials: true
  }).then(response => {
    // console.log(response)
    store.state.list.users = response.data.user
    store.state.max = response.data.max
  }).catch(error => {
    console.log(error)
    // alert('getに失敗しました')
    store.dispatch('loginState')
  })
}

export const getPrefs = ({ commit }) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/prefs/search?',
    withCredentials: true
  }).then(response => {
    // console.log(response)
    store.state.list.prefs = response.data.pref
  }).catch(error => {
    console.log(error)
    // alert('getに失敗しました')
    store.dispatch('loginState')
  })
}

export const getUsersSelect = ({ commit }) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/users/search?',
    withCredentials: true
  }).then(response => {
    // console.log(response)
    store.state.list.users = response.data.user
  }).catch(error => {
    console.log(error)
    // alert('getに失敗しました')
    store.dispatch('loginState')
  })
}

export const getUser = ({ commit }) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/user/',
    withCredentials: true
  }).then(response => {
    // console.log(response)
    store.state.item.user = response.data
  }).catch(error => {
    console.log(error)
    // alert('getUserに失敗しました')
    store.dispatch('loginState')
  })
}

export const postUser = ({ commit }, data) => {
  console.log(data)
  const params = {
    'user': data.user.user,
    'name': data.user.name,
    'email': data.user.email,
    'type': data.user.type,
    'office': data.user.office,
    'office_id': data.user.office_id,
    'hide_flag': data.list.hide_flag
  }
  console.log(params)
  axios({
    method: 'post',
    params: params,
    url: getAPIURL() + '/api/v1/users/',
    withCredentials: true
  }).then(response => {
    console.log(response)
    axios({
      method: 'get',
      url: getAPIURL() + '/api/v1/users/search?limit=' + settings.LIMIT,
      withCredentials: true
    }).then(response => {
      console.log(response)
      store.state.list.users = response.data.user
      data.this.$router.push({name: 'usersindex'})
      // alert('Userを登録しました')
    }).catch(error => {
      console.log(error)
      alert('Userを登録できませんでした。')
      store.dispatch('loginState')
    })
  }).catch(error => {
    console.log(error)
    alert('Userを登録できませんでした。')
    store.dispatch('loginState')
  })
}

export const patchUser = ({ commit }, data) => {
  const params = {
    'user': data.list.user,
    'name': data.list.name,
    'email': data.list.email,
    'type': data.user.type,
    'office': data.user.office,
    'office_id': data.user.office_id,
    'hide_flag': data.user.hide_flag
  }
  console.log(params)
  axios({
    method: 'patch',
    params: params,
    url: getAPIURL() + '/api/v1/users/' + data.list.id,
    withCredentials: true
  }).then(response => {
    console.log(response)
    axios({
      method: 'get',
      // url: getAPIURL() + '/api/v1/users/' + data.list.id,

      // usersindex
      // url: getAPIURL() + '/api/v1/users/' + data.list.id,
      url: getAPIURL() + '/api/v1/users/search?limit=' + settings.LIMIT,
      withCredentials: true
    }).then(response => {
      console.log(response)
      // store.state.item.user = response.data

      // usersindex
      // store.state.item.user = response.data
      store.state.list.users = response.data.user
      data.edit_id.edit_id = ''
      data.reset()
    }).catch(error => {
      console.log(error)
      alert('編集を保存できませんでした。')
      store.dispatch('loginState')
    })
  }).catch(error => {
    console.log(error)
    alert('編集を保存できませんでした。')
    store.dispatch('loginState')
  })
}

export const cancelUser = ({ commit }, data) => {
  axios({
    method: 'get',
    // url: getAPIURL() + '/api/v1/users/' + store.state.item.user.id,

    // usersindex
    // url: getAPIURL() + '/api/v1/users/' + data.list.id,
    url: getAPIURL() + '/api/v1/users/search?limit=' + settings.LIMIT,
    withCredentials: true
  }).then(response => {
    console.log(response)
    // store.state.item.user = response.data

    // usersindex
    // store.state.item.user = response.data
    store.state.list.users = response.data.user
    data.edit_id.edit_id = ''
    data.reset()
  }).catch(error => {
    console.log(error)
    // alert('get error')
    store.dispatch('loginState')
  })
}

export const deleteUser = ({ commit }, data) => {
  console.log(data)
  if (window.confirm('Userを削除しますか？')) {
    axios({
      method: 'delete',
      url: getAPIURL() + '/api/v1/users/' + data.list.id,
      withCredentials: true
    }).then(response => {
      console.log(response)
      axios({
        method: 'get',
        url: getAPIURL() + '/api/v1/users/search?limit=' + settings.LIMIT,
        withCredentials: true
      }).then(response => {
        console.log(response)
        store.state.list.users = response.data.user
        data.reset()
        // data.this.$router.push({name: 'usersindex'})
        alert('Userを削除しました')
      }).catch(error => {
        console.log(error)
        alert('Userを削除できませんでした。')
        store.dispatch('loginState')
      })
    }).catch(error => {
      console.log(error)
      alert('Userを削除できませんでした。')
      store.dispatch('loginState')
    })
  } else {
    return
  }
}

export const getAdvisors = ({ commit }) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/advisors/search?limit=' + settings.LIMIT,
    withCredentials: true
  }).then(response => {
    // console.log(response)
    store.state.list.advisors = response.data.advisor
    store.state.max = response.data.max
  }).catch(error => {
    console.log(error)
    // alert('getに失敗しました')
    store.dispatch('loginState')
  })
}

export const getAdvisorsSelect = ({ commit }) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/advisors/search?',
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.list.advisors = response.data.advisor
    store.state.max = response.data.max
  }).catch(error => {
    console.log(error)
    // alert('getに失敗しました')
    store.dispatch('loginState')
  })
}

export const getAdvisor = ({ commit }, id) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/advisors/' + id,
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.item.advisor = response.data
  }).catch(error => {
    console.log(error)
    // alert('getに失敗しました')
    store.dispatch('loginState')
  })
}

export const getFamilies = ({ commit }) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/families/search?limit=' + settings.LIMIT,
    withCredentials: true
  }).then(response => {
    // console.log(response)
    store.state.list.families = response.data.family
    store.state.max = response.data.max
  }).catch(error => {
    console.log(error)
    // alert('getFamilies失敗しました')
    store.dispatch('loginState')
  })
}

export const getFamiliesLimit0 = ({ commit }) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/families/search?limit=' + 0,
    withCredentials: true
  }).then(response => {
    // console.log(response)
    store.state.list.families = response.data.family
  }).catch(error => {
    console.log(error)
    // alert('getFamilies失敗しました')
    store.dispatch('loginState')
  })
}

export const getFamily = ({ commit }, id) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/families/' + id,
    withCredentials: true
  }).then(response => {
    // console.log(response)
    store.state.item.family = response.data
  }).catch(error => {
    console.log(error)
    // alert('getFamilyに失敗しました')
    store.dispatch('loginState')
  })
}

export const postFamily = ({ commit }, data) => {
  console.log(data)
  // let url = 'http://maps.googleapis.com/maps/api/geocode/json?address=' + data.family.geometry + data.family.address1
  // console.log(url)
  // function getGeo () {
  //   return axios({
  //     method: 'get',
  //     url: url
  //     // withCredentials: true
  //   })
  // }

  function addPOST (response) {
    // if (response.data.results.length === 0) {
    //   alert('Google Mapから住所を取得できませんでした。\n' + data.family.geometry + data.family.address1)
    // }
    let params = {
      // 'lat': response.data.results[0].geometry.location.lat,
      // 'lng': response.data.results[0].geometry.location.lng,
      'f_name': data.family.f_name,
      'l_name': data.family.l_name,
      'f_name_kana': data.family.f_name_kana,
      'l_name_kana': data.family.l_name_kana,
      'relationship': data.family.relationship,
      'zip': data.family.zip,
      'pref': data.family.pref,
      'address1': data.family.address1,
      'address2': data.family.address2,
      'tel1': data.family.tel1,
      'tel2': data.family.tel2,
      'fax': data.family.fax,
      'mail': data.family.mail,
      'mail2': data.family.mail2,
      'guidance_type': data.family.guidance_type,
      'structure': data.family.structure,
      'unit': data.family.unit,
      'workplace_contact': data.family.workplace_contact,
      'preferred_contact': data.family.preferred_contact,
      'contact_timezone': data.family.contact_timezone,
      'withdrawal_date': data.family.withdrawal_date,
      'note1': data.family.note1,
      'note2': data.family.note2
    }
    return axios({
      method: 'post',
      params: params,
      url: getAPIURL() + '/api/v1/families/',
      withCredentials: true
    })
  }
  let family_id
  function addPATCH (response) {
    console.log(response)
    let arr = []
    family_id = response.data.id
    for (let i = 0; i < data.appointment.length; i++) {
      console.log(i)
      let params = {
        'family_id': family_id,
        'medium1': data.appointment[i].medium1,
        'medium2': data.appointment[i].medium2,
        'medium3': data.appointment[i].medium3,
        'acquisition_date': data.appointment[i].acquisition_date,
        'visit_date': data.appointment[i].visit_date
      }
      console.log(params)
      arr.push(axios({
        method: 'patch',
        params: params,
        url: getAPIURL() + '/api/v1/appointments/' + data.appointment[i].id,
        withCredentials: true
      }))
    }
    console.log(arr)
    return Promise.all(arr)
  }

  function addPATCH2 (response) {
    console.log(response)
    let arr = []
    for (let i = 0; i < data.appointment.length; i++) {
      for (let j = 0; j < data.appointment[i].familysupports.length; j++) {
        console.log(j)
        const params = {
          'family_id': family_id
        }
        arr.push(axios({
          method: 'patch',
          params: params,
          url: getAPIURL() + '/api/v1/familysupports/' + data.appointment[i].familysupports[j].id,
          withCredentials: true
        }))
      }
    }
    return Promise.all(arr)
  }

  function addGET () {
    return axios({
      method: 'get',
      url: getAPIURL() + '/api/v1/appointments/search?limit=' + settings.LIMIT,
      withCredentials: true
    })
  }

  function stop (e) {
    console.log(e)
    throw e
  }

  function error (e) {
    console.log(e)
    alert('エラーです')
  }

  // if (window.confirm('この内容で登録してもよろしいですか？')) {
    // getGeo().catch(stop).then(addPOST).catch(stop).then(addPATCH).catch(stop).then(addPATCH2).catch(stop).then(addGET).catch(stop).then(response => {
  addPOST().catch(stop).then(addPATCH).catch(stop).then(addPATCH2).catch(stop).then(addGET).catch(stop).then(response => {
    store.state.list.appointments = response.data.appointment
    data.reset()
    // data.family.f_name = ''
    // data.family.l_name = ''
    // data.family.f_name_kana = ''
    // data.family.l_name_kana = ''
    // data.watchFamily.relationship = ''
    // data.family.zip = ''
    // data.watchFamily.pref = ''
    // data.family.address1 = ''
    // data.family.address2 = ''
    // data.family.tel1 = ''
    // data.family.tel2 = ''
    // data.family.fax = ''
    // data.family.mail = ''
    // data.family.mail2 = ''
    // data.watchFamily.guidance_type = 0
    // data.family.structure = ''
    // data.watchFamily.unit = 0
    // data.family.workplace_contact = ''
    // data.watchFamily.preferred_contact = 0
    // data.family.contact_timezone = ''
    // data.family.withdrawal_date = '0001/01/01'
    // data.family.note1 = ''
    // data.family.note2 = ''
    // alert('家庭情報を登録しました')
    data.this.$router.push({name: 'familyindex', params: { id: family_id }})
  }).catch(error)
  // } else {
  //   return
  // }
}

export const postFamilyModal = ({ commit }, data) => {
  console.log(data)
  // let url = 'http://maps.googleapis.com/maps/api/geocode/json?address=' + data.family.geometry + data.family.address1
  // console.log(url)
  // axios({
  //   method: 'get',
  //   url: url
  //   // withCredentials: true
  // })
  // .then(response => {
  //   if (response.data.results.length === 0) {
  //     alert('Google Mapから住所を取得できませんでした。\n' + data.family.geometry + data.family.address1)
  //   }
  const params = {
    'f_name': data.family.f_name,
    'l_name': data.family.l_name,
    'f_name_kana': data.family.f_name_kana,
    'l_name_kana': data.family.l_name_kana,
    'relationship': data.family.relationship,
    'pref': data.family.pref,
    'zip': data.family.zip,
    'address1': data.family.address1,
    'address2': data.family.address2,
    // 'lat': response.data.results[0].geometry.location.lat,
    // 'lng': response.data.results[0].geometry.location.lng,
    'tel1': data.family.tel1,
    'tel2': data.family.tel2,
    'fax': data.family.fax,
    'mail': data.family.mail,
    'mail2': data.family.mail2,
    'guidance_type': data.family.guidance_type,
    'structure': data.family.structure,
    'unit': data.family.unit,
    'workplace_contact': data.family.workplace_contact,
    'preferred_contact': data.family.preferred_contact,
    'contact_timezone': data.family.contact_timezone,
    'withdrawal_date': data.family.withdrawal_date,
    'note1': data.family.note1,
    'note2': data.family.note2
  }
  axios({
    method: 'post',
    params: params,
    url: getAPIURL() + '/api/v1/families/',
    withCredentials: true
  }).then(response => {
    console.log(response)
    console.log(response.data.id)
    const params = {
      'family_id': response.data.id,
      'medium1': data.appointment.medium1, // validates
      'medium2': data.appointment.medium2, // validates
      'medium3': data.appointment.medium3, // validates
      'acquisition_date': data.appointment.acquisition_date, // validates
      'visit_date': data.appointment.visit_date // validates
    }
    axios({
      method: 'patch',
      params: params,
      url: getAPIURL() + '/api/v1/appointments/' + data.appointment.id,
      withCredentials: true
    }).then(response => {
      console.log(response)
      axios({
        method: 'get',
        url: getAPIURL() + '/api/v1/appointments/' + data.appointment.id,
        withCredentials: true
      }).then(response => {
        store.state.item.appointment = response.data
        data.condition.condition = !data.condition.condition
        data.family.f_name = ''
        data.family.l_name = ''
        data.family.f_name_kana = ''
        data.family.l_name_kana = ''
        data.family.relationship = ''
        data.family.pref = ''
        data.family.zip = ''
        data.family.address1 = ''
        data.family.address2 = ''
        data.family.tel1 = ''
        data.family.tel2 = ''
        data.family.fax = ''
        data.family.mail = ''
        data.family.mail2 = ''
        data.family.guidance_type = ''
        data.family.structure = ''
        data.family.unit = ''
        data.family.workplace_contact = ''
        data.family.preferred_contact = ''
        data.family.contact_timezone = ''
        data.family.withdrawal_date = ''
        data.family.note1 = ''
        data.family.note2 = ''
        // alert('家庭情報を登録しました。')
      }).catch(error => {
        console.log(error)
        alert('家庭情報を登録できませんでした。')
        store.dispatch('loginState')
      })
    }).catch(error => {
      console.log(error)
      alert('家庭情報を登録できませんでした。')
      store.dispatch('loginState')
    })
  }).catch(error => {
    console.log(error)
    alert('家庭情報を登録できませんでした。')
    store.dispatch('loginState')
  })
  // }).catch(error => {
  //   console.log(error)
  //   alert('家庭情報を登録できませんでした。')
  //   store.dispatch('loginState')
  // })
}

export const patchFamily = ({ commit }, data) => {
  // let url = 'http://maps.googleapis.com/maps/api/geocode/json?address=' + data.geometry + data.family.address1
  // console.log(url)
  // axios({
  //   method: 'get',
  //   url: url
  //   // withCredentials: true
  // }).then(response => {
  //   if (response.data.results.length === 0) {
  //     alert('Google Mapから住所を取得できませんでした。\n' + data.geometry + data.family.address1)
  //   }
  const params = {
    'company_id': data.family.company_id,
    'office_id': data.family.office_id,
    'f_name': data.family.f_name,
    'l_name': data.family.l_name,
    'f_name_kana': data.family.f_name_kana,
    'l_name_kana': data.family.l_name_kana,
    'relationship': data.family.relationship,
    'zip': data.family.zip,
    'pref': data.family.pref,
    'address1': data.family.address1,
    'address2': data.family.address2,
    // 'lat': response.data.results[0].geometry.location.lat,
    // 'lng': response.data.results[0].geometry.location.lng,
    'tel1': data.family.tel1,
    'tel2': data.family.tel2,
    'fax': data.family.fax,
    'mail': data.family.mail,
    'mail2': data.family.mail2,
    'guidance_type': data.family.guidance_type,
    'structure': data.family.structure,
    'unit': data.family.unit,
    'workplace_contact': data.family.workplace_contact,
    'preferred_contact': data.family.preferred_contact,
    'contact_timezone': data.family.contact_timezone,
    'withdrawal_date': data.family.withdrawal_date,
    'note1': data.family.note1,
    'note2': data.family.note2
  }
  axios({
    method: 'patch',
    params: params,
    url: getAPIURL() + '/api/v1/families/' + data.family.id,
    withCredentials: true
  }).then(response => {
    console.log(response)
    axios({
      method: 'get',
      url: getAPIURL() + '/api/v1/families/' + data.family.id,
      withCredentials: true
    }).then(response => {
      console.log(response)
      store.state.item.family = response.data
      data.edit_id.family_id = ''
    }).catch(error => {
      console.log(error)
      alert('編集を保存できませんでした。')
      store.dispatch('loginState')
    })
  }).catch(error => {
    console.log(error)
    alert('編集を保存できませんでした。')
    store.dispatch('loginState')
  })
  // }).catch(error => {
  //   console.log(error)
  //   alert('編集を保存できませんでした。')
  //   store.dispatch('loginState')
  // })
}

export const cancelFamily = ({ commit }, data) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/families/' + store.state.item.family.id,
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.item.family = response.data
    data.edit_id.family_id = ''
    // alert('editキャンセルしました')
  })
}

export const deleteFamily = ({ commit }, data) => {
  console.log(data)
  if (window.confirm('家庭情報を削除しますか？')) {
    axios({
      method: 'delete',
      url: getAPIURL() + '/api/v1/families/' + data.family.id,
      withCredentials: true
    }).then(response => {
      console.log(response)
      axios({
        method: 'get',
        url: getAPIURL() + '/api/v1/families/search?limit=' + settings.LIMIT,
        withCredentials: true
      }).then(response => {
        console.log(response)
        store.state.list.families = response.data.family
        data.this.$router.push({name: 'familiesindex'})
        alert('家庭情報を削除しました')
      }).catch(error => {
        console.log(error)
        alert('家庭情報を削除できませんでした。')
        store.dispatch('loginState')
      })
    }).catch(error => {
      console.log(error)
      alert('家庭情報を削除できませんでした。')
      store.dispatch('loginState')
    })
  } else {
    return
  }
}

export const deleteFamilyStudent = ({ commit }, data) => {
  if (window.confirm('本当に削除しますか？(生徒のデータが削除されます。)')) {
    console.log(data)
    axios({
      method: 'delete',
      url: getAPIURL() + '/api/v1/students/' + data.id,
      withCredentials: true
    }).then(response => {
      console.log(response)
      axios({
        method: 'get',
        url: getAPIURL() + '/api/v1/families/' + store.state.item.family.id,
        withCredentials: true
      }).then(response => {
        console.log(response)
        store.state.item.family = response.data
        alert('生徒情報を削除しました。')
      }).catch(error => {
        console.log(error)
        alert('生徒情報を削除できませんでした。')
        store.dispatch('loginState')
      })
    }).catch(error => {
      console.log(error)
      alert('生徒情報を削除できませんでした。')
      store.dispatch('loginState')
    })
  } else {
    return
  }
}

export const getFamilysupports = ({ commit }) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/familysupports/search?limit=' + settings.LIMIT,
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.list.familysupports = response.data.familysupport
  }).catch(error => {
    console.log(error)
    // alert('getFamilysupportsに失敗しました')
    store.dispatch('loginState')
  })
}

export const getAppointmentsupports = ({ commit }) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/familysupports/search2?limit=' + settings.LIMIT,
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.list.familysupports = response.data.appointmentsupport
  }).catch(error => {
    console.log(error)
    // alert('getAppointmentsupportsに失敗しました')
    store.dispatch('loginState')
  })
}

export const getFamilyfiles = ({ commit }) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/familyfiles/search?limit=' + settings.LIMIT,
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.list.familyfiles = response.data.familyfile
  }).catch(error => {
    console.log(error)
    // alert('getFamilyfilesに失敗しました')
    store.dispatch('loginState')
  })
}

export const getFamilyfile = ({ commit }, data) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/familyfiles/' + data.id,
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.item.familyfile = response.data.familyfile
  }).catch(error => {
    console.log(error)
    // alert('getFamilyfileに失敗しました')
    store.dispatch('loginState')
  })
}

export const postSupport = ({ commit }, data) => {
  console.log(data)
  console.log(data.this.$route)
  let url
  if (/appointmentindex/.test(data.this.$route.name)) {
    url = getAPIURL() + '/api/v1/familysupports/'
  } else if (/appointmenthistory/.test(data.this.$route.name)) {
    url = getAPIURL() + '/api/v1/familysupports/'
  } else if (/agreementindex/.test(data.this.$route.name)) {
    url = getAPIURL() + '/api/v1/agreementsupports/'
  } else if (/agreementhistory/.test(data.this.$route.name)) {
    url = getAPIURL() + '/api/v1/agreementsupports/'
  } else if (/tutorindex/.test(data.this.$route.name)) {
    url = getAPIURL() + '/api/v1/tutorsupports/'
  } else if (/tutorhistory/.test(data.this.$route.name)) {
    url = getAPIURL() + '/api/v1/tutorsupports/'
  } else if (/familyindex/.test(data.this.$route.name)) {
    url = getAPIURL() + '/api/v1/familysupports/'
  } else if (/familyhistory/.test(data.this.$route.name)) {
    url = getAPIURL() + '/api/v1/familysupports/'
  } else if (/studentindex/.test(data.this.$route.name)) {
    url = getAPIURL() + '/api/v1/familysupports/'
  } else if (/studenthistory/.test(data.this.$route.name)) {
    url = getAPIURL() + '/api/v1/familysupports/'
  }
  let params
  if (/appointmentindex/.test(data.this.$route.name)) {
    params = {
      'user_id': store.state.item.user.id,
      'appointment_id': store.state.item.appointment.id,
      'support_date': moment(data.support.support_date).format(),
      'note': data.support.note
    }
  } else if (/appointmenthistory/.test(data.this.$route.name)) {
    params = {
      'user_id': store.state.item.user.id,
      'appointment_id': store.state.item.appointment.id,
      'support_date': moment(data.support.support_date).format(),
      'note': data.support.note
    }
  } else if (/agreementindex/.test(data.this.$route.name)) {
    params = {
      'user_id': store.state.item.user.id,
      'agreement_id': store.state.item.agreement.id,
      'support_date': moment(data.support.support_date).format(),
      'note': data.support.note
    }
  } else if (/agreementhistory/.test(data.this.$route.name)) {
    params = {
      'user_id': store.state.item.user.id,
      'agreement_id': store.state.item.agreement.id,
      'support_date': moment(data.support.support_date).format(),
      'note': data.support.note
    }
  } else if (/tutorindex/.test(data.this.$route.name)) {
    params = {
      'user_id': store.state.item.user.id,
      'tutor_id': store.state.item.tutor.id,
      'support_date': moment(data.support.support_date).format(),
      'note': data.support.note // note うまく渡ってない
    }
  } else if (/tutorhistory/.test(data.this.$route.name)) {
    params = {
      'user_id': store.state.item.user.id,
      'tutor_id': store.state.item.tutor.id,
      'support_date': moment(data.support.support_date).format(),
      'note': data.support.note // note うまく渡ってない
    }
  } else if (/familyindex/.test(data.this.$route.name)) {
    params = {
      'user_id': store.state.item.user.id,
      'family_id': store.state.item.family.id,
      'support_date': moment(data.support.support_date).format(),
      'note': data.support.note
    }
  } else if (/familyhistory/.test(data.this.$route.name)) {
    params = {
      'user_id': store.state.item.user.id,
      'family_id': store.state.item.family.id,
      'support_date': moment(data.support.support_date).format(),
      'note': data.support.note
    }
  } else if (/studentindex/.test(data.this.$route.name)) {
    params = {
      'user_id': store.state.item.user.id,
      'family_id': store.state.item.student.family.id,
      'support_date': moment(data.support.support_date).format(),
      'note': data.support.note
    }
  } else if (/studenthistory/.test(data.this.$route.name)) {
    params = {
      'user_id': store.state.item.user.id,
      'family_id': store.state.item.student.family.id,
      'support_date': moment(data.support.support_date).format(),
      'note': data.support.note
    }
  }
  console.log(params)
  axios({
    method: 'post',
    params: params,
    url: url,
    withCredentials: true
  }).then(response => {
    console.log(response)
    let url
    if (/appointmentindex/.test(data.this.$route.name)) {
      url = getAPIURL() + '/api/v1/appointments/' + store.state.item.appointment.id
    } else if (/appointmenthistory/.test(data.this.$route.name)) {
      url = getAPIURL() + '/api/v1/appointments/' + store.state.item.appointment.id
    } else if (/agreementindex/.test(data.this.$route.name)) {
      url = getAPIURL() + '/api/v1/agreements/' + store.state.item.agreement.id
    } else if (/agreementhistory/.test(data.this.$route.name)) {
      url = getAPIURL() + '/api/v1/agreements/' + store.state.item.agreement.id
    } else if (/tutorindex/.test(data.this.$route.name)) {
      url = getAPIURL() + '/api/v1/tutors/' + store.state.item.tutor.id
    } else if (/tutorhistory/.test(data.this.$route.name)) {
      url = getAPIURL() + '/api/v1/tutors/' + store.state.item.tutor.id
    } else if (/familyindex/.test(data.this.$route.name)) {
      url = getAPIURL() + '/api/v1/families/' + store.state.item.family.id
    } else if (/familyhistory/.test(data.this.$route.name)) {
      url = getAPIURL() + '/api/v1/families/' + store.state.item.family.id
    } else if (/studentindex/.test(data.this.$route.name)) {
      url = getAPIURL() + '/api/v1/students/' + store.state.item.student.id
    } else if (/studenthistory/.test(data.this.$route.name)) {
      url = getAPIURL() + '/api/v1/students/' + store.state.item.student.id
    }
    axios({
      method: 'get',
      url: url,
      withCredentials: true
    }).then(response => {
      if (/appointmentindex/.test(data.this.$route.name)) {
        store.state.item.appointment = response.data
      } else if (/appointmenthistory/.test(data.this.$route.name)) {
        store.state.item.appointment = response.data
      } else if (/agreementindex/.test(data.this.$route.name)) {
        store.state.item.agreement = response.data
      } else if (/agreementhistory/.test(data.this.$route.name)) {
        store.state.item.agreement = response.data
      } else if (/tutorindex/.test(data.this.$route.name)) {
        store.state.item.tutor = response.data
      } else if (/tutorhistory/.test(data.this.$route.name)) {
        store.state.item.tutor = response.data
      } else if (/familyindex/.test(data.this.$route.name)) {
        store.state.item.family = response.data
      } else if (/familyhistory/.test(data.this.$route.name)) {
        store.state.item.family = response.data
      } else if (/studentindex/.test(data.this.$route.name)) {
        store.state.item.student = response.data
      } else if (/studenthistory/.test(data.this.$route.name)) {
        store.state.item.student = response.data
      }
      data.support.note = ''
      data.condition.condition = !data.condition.condition
      // alert('対応履歴を登録しました')
    }).catch(error => {
      console.log(error)
      alert('対応履歴を登録できませんでした。')
      store.dispatch('loginState')
    })
  }).catch(error => {
    console.log(error)
    alert('対応履歴を登録できませんでした。')
    store.dispatch('loginState')
  })
}

export const patchAppointmentsupport = ({ commit }, data) => {
  const params = {
    // 'user_id': store.state.item.user.id,
    'appointment_id': store.state.item.appointment.id,
    'support_date': moment(data.patch.support_date).format(),
    'note': data.list.note
  }
  axios({
    method: 'patch',
    params: params,
    url: getAPIURL() + '/api/v1/familysupports/' + data.list.id,
    withCredentials: true
  }).then(response => {
    console.log(response)
    axios({
      method: 'get',
      url: getAPIURL() + '/api/v1/appointments/' + store.state.item.appointment.id,
      withCredentials: true
    }).then(response => {
      console.log(response)
      store.state.item.appointment = response.data
      data.edit_id.list_id = ''
      // alert('対応履歴を更新しました')
    }).catch(error => {
      console.log(error)
      alert('対応履歴を更新できませんでした。')
      store.dispatch('loginState')
    })
  }).catch(error => {
    console.log(error)
    alert('対応履歴を更新できませんでした。')
    store.dispatch('loginState')
  })
}

export const patchFamilysupport = ({ commit }, data) => {
  const params = {
    // 'user_id': store.state.item.user.id,
    'family_id': store.state.item.family.id,
    'support_date': moment(data.patch.support_date).format(),
    'note': data.list.note
  }
  axios({
    method: 'patch',
    params: params,
    url: getAPIURL() + '/api/v1/familysupports/' + data.list.id,
    withCredentials: true
  }).then(response => {
    console.log(response)
    axios({
      method: 'get',
      url: getAPIURL() + '/api/v1/families/' + store.state.item.family.id,
      withCredentials: true
    }).then(response => {
      console.log(response)
      store.state.item.family = response.data
      data.edit_id.list_id = ''
      // alert('対応履歴を更新しました')
    }).catch(error => {
      console.log(error)
      alert('対応履歴を更新できませんでした。')
      store.dispatch('loginState')
    })
  }).catch(error => {
    console.log(error)
    alert('対応履歴を更新できませんでした。')
    store.dispatch('loginState')
  })
}

export const patchAgreementsupport = ({ commit }, data) => {
  const params = {
    // 'user_id': store.state.item.user.id,
    'agreement_id': store.state.item.agreement.id,
    'support_date': moment(data.patch.support_date).format(),
    'note': data.list.note
  }
  axios({
    method: 'patch',
    params: params,
    url: getAPIURL() + '/api/v1/agreementsupports/' + data.list.id,
    withCredentials: true
  }).then(response => {
    console.log(response)
    axios({
      method: 'get',
      url: getAPIURL() + '/api/v1/agreements/' + store.state.item.agreement.id,
      withCredentials: true
    }).then(response => {
      console.log(response)
      store.state.item.agreement = response.data
      data.edit_id.list_id = ''
      // alert('対応履歴を更新しました')
    }).catch(error => {
      console.log(error)
      alert('対応履歴を更新できませんでした。')
      store.dispatch('loginState')
    })
  }).catch(error => {
    console.log(error)
    alert('対応履歴を更新できませんでした。')
    store.dispatch('loginState')
  })
}

export const deleteAppointmentsupport = ({ commit }, list) => {
  if (window.confirm('本当に削除しますか？')) {
    axios({
      method: 'delete',
      url: getAPIURL() + '/api/v1/familysupports/' + list.id,
      withCredentials: true
    }).then(response => {
      console.log(response)
      axios({
        method: 'get',
        url: getAPIURL() + '/api/v1/appointments/' + store.state.item.appointment.id,
        withCredentials: true
      }).then(response => {
        console.log(response)
        store.state.item.appointment = response.data
        alert('対応履歴を削除しました')
      }).catch(error => {
        console.log(error)
        alert('対応履歴を削除できませんでした。')
        store.dispatch('loginstate')
      })
    }).catch(error => {
      console.log(error)
      alert('対応履歴を削除できませんでした。')
      store.dispatch('loginstate')
    })
  } else {
    return
  }
}

export const deleteFamilysupport = ({ commit }, list) => {
  if (window.confirm('本当に削除しますか？')) {
    axios({
      method: 'delete',
      url: getAPIURL() + '/api/v1/familysupports/' + list.id,
      withCredentials: true
    }).then(response => {
      console.log(response)
      axios({
        method: 'get',
        url: getAPIURL() + '/api/v1/families/' + store.state.item.family.id,
        withCredentials: true
      }).then(response => {
        console.log(response)
        store.state.item.family = response.data
        alert('対応履歴を削除しました')
      }).catch(error => {
        console.log(error)
        alert('対応履歴を削除できませんでした。')
        store.dispatch('loginstate')
      })
    }).catch(error => {
      console.log(error)
      alert('対応履歴を削除できませんでした。')
      store.dispatch('loginstate')
    })
  } else {
    return
  }
}

export const deleteAgreementsupport = ({ commit }, list) => {
  if (window.confirm('本当に削除しますか？')) {
    axios({
      method: 'delete',
      url: getAPIURL() + '/api/v1/agreementsupports/' + list.id,
      withCredentials: true
    }).then(response => {
      console.log(response)
      axios({
        method: 'get',
        url: getAPIURL() + '/api/v1/agreements/' + store.state.item.agreement.id,
        withCredentials: true
      }).then(response => {
        console.log(response)
        store.state.item.agreement = response.data
        alert('対応履歴を削除しました')
      }).catch(error => {
        console.log(error)
        alert('対応履歴を削除できませんでした。')
        store.dispatch('loginstate')
      })
    }).catch(error => {
      console.log(error)
      alert('対応履歴を削除できませんでした。')
      store.dispatch('loginstate')
    })
  } else {
    return
  }
}

export const cancelAppointmentsupport = ({ commit }, data) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/appointments/' + store.state.item.appointment.id,
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.item.appointment = response.data
    data.edit_id.list_id = ''
    // alert('editキャンセルしました')
  })
}

export const cancelFamilysupport = ({ commit }, data) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/families/' + store.state.item.family.id,
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.item.family = response.data
    data.edit_id.list_id = ''
    // alert('editキャンセルしました')
  })
}

export const cancelAgreementsupport = ({ commit }, data) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/agreements/' + store.state.item.agreement.id,
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.item.agreement = response.data
    data.edit_id.list_id = ''
    // alert('editキャンセルしました')
  })
}

export const postFamilyfile = ({ commit }, data) => {
  console.log(data)
  console.log(data.this.$route.name)
  // if (window.confirm('ファイルをアップロードしますか？')) {
  let params = new FormData()
  if (/familyfileview/.test(data.this.$route.name)) {
    // FamilyfileView
    params.append('family_id', store.state.item.family.id)
    params.append('file_name', data.familyfile.file_name)
    params.append('file', data.familyfile.file)
  } else if (/familyfilesindex/.test(data.this.$route.name)) {
    // FamilyfilesIndex
    params.append('family_id', data.familyfile.family_id)
    params.append('file_name', data.familyfile.file_name)
    params.append('file', data.familyfile.file)
  }
  console.log(data)
  let config = {
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    withCredentials: true
  }
  let url = getAPIURL() + '/api/v1/familyfiles'
  axios.post(url, params, config).then(response => {
    console.log(response)
    if (/familyfileview/.test(data.this.$route.name)) {
      // FamilyfileView
      url = getAPIURL() + '/api/v1/families/' + store.state.item.family.id
    } else if (/familyfilesindex/.test(data.this.$route.name)) {
      // FamilyfilesIndex
      url = getAPIURL() + '/api/v1/familyfiles/search?limit=' + settings.LIMIT
    }
    axios({
      method: 'get',
      url: url,
      withCredentials: true
    }).then(response => {
      if (/familyfileview/.test(data.this.$route.name)) {
        // FamilyfileView
        store.state.item.family = response.data
      } else if (/familyfilesindex/.test(data.this.$route.name)) {
        // FamilyfilesIndex
        store.state.list.familyfiles = response.data.familyfile
      }
      data.familyfile.family_id = ''
      data.familyfile.user_id = ''
      data.familyfile.file_name = ''
      document.getElementById('file').value = ''
      // alert('ファイルをアップロードしました。')
    }).catch(error => {
      console.log(error)
      alert('ファイルをアップロードできませんでした。')
      store.dispatch('loginState')
    })
  }).catch(error => {
    console.log(error)
    alert('ファイルをアップロードできませんでした。')
    store.dispatch('loginState')
  })
  // } else {
  //   return
  // }
}

export const deleteFamilyfile = ({ commit }, data) => {
  if (window.confirm('ファイルを削除しますか？')) {
    axios({
      method: 'delete',
      url: getAPIURL() + '/api/v1/familyfiles/' + data.list.id,
      withCredentials: true
    }).then(response => {
      console.log(response)
      let url
      if (/familyfileview/.test(data.this.$route.name)) {
        url = getAPIURL() + '/api/v1/families/' + data.list.family_id
      } else if (/familyfilesindex/.test(data.this.$route.name)) {
        url = getAPIURL() + '/api/v1/familyfiles/search?limit=' + settings.LIMIT
      }
      axios({
        method: 'get',
        url: url,
        withCredentials: true
      }).then(response => {
        console.log(response)
        if (/familyfileview/.test(data.this.$route.name)) {
          // FamilyfileView
          store.state.item.family = response.data
        } else if (/familyfilesindex/.test(data.this.$route.name)) {
          // FamilyfilesIndex
          store.state.list.familyfiles = response.data.familyfile
        }
        alert('ファイルが削除されました')
      }).catch(error => {
        console.log(error)
        alert('ファイルを削除できませんでした。')
        store.dispatch('loginState')
      })
    }).catch(error => {
      console.log(error)
      alert('ファイルを削除できませんでした。')
      store.dispatch('loginState')
    })
  } else {
    return
  }
}

export const cancelFamilyfile = ({ commit }, data) => {
  let url
  if (/familyfileview/.test(data.this.$route.name)) {
    // FamilyfileView
    url = getAPIURL() + '/api/v1/families/' + data.list.family_id
  } else if (/familyfilesindex/.test(data.this.$route.name)) {
    // FamilyfilesIndex
    url = getAPIURL() + '/api/v1/familyfiles/search?limit=' + settings.LIMIT
  }
  axios({
    method: 'get',
    url: url,
    withCredentials: true
  }).then(response => {
    console.log(response)
    if (/familyfileview/.test(data.this.$route.name)) {
      // FamilyfileView
      store.state.item.family = response.data
    } else if (/familyfilesindex/.test(data.this.$route.name)) {
      // FamilyfilesIndex
      store.state.list.familyfiles = response.data.familyfile
    }
    data.edit_id.edit_id = ''
  }).catch(error => {
    console.log(error)
    // alert('get失敗しました')
    store.dispatch('loginState')
  })
}

export const patchFamilyfile = ({ commit }, data) => {
  console.log(data)
  // if (window.confirm('本当に更新しますか？')) {
  let params = new FormData()
  if (/familyfileview/.test(data.this.$route.name)) {
    // FamilyfileView
    params.append('file_name', data.familyfile.file_name)
    params.append('file', data.familyfile.file)
  } else if (/familyfilesindex/.test(data.this.$route.name)) {
    // FamilyfilesIndex
    params.append('file_name', data.familyfile.file_name)
    params.append('file', data.familyfile.file)
  }
  console.log(data)
  let config = {
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    withCredentials: true
  }
  let url = getAPIURL() + '/api/v1/familyfiles/' + data.list.id
  axios.patch(url, params, config).then(response => {
    console.log(response)
    if (/familyfileview/.test(data.this.$route.name)) {
      // FamilyfileView
      url = getAPIURL() + '/api/v1/families/' + store.state.item.family.id
    } else if (/familyfilesindex/.test(data.this.$route.name)) {
      // FamilyfilesIndex
      url = getAPIURL() + '/api/v1/familyfiles/search?limit=' + settings.LIMIT
    }
    axios({
      method: 'get',
      url: url,
      withCredentials: true
    }).then(response => {
      if (/familyfileview/.test(data.this.$route.name)) {
        // FamilyfileView
        store.state.item.family = response.data
      } else if (/familyfilesindex/.test(data.this.$route.name)) {
        // FamilyfilesIndex
        store.state.list.familyfiles = response.data.familyfile
      }
      data.edit_id.edit_id = ''
      // alert('ファイルを更新しました')
    }).catch(error => {
      console.log(error)
      alert('ファイルを更新できませんでした。')
      store.dispatch('loginState')
    })
  }).catch(error => {
    console.log(error)
    alert('ファイルを更新できませんでした。')
    store.dispatch('loginState')
  })
  // } else {
  //   return
  // }
}

export const postStudentfile = ({ commit }, data) => {
  console.log(data)
  console.log(data.this.$route.name)
  // if (window.confirm('ファイルをアップロードしますか？')) {
  let params = new FormData()
  if (/studentfileview/.test(data.this.$route.name)) {
    // StudentfileView
    params.append('student_id', store.state.item.student.id)
    params.append('month', data.studentfile.month)
    params.append('state', data.studentfile.state)
    params.append('filing_date', data.studentfile.filing_date)
    params.append('note', data.studentfile.note)
    params.append('file_name', data.studentfile.file_name)
    params.append('points_english', data.studentfile.points_english)
    params.append('points_mathematics', data.studentfile.points_mathematics)
    params.append('points_japanese', data.studentfile.points_japanese)
    params.append('points_science', data.studentfile.points_science)
    params.append('points_socialstudies', data.studentfile.points_socialstudies)
    params.append('file', data.studentfile.file)
  } else if (/studentfilesindex/.test(data.this.$route.name)) {
    // StudentfilesIndex
    params.append('student_id', data.studentfile.student_id)
    params.append('month', data.studentfile.month)
    params.append('state', data.studentfile.state)
    params.append('filing_date', data.studentfile.filing_date)
    params.append('note', data.studentfile.note)
    params.append('file_name', data.studentfile.file_name)
    params.append('points_english', data.studentfile.points_english)
    params.append('points_mathematics', data.studentfile.points_mathematics)
    params.append('points_japanese', data.studentfile.points_japanese)
    params.append('points_science', data.studentfile.points_science)
    params.append('points_socialstudies', data.studentfile.points_socialstudies)
    params.append('file', data.studentfile.file)
  }
  console.log(data)
  let config = {
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    withCredentials: true
  }
  let url = getAPIURL() + '/api/v1/studentfiles'
  axios.post(url, params, config).then(response => {
    console.log(response)
    if (/studentfileview/.test(data.this.$route.name)) {
      // StudentfileView
      url = getAPIURL() + '/api/v1/students/' + store.state.item.student.id
    } else if (/studentfilesindex/.test(data.this.$route.name)) {
      // StudentfilesIndex
      url = getAPIURL() + '/api/v1/studentfiles/search?limit=' + settings.LIMIT
    }
    axios({
      method: 'get',
      url: url,
      withCredentials: true
    }).then(response => {
      if (/studentfileview/.test(data.this.$route.name)) {
        // StudentfileView
        store.state.item.student = response.data
      } else if (/studentfilesindex/.test(data.this.$route.name)) {
        // StudentfilesIndex
        store.state.list.studentfiles = response.data.studentfile
      }
      data.studentfile.student_id = ''
      // data.studentfile.month = ''
      // data.studentfile.state = ''
      // data.studentfile.filing_date = ''
      data.studentfile.note = ''
      data.studentfile.user_id = ''
      // data.studentfile.file_name = ''
      data.studentfile.points_english = ''
      data.studentfile.points_mathematics = ''
      data.studentfile.points_japanese = ''
      data.studentfile.points_science = ''
      data.studentfile.points_socialstudies = ''
      document.getElementById('file').value = ''
      // alert('ファイルをアップロードしました。')
    }).catch(error => {
      console.log(error)
      alert('ファイルをアップロードできませんでした。')
      store.dispatch('loginState')
    })
  }).catch(error => {
    console.log(error)
    alert('ファイルをアップロードできませんでした。')
    store.dispatch('loginState')
  })
  // } else {
  //   return
  // }
}

export const deleteStudentfile = ({ commit }, data) => {
  if (window.confirm('ファイルを削除しますか？')) {
    axios({
      method: 'delete',
      url: getAPIURL() + '/api/v1/studentfiles/' + data.list.id,
      withCredentials: true
    }).then(response => {
      console.log(response)
      let url
      if (/studentfileview/.test(data.this.$route.name)) {
        url = getAPIURL() + '/api/v1/students/' + data.list.student_id
      } else if (/studentfilesindex/.test(data.this.$route.name)) {
        url = getAPIURL() + '/api/v1/studentfiles/search?limit=' + settings.LIMIT
      }
      axios({
        method: 'get',
        url: url,
        withCredentials: true
      }).then(response => {
        console.log(response)
        if (/studentfileview/.test(data.this.$route.name)) {
          // StudentfileView
          store.state.item.student = response.data
        } else if (/studentfilesindex/.test(data.this.$route.name)) {
          // StudentfilesIndex
          store.state.list.studentfiles = response.data.studentfile
        }
        alert('ファイルを削除しました。')
      }).catch(error => {
        console.log(error)
        alert('ファイルを削除できませんでした。')
        store.dispatch('loginState')
      })
    }).catch(error => {
      console.log(error)
      alert('ファイルを削除できませんでした。')
      store.dispatch('loginState')
    })
  } else {
    return
  }
}

export const cancelStudentfile = ({ commit }, data) => {
  let url
  if (/studentfileview/.test(data.this.$route.name)) {
    // StudentfileView
    url = getAPIURL() + '/api/v1/students/' + data.list.student_id
  } else if (/studentfilesindex/.test(data.this.$route.name)) {
    // StufilesIndex
    url = getAPIURL() + '/api/v1/studentfiles/search?limit=' + settings.LIMIT
  }
  axios({
    method: 'get',
    url: url,
    withCredentials: true
  }).then(response => {
    console.log(response)
    if (/studentfileview/.test(data.this.$route.name)) {
      // StudentfileView
      store.state.item.student = response.data
    } else if (/studentfilesindex/.test(data.this.$route.name)) {
      // StudentfilesIndex
      store.state.list.studentfiles = response.data.studentfile
    }
    data.edit_id.edit_id = ''
  }).catch(error => {
    console.log(error)
    // alert('get失敗しました')
    store.dispatch('loginState')
  })
}

export const patchStudentfile = ({ commit }, data) => {
  // if (window.confirm('本当に更新しますか？')) {
  let params = new FormData()
  if (/studentfileview/.test(data.this.$route.name)) {
    // StudentfileView
    params.append('month', data.list.month)
    params.append('state', data.studentfile.state)
    params.append('filing_date', data.list.filing_date)
    params.append('note', data.list.note)
    params.append('file_name', data.studentfile.file_name)
    params.append('points_english', data.list.points_english)
    params.append('points_mathematics', data.list.points_mathematics)
    params.append('points_japanese', data.list.points_japanese)
    params.append('points_science', data.list.points_science)
    params.append('points_socialstudies', data.list.points_socialstudies)
    params.append('file', data.studentfile.file)
  } else if (/studentfilesindex/.test(data.this.$route.name)) {
    // StudentfilesIndex
    params.append('month', data.list.month)
    params.append('state', data.studentfile.state)
    params.append('filing_date', data.list.filing_date)
    params.append('note', data.list.note)
    params.append('file_name', data.studentfile.file_name)
    params.append('points_english', data.list.points_english)
    params.append('points_mathematics', data.list.points_mathematics)
    params.append('points_japanese', data.list.points_japanese)
    params.append('points_science', data.list.points_science)
    params.append('points_socialstudies', data.list.points_socialstudies)
    params.append('file', data.studentfile.file)
  }
  console.log(data)
  let config = {
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    withCredentials: true
  }
  let url = getAPIURL() + '/api/v1/studentfiles/' + data.list.id
  axios.patch(url, params, config).then(response => {
    console.log(response)
    if (/studentfileview/.test(data.this.$route.name)) {
      // StudentfileView
      url = getAPIURL() + '/api/v1/students/' + store.state.item.student.id
    } else if (/studentfilesindex/.test(data.this.$route.name)) {
      // StudentfilesIndex
      url = getAPIURL() + '/api/v1/studentfiles/search?limit=' + settings.LIMIT
    }
    axios({
      method: 'get',
      url: url,
      withCredentials: true
    }).then(response => {
      if (/studentfileview/.test(data.this.$route.name)) {
        // StudentfileView
        store.state.item.student = response.data
      } else if (/studentfilesindex/.test(data.this.$route.name)) {
        // StudentfilesIndex
        store.state.list.studentfiles = response.data.studentfile
      }
      data.edit_id.edit_id = ''
      // alert('ファイルを更新しました')
    }).catch(error => {
      console.log(error)
      alert('ファイルを更新できませんでした。')
      store.dispatch('loginState')
    })
  }).catch(error => {
    console.log(error)
    alert('ファイルを更新できませんでした。')
    store.dispatch('loginState')
  })
  // } else {
  //   return
  // }
}

export const postReport = ({ commit }, data) => {
  console.log(data)
  console.log(data.this.$route.name)
  // if (window.confirm('報告書をアップロードしますか？')) {
  let params = new FormData()
  if (/studentreports/.test(data.this.$route.name)) {
    // StudentReports
    params.append('student_tutor_id', data.report.student_tutor_id)
    params.append('month', data.report.month)
    params.append('state', data.report.state)
    params.append('filing_date', data.report.filing_date)
    params.append('note', data.report.note)
    params.append('file_name', data.report.file_name)
    params.append('points_english', data.report.points_english)
    params.append('points_mathematics', data.report.points_mathematics)
    params.append('points_japanese', data.report.points_japanese)
    params.append('points_science', data.report.points_science)
    params.append('points_socialstudies', data.report.points_socialstudies)
    params.append('file', data.report.file)
  } else if (/tutorreports/.test(data.this.$route.name)) {
    // TutorReports
    params.append('student_tutor_id', data.report.student_tutor_id)
    params.append('month', data.report.month)
    params.append('state', data.report.state)
    params.append('filing_date', data.report.filing_date)
    params.append('note', data.report.note)
    params.append('file_name', data.report.file_name)
    params.append('points_english', data.report.points_english)
    params.append('points_mathematics', data.report.points_mathematics)
    params.append('points_japanese', data.report.points_japanese)
    params.append('points_science', data.report.points_science)
    params.append('points_socialstudies', data.report.points_socialstudies)
    params.append('file', data.report.file)
  } else if (/reportsindex/.test(data.this.$route.name)) {
    // ReportsIndex
    params.append('student_tutor_id', data.report.student_tutor_id)
    params.append('month', data.report.month)
    params.append('state', data.report.state)
    params.append('filing_date', data.report.filing_date)
    params.append('note', data.report.note)
    params.append('file_name', data.report.file_name)
    params.append('points_english', data.report.points_english)
    params.append('points_mathematics', data.report.points_mathematics)
    params.append('points_japanese', data.report.points_japanese)
    params.append('points_science', data.report.points_science)
    params.append('points_socialstudies', data.report.points_socialstudies)
    params.append('file', data.report.file)
  }
  console.log(data)
  let config = {
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    withCredentials: true
  }
  let url = getAPIURL() + '/api/v1/reports'
  axios.post(url, params, config).then(response => {
    console.log(response)
    if (/studentreports/.test(data.this.$route.name)) {
      // StudentReports
      url = getAPIURL() + '/api/v1/students/' + store.state.item.student.id
    } else if (/tutorreports/.test(data.this.$route.name)) {
      // TutorReports
      url = getAPIURL() + '/api/v1/tutors/' + store.state.item.tutor.id
    } else if (/reportsindex/.test(data.this.$route.name)) {
      // ReportsIndex
      url = getAPIURL() + '/api/v1/reports/search?limit=' + settings.LIMIT
    }
    axios({
      method: 'get',
      url: url,
      withCredentials: true
    }).then(response => {
      if (/studentreports/.test(data.this.$route.name)) {
        // StudentReports
        store.state.item.student = response.data
      } else if (/tutorreports/.test(data.this.$route.name)) {
        // TutorReports
        store.state.item.tutor = response.data
      } else if (/reportsindex/.test(data.this.$route.name)) {
        // ReportsIndex
        store.state.list.reports = response.data.report
      }
      data.report.student_tutor_id = ''
      // data.report.month = ''
      // data.report.state = ''
      // data.report.filing_date = ''
      data.report.note = ''
      data.report.user_id = ''
      // data.report.file_name = ''
      data.report.points_english = ''
      data.report.points_mathematics = ''
      data.report.points_japanese = ''
      data.report.points_science = ''
      data.report.points_socialstudies = ''
      document.getElementById('file').value = ''
      // alert('報告書をアップロードしました。')
    }).catch(error => {
      console.log(error)
      alert('報告書をアップロードできませんでした。')
      store.dispatch('loginState')
    })
  }).catch(error => {
    console.log(error)
    alert('報告書をアップロードできませんでした。')
    store.dispatch('loginState')
  })
  // } else {
  //   return
  // }
}

export const deleteReport = ({ commit }, data) => {
  if (window.confirm('報告書を削除しますか？')) {
    axios({
      method: 'delete',
      url: getAPIURL() + '/api/v1/reports/' + data.list.id,
      withCredentials: true
    }).then(response => {
      console.log(response)
      let url
      if (/studentreports/.test(data.this.$route.name)) {
        // url = getAPIURL() + '/api/v1/students/' + data.list.student_id
        url = getAPIURL() + '/api/v1/reports/search?limit=' + settings.LIMIT
      } else if (/tutorreports/.test(data.this.$route.name)) {
        // url = getAPIURL() + '/api/v1/tutors/' + data.list.tutor_id
        url = getAPIURL() + '/api/v1/reports/search?limit=' + settings.LIMIT
      } else if (/reportsindex/.test(data.this.$route.name)) {
        url = getAPIURL() + '/api/v1/reports/search?limit=' + settings.LIMIT
      }
      axios({
        method: 'get',
        url: url,
        withCredentials: true
      }).then(response => {
        console.log(response)
        if (/studetreports/.test(data.this.$route.name)) {
          // StudentReports
          // store.state.item.student = response.data
          store.state.list.reports = response.data.report
        } else if (/tutorreports/.test(data.this.$route.name)) {
          // TutorReports
          // store.state.item.tutor = response.data
          store.state.list.reports = response.data.report
        } else if (/reportsindex/.test(data.this.$route.name)) {
          // ReportsIndex
          store.state.list.reports = response.data.report
        }
        alert('報告書を削除しました。')
      }).catch(error => {
        console.log(error)
        alert('報告書を削除できませんでした。')
        store.dispatch('loginState')
      })
    }).catch(error => {
      console.log(error)
      alert('報告書を削除できませんでした。')
      store.dispatch('loginState')
    })
  } else {
    return
  }
}

export const cancelReport = ({ commit }, data) => {
  let url
  if (/studentreports/.test(data.this.$route.name)) {
    // StudentReports
    // url = getAPIURL() + '/api/v1/students/' + data.list.student_id
    url = getAPIURL() + '/api/v1/reports/search?limit=' + settings.LIMIT
  } else if (/tutorreports/.test(data.this.$route.name)) {
    // TutorReports
    // url = getAPIURL() + '/api/v1/tutors/' + data.list.tutor_id
    url = getAPIURL() + '/api/v1/reports/search?limit=' + settings.LIMIT
  } else if (/reportsindex/.test(data.this.$route.name)) {
    // ReportsIndex
    url = getAPIURL() + '/api/v1/reports/search?limit=' + settings.LIMIT
  }
  axios({
    method: 'get',
    url: url,
    withCredentials: true
  }).then(response => {
    console.log(response)
    if (/studentreports/.test(data.this.$route.name)) {
      // StudentReports
      // store.state.item.student = response.data
      store.state.list.reports = response.data.report
    } else if (/tutorreports/.test(data.this.$route.name)) {
      // TutorReports
      // store.state.item.tutor = response.data
      store.state.list.reports = response.data.report
    } else if (/reportsindex/.test(data.this.$route.name)) {
      // ReportsIndex
      store.state.list.reports = response.data.report
    }
    data.edit_id.edit_id = ''
  }).catch(error => {
    console.log(error)
    // alert('get失敗しました')
    store.dispatch('loginState')
  })
}

export const patchReport = ({ commit }, data) => {
  // if (window.confirm('本当に更新しますか？')) {
  let params = new FormData()
  if (/studentreports/.test(data.this.$route.name)) {
    // StudentReports
    params.append('month', data.list.month)
    params.append('state', data.report.state)
    params.append('filing_date', data.list.filing_date)
    params.append('note', data.list.note)
    params.append('file_name', data.report.file_name)
    params.append('points_english', data.list.points_english)
    params.append('points_mathematics', data.list.points_mathematics)
    params.append('points_japanese', data.list.points_japanese)
    params.append('points_science', data.list.points_science)
    params.append('points_socialstudies', data.list.points_socialstudies)
    params.append('file', data.report.file)
  } else if (/tutorreports/.test(data.this.$route.name)) {
    // TutorReports
    params.append('month', data.list.month)
    params.append('state', data.report.state)
    params.append('filing_date', data.list.filing_date)
    params.append('note', data.list.note)
    params.append('file_name', data.report.file_name)
    params.append('points_english', data.list.points_english)
    params.append('points_mathematics', data.list.points_mathematics)
    params.append('points_japanese', data.list.points_japanese)
    params.append('points_science', data.list.points_science)
    params.append('points_socialstudies', data.list.points_socialstudies)
    params.append('file', data.report.file)
  } else if (/reportsindex/.test(data.this.$route.name)) {
    // ReportsIndex
    params.append('month', data.list.month)
    params.append('state', data.report.state)
    params.append('filing_date', data.list.filing_date)
    params.append('note', data.list.note)
    params.append('file_name', data.report.file_name)
    params.append('points_english', data.list.points_english)
    params.append('points_mathematics', data.list.points_mathematics)
    params.append('points_japanese', data.list.points_japanese)
    params.append('points_science', data.list.points_science)
    params.append('points_socialstudies', data.list.points_socialstudies)
    params.append('file', data.report.file)
  }
  console.log(data)
  let config = {
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    withCredentials: true
  }
  let url = getAPIURL() + '/api/v1/reports/' + data.list.id
  axios.patch(url, params, config).then(response => {
    console.log(response)
    if (/studentreports/.test(data.this.$route.name)) {
      // StudentReports
      // url = getAPIURL() + '/api/v1/students/' + data.list.student_id
      url = getAPIURL() + '/api/v1/reports/search?limit=' + settings.LIMIT
    } else if (/tutorreports/.test(data.this.$route.name)) {
      // TutorReports
      // url = getAPIURL() + '/api/v1/tutors/' + data.list.tutor_id
      url = getAPIURL() + '/api/v1/reports/search?limit=' + settings.LIMIT
    } else if (/reportsindex/.test(data.this.$route.name)) {
      // ReportsIndex
      url = getAPIURL() + '/api/v1/reports/search?limit=' + settings.LIMIT
    }
    axios({
      method: 'get',
      url: url,
      withCredentials: true
    }).then(response => {
      if (/studentreports/.test(data.this.$route.name)) {
        // StudentReports
        // store.state.item.student = response.data
        store.state.list.reports = response.data.report
      } else if (/tutorreports/.test(data.this.$route.name)) {
        // TutorReports
        // store.state.item.tutor = response.data
        store.state.list.reports = response.data.report
      } else if (/reportsindex/.test(data.this.$route.name)) {
        // ReportsIndex
        store.state.list.reports = response.data.report
      }
      data.edit_id.edit_id = ''
      // alert('報告書を更新しました')
    }).catch(error => {
      console.log(error)
      alert('報告書を更新できませんでした。')
      store.dispatch('loginState')
    })
  }).catch(error => {
    console.log(error)
    alert('報告書を更新できませんでした。')
    store.dispatch('loginState')
  })
  // } else {
  //   return
  // }
}

export const patchStudentTutorId = ({ commit }, data) => {
  // if (window.confirm('この先生を紐付けしますか？')) {
  const params = {
    'tutor_id': data.tutor.id
  }
  axios({
    method: 'patch',
    params: params,
    url: getAPIURL() + '/api/v1/student_tutors/' + data.id,
    withCredentials: true
  }).then(response => {
    console.log(response)
    axios({
      method: 'get',
      url: getAPIURL() + '/api/v1/student_tutors/search?limit=' + settings.LIMIT,
      withCredentials: true
    }).then(response => {
      console.log(response)
      store.state.list.student_tutors = response.data.student_tutor
      data.tutor.id = ''
      // alert('先生の紐付けを完了しました')
      data.condition.condition = false
    }).catch(error => {
      console.log(error)
      alert('生徒情報を登録できませんした。')
      store.dispatch('loginState')
    })
  }).catch(error => {
    console.log(error)
    alert('生徒情報を登録できませんした。')
    store.dispatch('loginState')
  })
  // } else {
  //   return
  // }
}

export const postTutorfile = ({ commit }, data) => {
  console.log(data)
  console.log(data.this.$route.name)
  // if (window.confirm('ファイルをアップロードしますか？')) {
  let params = new FormData()
  if (/tutorfileview/.test(data.this.$route.name)) {
    // TutorfileView
    params.append('tutor_id', store.state.item.tutor.id)
    params.append('file_name', data.tutorfile.file_name)
    params.append('file', data.tutorfile.file)
  } else if (/tutorfilesindex/.test(data.this.$route.name)) {
    // TutorfilesIndex
    params.append('tutor_id', data.tutorfile.tutor_id)
    params.append('file_name', data.tutorfile.file_name)
    params.append('file', data.tutorfile.file)
  }
  console.log(data)
  console.log(settings)
  console.log(store)
  let config = {
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    withCredentials: true
  }
  let url = getAPIURL() + '/api/v1/tutorfiles'
  axios.post(url, params, config).then(response => {
    console.log(response)
    if (/tutorfileview/.test(data.this.$route.name)) {
      // TutorfileView
      url = getAPIURL() + '/api/v1/tutors/' + store.state.item.tutor.id
    } else if (/tutorfilesindex/.test(data.this.$route.name)) {
      // TutorfilesIndex
      url = getAPIURL() + '/api/v1/tutorfiles/search?limit=' + settings.LIMIT
    }
    axios({
      method: 'get',
      url: url,
      withCredentials: true
    }).then(response => {
      console.log(response)
      if (/tutorfileview/.test(data.this.$route.name)) {
        // TutorfileView
        store.state.item.tutor = response.data
      } else if (/tutorfilesindex/.test(data.this.$route.name)) {
        // TutorfilesIndex
        store.state.list.tutorfiles = response.data.tutorfile
      }
      data.tutorfile.tutor_id = ''
      data.tutorfile.user_id = ''
      data.tutorfile.file_name = ''
      document.getElementById('file').value = ''
      // alert('ファイルをアップロードしました。')
    }).catch(error => {
      console.log(error)
      alert('ファイルをアップロードできませんでした。')
      store.dispatch('loginState')
    })
  }).catch(error => {
    console.log(error)
    alert('ファイルをアップロードできませんでした。')
    store.dispatch('loginState')
  })
  // } else {
  //   return
  // }
}

export const deleteTutorfile = ({ commit }, data) => {
  if (window.confirm('ファイルを削除しますか？')) {
    axios({
      method: 'delete',
      url: getAPIURL() + '/api/v1/tutorfiles/' + data.list.id,
      withCredentials: true
    }).then(response => {
      console.log(response)
      let url
      if (/tutorfileview/.test(data.this.$route.name)) {
        url = getAPIURL() + '/api/v1/tutors/' + data.list.tutor_id
      } else if (/tutorfilesindex/.test(data.this.$route.name)) {
        url = getAPIURL() + '/api/v1/tutorfiles/search?limit=' + settings.LIMIT
      }
      axios({
        method: 'get',
        url: url,
        withCredentials: true
      }).then(response => {
        console.log(response)
        if (/tutorfileview/.test(data.this.$route.name)) {
          // TutorfileView
          store.state.item.tutor = response.data
        } else if (/tutorfilesindex/.test(data.this.$route.name)) {
          // TutorfilesIndex
          store.state.list.tutorfiles = response.data.tutorfile
        }
        alert('ファイルを削除しました')
      }).catch(error => {
        console.log(error)
        alert('ファイルを削除できませんでした。')
        store.dispatch('loginState')
      })
    }).catch(error => {
      console.log(error)
      alert('ファイルを削除できませんでした。')
      store.dispatch('loginState')
    })
  } else {
    return
  }
}

export const cancelTutorfile = ({ commit }, data) => {
  let url
  if (/tutorfileview/.test(data.this.$route.name)) {
    // TutorfileView
    url = getAPIURL() + '/api/v1/tutors/' + data.list.tutor_id
  } else if (/tutorfilesindex/.test(data.this.$route.name)) {
    // TutorfilesIndex
    url = getAPIURL() + '/api/v1/tutorfiles/search?limit=' + settings.LIMIT
  }
  axios({
    method: 'get',
    url: url,
    withCredentials: true
  }).then(response => {
    console.log(response)
    if (/tutorfileview/.test(data.this.$route.name)) {
      // TutorfileView
      store.state.item.tutor = response.data
    } else if (/tutorfilesindex/.test(data.this.$route.name)) {
      // TutorfilesIndex
      store.state.list.tutorfiles = response.data.tutorfile
    }
    data.edit_id.edit_id = ''
  }).catch(error => {
    console.log(error)
    // alert('get失敗しました')
    store.dispatch('loginState')
  })
}

export const patchTutorfile = ({ commit }, data) => {
  // if (window.confirm('本当に更新しますか？')) {
  let params = new FormData()
  if (/tutorfileview/.test(data.this.$route.name)) {
    // TutorfileView
    params.append('file_name', data.tutorfile.file_name)
    params.append('file', data.tutorfile.file)
  } else if (/tutorfilesindex/.test(data.this.$route.name)) {
    // TutorfilesIndex
    params.append('file_name', data.tutorfile.file_name)
    params.append('file', data.tutorfile.file)
  }
  console.log(data)
  let config = {
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    withCredentials: true
  }
  let url = getAPIURL() + '/api/v1/tutorfiles/' + data.list.id
  axios.patch(url, params, config).then(response => {
    console.log(response)
    if (/tutorfileview/.test(data.this.$route.name)) {
      // TutotfileView
      url = getAPIURL() + '/api/v1/tutors/' + store.state.item.tutor.id
    } else if (/tutorfilesindex/.test(data.this.$route.name)) {
      // TutorfilesIndex
      url = getAPIURL() + '/api/v1/tutorfiles/search?limit=' + settings.LIMIT
    }
    axios({
      method: 'get',
      url: url,
      withCredentials: true
    }).then(response => {
      if (/tutorfileview/.test(data.this.$route.name)) {
        // TutorfileView
        store.state.item.tutor = response.data
      } else if (/tutorfilesindex/.test(data.this.$route.name)) {
        // TutorfilesIndex
        store.state.list.tutorfiles = response.data.tutorfile
      }
      data.edit_id.edit_id = ''
      // alert('ファイルを更新しました')
    }).catch(error => {
      console.log(error)
      alert('ファイルを更新できませんでした。')
      store.dispatch('loginState')
    })
  }).catch(error => {
    console.log(error)
    alert('ファイルを更新できませんでした。')
    store.dispatch('loginState')
  })
  // } else {
  //   return
  // }
}

export const getStudents = ({ commit }) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/students/search?limit=' + settings.LIMIT,
    withCredentials: true
  }).then(response => {
    // console.log(response)
    store.state.list.students = response.data.student
    store.state.max = response.data.max
  }).catch(error => {
    console.log(error)
    // alert('getStudentsに失敗しました')
    store.dispatch('loginState')
  })
}

export const getStudentsLimit10 = ({ commit }) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/students/search?limit=' + 10,
    withCredentials: true
  }).then(response => {
    // console.log(response)
    store.state.list.students = response.data.student
  }).catch(error => {
    console.log(error)
    // alert('getStudentsに失敗しました')
    store.dispatch('loginState')
  })
}

export const getStudentsLimit0 = ({ commit }) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/students/search?limit=' + 0,
    withCredentials: true
  }).then(response => {
    // console.log(response)
    store.state.list.students = response.data.student
  }).catch(error => {
    console.log(error)
    // alert('getStudentsに失敗しました')
    store.dispatch('loginState')
  })
}

export const getStudent = ({ commit }, id) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/students/' + id,
    withCredentials: true
  }).then(response => {
    // console.log(response)
    store.state.item.student = response.data
  }).catch(error => {
    console.log(error)
    // alert('getStudentに失敗しました')
    store.dispatch('loginState')
  })
}

export const postStudent = ({ commit }, data) => {
  let student_id
  // if (window.confirm('この内容で登録してもよろしいですか？')) {
  console.log(data)
  const params = {
    'family_id': data.student.family_id,
    'state': data.student.state,
    'f_name': data.student.f_name,
    'l_name': data.student.l_name,
    'f_name_kana': data.student.f_name_kana,
    'l_name_kana': data.student.l_name_kana,
    'gender': data.student.gender,
    'birthday': data.student.birthday,
    'school_type': data.student.school_type,
    'school_name': data.student.school_name,
    'grade_flag': data.student.grade_flag,
    'guidance_detail': data.student.guidance_detail,
    'takeover_time': data.student.takeover_time,
    'inheritance_result': data.student.inheritance_result,
    'next_contact_date': data.student.next_contact_date,
    'priority': data.student.priority,
    'service_period_start': data.student.service_period_start,
    'service_period_end': data.student.service_period_end,
    'note': data.student.note
  }
  axios({
    method: 'post',
    params: params,
    url: getAPIURL() + '/api/v1/students/',
    withCredentials: true
  }).then(response => {
    console.log(response)
    student_id = response.data.id
    axios({
      method: 'get',
      url: getAPIURL() + '/api/v1/students/search?limit=' + settings.LIMIT,
      withCredentials: true
    }).then(response => {
      console.log(response)
      store.state.list.students = response.data.student
      data.student.family_id = ''
      data.reset()
      data.this.$router.push({name: 'studentindex', params: { id: student_id }})
    }).catch(error => {
      console.log(error)
      alert('生徒情報を登録できませんでした。')
      store.dispatch('loginState')
    })
  }).catch(error => {
    console.log(error)
    alert('生徒情報を登録できませんでした。')
    store.dispatch('loginState')
  })
  // } else {
  //   return
  // }
}

export const postStudentModal = ({ commit }, data) => {
  console.log(data)
  const params = {
    'family_id': data.family.id,
    'state': data.student.state,
    'f_name': data.student.f_name,
    'l_name': data.student.l_name,
    'f_name_kana': data.student.f_name_kana,
    'l_name_kana': data.student.l_name_kana,
    'gender': data.student.gender,
    'birthday': data.student.birthday,
    'school_type': data.student.school_type,
    'school_name': data.student.school_name,
    'grade_flag': data.student.grade_flag,
    'guidance_detail': data.student.guidance_detail,
    'takeover_time': data.student.takeover_time,
    'inheritance_result': data.student.inheritance,
    'next_contact_date': data.student.next_contact_date,
    'priority': data.student.priority,
    'service_period_start': data.student.service_period_start,
    'service_period_end': data.student.service_period_end,
    'note': data.student.note
  }
  axios({
    method: 'post',
    params: params,
    url: getAPIURL() + '/api/v1/students/',
    withCredentials: true
  }).then(response => {
    console.log(response)
    axios({
      method: 'get',
      url: getAPIURL() + '/api/v1/families/' + store.state.item.family.id,
      withCredentials: true
    }).then(response => {
      store.state.item.family = response.data
      data.condition.condition = !data.condition.condition
      data.family_id = ''
      data.student.state = 0
      data.student.f_name = ''
      data.student.l_name = ''
      data.student.f_name_kana = ''
      data.student.l_name_kana = ''
      data.student.gender = 0
      data.student.birthday = '0001/01/01'
      data.student.school_type = 0
      data.student.school_name = ''
      data.student.grade_flag = 0
      data.student.guidance_detail = ''
      data.student.takeover_time = ''
      data.student.inheritance = 0
      data.student.next_contact_date = ''
      data.student.priority = 0
      data.student.service_period_start = '0001/01/01'
      data.student.service_period_end = '0001/01/01'
      data.student.note = ''
      // alert('生徒情報を登録しました。')
    }).catch(error => {
      console.log(error)
      alert('生徒情報を登録できませんでした。')
      store.dispatch('loginState')
    })
  }).catch(error => {
    console.log(error)
    alert('生徒情報を登録できませんでした。')
    store.dispatch('loginState')
  })
}

export const patchStudent = ({ commit }, data) => {
  const params = {
    'state': data.student.state,
    'f_name': data.student.f_name,
    'l_name': data.student.l_name,
    'f_name_kana': data.student.f_name_kana,
    'l_name_kana': data.student.l_name_kana,
    'gender': data.student.gender,
    'birthday': data.student.birthday,
    'school_type': data.student.school_type,
    'school_name': data.student.school_name,
    'grade_flag': data.student.grade_flag,
    'guidance_detail': data.student.guidance_detail,
    'takeover_time': data.student.takeover_time,
    'inheritance_result': data.student.inheritance_result,
    'next_contact_date': data.student.next_contact_date,
    'priority': data.student.priority,
    'service_period_start': data.student.service_period_start,
    'service_period_end': data.student.service_period_end,
    'note': data.student.note
  }
  console.log(params)
  axios({
    method: 'patch',
    params: params,
    url: getAPIURL() + '/api/v1/students/' + data.student.id,
    withCredentials: true
  }).then(response => {
    console.log(response)
    axios({
      method: 'get',
      url: getAPIURL() + '/api/v1/students/' + data.student.id,
      withCredentials: true
    }).then(response => {
      console.log(response)
      store.state.item.student = response.data
      data.edit_id.student_id = ''
      // alert('生徒情報を更新しました。')
    }).catch(error => {
      console.log(error)
      alert('生徒情報を更新できませんでした。')
      store.dispatch('loginState')
    })
  }).catch(error => {
    console.log(error)
    alert('生徒情報を更新できませんでした。')
    store.dispatch('loginState')
  })
}

export const cancelStudent = ({ commit }, data) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/students/' + store.state.item.student.id,
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.item.student = response.data
    data.edit_id.student_id = ''
    // alert('editキャンセルしました')
  })
}

export const getStudentfiles = ({ commit }) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/studentfiles/search?limit=' + settings.LIMIT,
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.list.studentfiles = response.data.studentfile
  }).catch(error => {
    console.log(error)
    // alert('getStudentfilesに失敗しました')
    store.dispatch('loginState')
  })
}

export const getStudentfile = ({ commit }, data) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/studentfiles/' + data.id,
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.item.studentfile = response.data.studentfile
  }).catch(error => {
    console.log(error)
    // alert('getStudentfileに失敗しました')
    store.dispatch('loginState')
  })
}

export const getReports = ({ commit }) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/reports/search?limit=' + settings.LIMIT,
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.list.reports = response.data.report
  }).catch(error => {
    console.log(error)
    // alert('getReportsに失敗しました')
    store.dispatch('loginState')
  })
}

export const getReport = ({ commit }, data) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/reports/' + data.id,
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.item.report = response.data.report
  }).catch(error => {
    console.log(error)
    // alert('getReportに失敗しました')
    store.dispatch('loginState')
  })
}

export const cancelStudentsupport = ({ commit }, data) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/students/' + store.state.item.student.id,
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.item.student = response.data
    data.edit_id.list_id = ''
    // alert("キャンセルしました")
  }).catch(error => {
    console.log(error)
    // alert('get失敗しました')
    store.dispatch('loginState')
  })
}

export const patchStudentsupport = ({ commit }, data) => {
  console.log(data)
  const params = {
    // 'user_id': store.state.item.user.id,
    'family_id': store.state.item.student.family.id,
    'support_date': moment(data.patch.support_date).format(),
    'note': data.list.note
  }
  axios({
    method: 'patch',
    params: params,
    url: getAPIURL() + '/api/v1/familysupports/' + data.list.id,
    withCredentials: true
  }).then(response => {
    console.log(response)
    axios({
      method: 'get',
      url: getAPIURL() + '/api/v1/students/' + store.state.item.student.id,
      withCredentials: true
    }).then(response => {
      console.log(response)
      store.state.item.student = response.data
      data.edit_id.list_id = ''
      // alert('対応履歴を更新しました。')
    }).catch(error => {
      console.log(error)
      alert('対応履歴を更新できませんでした。')
      store.dispatch('loginState')
    })
  }).catch(error => {
    console.log(error)
    alert('対応履歴を更新できませんでした。')
    store.dispatch('loginState')
  })
}

export const deleteStudentsupport = ({ commit }, list) => {
  if (window.confirm('本当に削除しますか？')) {
    axios({
      method: 'delete',
      url: getAPIURL() + '/api/v1/familysupports/' + list.id,
      withCredentials: true
    }).then(response => {
      console.log(response)
      axios({
        method: 'get',
        url: getAPIURL() + '/api/v1/students/' + store.state.item.student.id,
        withCredentials: true
      }).then(response => {
        console.log(response)
        store.state.item.student = response.data
        alert('対応履歴を削除しました')
      }).catch(error => {
        console.log(error)
        alert('対応履歴を削除できませんでした。')
        store.dispatch('loginState')
      })
    }).catch(error => {
      console.log(error)
      alert('対応履歴を削除できませんでした。')
      store.dispatch('loginState')
    })
  } else {
    return
  }
}

export const getAgreements = ({ commit }) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/agreements/search?limit=' + settings.LIMIT,
    withCredentials: true
  }).then(response => {
    // console.log(response)
    store.state.list.agreements = response.data.agreement
    store.state.max = response.data.max
    store.state.sum = response.data.sum
    store.state.digestibility = response.data.digestibility
  }).catch(error => {
    console.log(error)
    // alert('getAgreementsに失敗しました')
    store.dispatch('loginState')
  })
}

export const getAgreement = ({ commit }, id) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/agreements/' + id,
    withCredentials: true
  }).then(response => {
    // console.log(response)
    store.state.item.agreement = response.data
  }).catch(error => {
    console.log(error)
    // alert('getAgreementに失敗しました')
    store.dispatch('loginState')
  })
}

export const postAgreement = ({ commit }, data) => {
  console.log(data)
  const params = {
    'student_id': data.agreement.student_id,
    'payroll_check': data.agreement.payroll_check,
    'contract_type': data.agreement.contract_type,
    'contract_date': data.agreement.contract_date,
    'change_date': data.agreement.change_date,
    'cancel_type': data.agreement.cancel_type,
    'cancel_date': data.agreement.cancel_date,
    'media': data.agreement.media,
    'f_name': data.agreement.f_name,
    'l_name': data.agreement.l_name,
    'f_name_kana': data.agreement.f_name_kana,
    'l_name_kana': data.agreement.l_name_kana,
    'tel': data.agreement.tel,
    'tel2': data.agreement.tel2,
    'address': data.agreement.address,
    'address2': data.agreement.address2,
    'office': data.agreement.office,
    'person': data.agreement.person,
    'product_name': data.agreement.product_name,
    'payment_type': data.agreement.payment_type,
    'text_type': data.agreement.text_type,
    'amount': data.agreement.amount,
    'discount': data.agreement.discount,
    'pure_amount': data.agreement.pure_amount,
    'division_commission': data.agreement.division_commission,
    'total_amount': data.agreement.total_amount,
    'payments_number': data.agreement.payments_number,
    'deposit_amount_date': data.agreement.deposit_amount_date,
    'text_payment_period_start': data.agreement.text_payment_period_start,
    'text_payment_period_end': data.agreement.text_payment_period_end,
    'service_period_start': data.agreement.service_period_start,
    'service_period_end': data.agreement.service_period_end,
    'first_month_deposit_method': data.agreement.first_month_deposit_method,
    'first_month_deposit_check': data.agreement.first_month_deposit_check,
    'admission_fee': data.agreement.admission_fee,
    'admission_fee_method': data.agreement.admission_fee_method,
    'admission_fee_check': data.agreement.admission_fee_check,
    'deposit': data.agreement.deposit,
    'deposit_method': data.agreement.deposit_method,
    'deposit_check': data.agreement.deposit_check,
    'bank_number': data.agreement.bank_number,
    'branch_number': data.agreement.branch_number,
    'deposit_item': data.agreement.deposit_item,
    'account_number': data.agreement.account_number,
    'account_holder': data.agreement.account_holder,
    'expected_refund_date': data.agreement.expected_refund_date,
    'deposit_refund_date': data.agreement.deposit_refund_date,
    'approval_date': data.agreement.approval_date,
    'approval_number': data.agreement.approval_number,
    'delivery_date': data.agreement.delivery_date,
    'contract_collection_date': data.agreement.contract_collection_date,
    'factor_collection_date': data.agreement.factor_collection_date,
    'factor_check': data.agreement.factor_check,
    'ledger_check': data.agreement.ledger_check,
    'cancel_check': data.agreement.cancel_check,
    'change_check': data.agreement.change_check,
    'grade': data.agreement.grade,
    'point_total': data.agreement.point_total,
    'note': data.agreement.note
  }
  console.log(params)
  axios({
    method: 'post',
    params: params,
    url: getAPIURL() + '/api/v1/agreements/',
    withCredentials: true
  }).then(response => {
    console.log(response)
    let url
    if (/studentagreements/.test(data.this.$route.name)) {
      // studentAgreements
      url = getAPIURL() + '/api/v1/students/' + response.data.student_id
    } else if (/agreementsadd/.test(data.this.$route.name)) {
      // AgreementsAdd
      url = getAPIURL() + '/api/v1/agreements/search?limit=' + settings.LIMIT
    }
    axios({
      method: 'get',
      url: url,
      withCredentials: true
    }).then(response => {
      console.log(response)
      if (/studentagreements/.test(data.this.$route.name)) {
        // studentAgreement
        store.state.item.student = response.data
        // data.this.$router.push({name: 'studentagreements'})
      } else if (/agreementsadd/.test(data.this.$route.name)) {
        // AgreementsAdd
        store.state.list.agreements = response.data.agreement
        // data.this.$router.push({name: 'agreementsindex'})
      }
      data.agreement.student_id = ''
      data.reset()
    }).catch(error => {
      console.log(error)
      alert('契約情報を登録できませんでした。')
      store.dispatch('loginState')
    })
  }).catch(error => {
    console.log(error)
    alert('契約情報を登録できませんでした。')
    store.dispatch('loginState')
  })
}

export const patchAgreement = ({ commit }, data) => {
  console.log(data)
  const params = {
    'student_id': data.list.student_id,
    'payroll_check': data.list.payroll_check,
    'contract_type': data.list.contract_type,
    'contract_date': data.list.contract_date,
    'change_date': data.list.change_date,
    'cancel_type': data.list.cancel_type,
    'cancel_date': data.list.cancel_date,
    'media': data.list.media,
    'f_name': data.list.f_name,
    'l_name': data.list.l_name,
    'f_name_kana': data.list.f_name_kana,
    'l_name_kana': data.list.l_name_kana,
    'tel': data.list.tel,
    'tel2': data.list.tel2,
    'address': data.list.address,
    'address2': data.list.address2,
    'office': data.list.office,
    'person': data.list.person,
    'product_name': data.list.product_name,
    'payment_type': data.list.payment_type,
    'text_type': data.list.text_type,
    'amount': data.list.amount,
    'discount': data.list.discount,
    'pure_amount': data.list.pure_amount,
    'division_commission': data.list.division_commission,
    'total_amount': data.list.total_amount,
    'payments_number': data.list.payments_number,
    'deposit_amount_date': data.list.deposit_amount_date,
    'text_payment_period_start': data.list.text_payment_period_start,
    'text_payment_period_end': data.list.text_payment_period_end,
    'service_period_start': data.list.service_period_start,
    'service_period_end': data.list.service_period_end,
    'first_month_deposit_method': data.list.first_month_deposit_method,
    'first_month_deposit_check': data.list.first_month_deposit_check,
    'admission_fee': data.list.admission_fee,
    'admission_fee_method': data.list.admission_fee_method,
    'admission_fee_check': data.list.admission_fee_check,
    'deposit': data.list.deposit,
    'deposit_method': data.list.deposit_method,
    'deposit_check': data.list.deposit_check,
    'bank_number': data.list.bank_number,
    'branch_number': data.list.branch_number,
    'deposit_item': data.list.deposit_item,
    'account_number': data.list.account_number,
    'account_holder': data.list.account_holder,
    'expected_refund_date': data.list.expected_refund_date,
    'deposit_refund_date': data.list.deposit_refund_date,
    'approval_date': data.list.approval_date,
    'approval_number': data.list.approval_number,
    'delivery_date': data.list.delivery_date,
    'contract_collection_date': data.list.contract_collection_date,
    'factor_collection_date': data.list.factor_collection_date,
    'factor_check': data.list.factor_check,
    'ledger_check': data.list.ledger_check,
    'cancel_check': data.list.cancel_check,
    'change_check': data.list.change_check,
    'grade': data.list.grade,
    'point_total': data.list.point_total,
    'note': data.list.note
  }
  axios({
    method: 'patch',
    params: params,
    url: getAPIURL() + '/api/v1/agreements/' + data.list.id,
    withCredentials: true
  }).then(response => {
    console.log(response)
    let url = getAPIURL() + '/api/v1/agreements/' + data.list.id
    axios({
      method: 'get',
      url: url,
      withCredentials: true
    }).then(response => {
      console.log(response)
      store.state.item.agreement = response.data
      data.edit_id.agreement_id = ''
      // alert('契約情報を更新しました')
    }).catch(error => {
      console.log(error)
      alert('契約情報を更新できませんでした。')
      store.dispatch('loginState')
    })
  }).catch(error => {
    console.log(error)
    alert('契約情報を更新できませんでした。')
    store.dispatch('loginState')
  })
}

export const editAgreement = ({ commit }, data) => {
  console.log(data)
  let url
  if (/studentagreement/.test(data.this.$route.name)) {
    // studentAgreement
    url = getAPIURL() + '/api/v1/students/' + data.list.student_id
  } else if (/agreementindex/.test(data.this.$route.name)) {
    // AgreementIndex
    url = getAPIURL() + '/api/v1/agreements/' + data.list.id
  }
  axios({
    // multipatchの場合、編集、編集で押されると加工したオブジェクトが見えてしまう為get
    method: 'get',
    url: url,
    withCredentials: true
  }).then(response => {
    console.log(response)
    if (/studentagreement/.test(data.this.$route.name)) {
      // studentAgreement
      store.state.item.student = response.data
    } else if (/agreementindex/.test(data.this.$route.name)) {
      // AgreementIndex
      store.state.item.agreement = response.data
    }
    data.edit_id.edit_id = data.list.id
    store.dispatch('loginState')
  }).catch(error => {
    console.log(error)
    // alert('getに失敗しました')
    store.dispatch('loginState')
  })
}

export const cancelAgreement = ({ commit }, data) => {
  let url
  if (/studentagreement/.test(data.this.$route.name)) {
    // studentAgreement
    url = getAPIURL() + '/api/v1/students/' + data.list.student_id
  } else if (/agreementindex/.test(data.this.$route.name)) {
    // AgreementIndex
    url = getAPIURL() + '/api/v1/agreements/' + data.list.id
  }
  axios({
    method: 'get',
    url: url,
    withCredentials: true
  }).then(response => {
    console.log(response)
    if (/studentagreement/.test(data.this.$route.name)) {
      // studentAgreement
      store.state.item.student = response.data
      data.edit_id.edit_id = ''
    } else if (/agreementindex/.test(data.this.$route.name)) {
      // AgreementIndex
      store.state.item.agreement = response.data
      data.edit_id.agreement_id = ''
    }
    // alert('キャンセルしました')
  }).catch(error => {
    console.log(error)
    // alert('getに失敗しました')
    store.dispatch('loginState')
  })
}

export const deleteAgreement = ({ commit }, data) => {
  if (window.confirm('契約情報を削除しますか？')) {
    axios({
      method: 'delete',
      url: getAPIURL() + '/api/v1/agreements/' + data.agreement.id,
      withCredentials: true
    }).then(response => {
      console.log(response)
      axios({
        method: 'get',
        url: getAPIURL() + '/api/v1/agreements/search?limit=' + settings.LIMIT,
        withCredentials: true
      }).then(response => {
        console.log(response)
        store.state.list.agreement = response.data.agreement
        data.this.$router.push({name: 'agreementsindex'})
        alert('契約情報を削除しました')
      }).catch(error => {
        console.log(error)
        alert('契約情報を削除できませんでした。')
        store.dispatch('loginState')
      })
    }).catch(error => {
      console.log(error)
      alert('契約情報を削除できませんでした。')
      store.dispatch('loginState')
    })
  } else {
    return
  }
}

export const getStudent_tutors = ({ commit }) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/student_tutors/search?limit=' + 30,
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.list.student_tutors = response.data.student_tutor
    store.state.max = response.data.max
  }).catch(error => {
    console.log(error)
    // alert('getStudent_tutorsに失敗しました')
    store.dispatch('loginState')
  })
}

export const getStudent_tutor = ({ commit }, id) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/student_tutors/' + id,
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.item.student_tutor = response.data
  }).catch(error => {
    console.log(error)
    // alert('getStudent_tutorに失敗しました')
    store.dispatch('loginState')
  })
}

export const getTutors = ({ commit }) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/tutors/search?limit=' + settings.LIMIT,
    withCredentials: true
  }).then(response => {
    // console.log(response)
    store.state.list.tutors = response.data.tutor
    store.state.max = response.data.max
  }).catch(error => {
    console.log(error)
    // alert('gettutorsに失敗しました')
    store.dispatch('loginstate')
  })
}

export const getTutorsLimit10 = ({ commit }) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/tutors/search?limit=' + 10,
    withCredentials: true
  }).then(response => {
    // console.log(response)
    store.state.list.tutors = response.data.tutor
  }).catch(error => {
    console.log(error)
    // alert('gettutorsに失敗しました')
    store.dispatch('loginstate')
  })
}

export const getTutor = ({ commit }, id) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/tutors/' + id,
    withCredentials: true
  }).then(response => {
    // console.log(response)
    store.state.item.tutor = response.data
  }).catch(error => {
    console.log(error)
    // alert('getTutorに失敗しました')
    store.dispatch('loginState')
  })
}

export const postTutor = ({ commit }, data) => {
  let tutor_id
  // if (window.confirm('この内容で登録してもよろしいですか？')) {
  console.log(data)
  // let url = 'http://maps.googleapis.com/maps/api/geocode/json?address=' + data.tutor.geometry + data.tutor.address1
  // console.log(url)
  // axios({
  //   method: 'get',
  //   url: url
  //   // withCredentials: true
  // }).then(response => {
  //   console.log(response)
  //   if (response.data.results.length === 0) {
  //     alert('Google Mapから住所を取得できませんでした。\n' + data.tutor.geometry + data.tutor.address1)
  //   }
  const params = {
    'state': data.tutor.state,
    'registration_date': data.tutor.registration_date,
    'f_name': data.tutor.f_name,
    'l_name': data.tutor.l_name,
    'f_name_kana': data.tutor.f_name_kana,
    'l_name_kana': data.tutor.l_name_kana,
    'gender': data.tutor.gender,
    'birthday': data.tutor.birthday,
    'zip': data.tutor.zip,
    'pref': data.tutor.pref,
    'address1': data.tutor.address1,
    'address2': data.tutor.address2,
    // 'lat': response.data.results[0].geometry.location.lat,
    // 'lng': response.data.results[0].geometry.location.lng,
    'tel1': data.tutor.tel1,
    'tel2': data.tutor.tel2,
    'mail1': data.tutor.mail1,
    'mail2': data.tutor.mail2,
    'home_zip': data.tutor.home_zip,
    'home_pref': data.tutor.home_pref,
    'home_address1': data.tutor.home_address1,
    'home_address2': data.tutor.home_address2,
    'home_tel': data.tutor.home_tel,
    'school_stage': data.tutor.school_stage,
    'school_name': data.tutor.school_name,
    'department': data.tutor.department,
    'old_grade': data.tutor.old_grade,
    'grade_flag': data.tutor.grade_flag,
    'department_type': data.tutor.department_type,
    'club': data.tutor.club,
    'transportation_car': data.tutor.transportation_car,
    'transportation_bike': data.tutor.transportation_bike,
    'transportation_scooters': data.tutor.transportation_scooters,
    'transportation_bicycle': data.tutor.transportation_bicycle,
    'transportation_train': data.tutor.transportation_train,
    'transportation_none': data.tutor.transportation_none,
    'nearest_station': data.tutor.nearest_station,
    'high_school_name': data.tutor.high_school_name,
    'high_school_club': data.tutor.high_school_club,
    'exam_s': data.tutor.exam_s,
    'exam_c': data.tutor.exam_c,
    'exam_k': data.tutor.exam_k,
    'exam_d': data.tutor.exam_d,
    'experience_tutor': data.tutor.experience_tutor,
    'experience_tutor_note': data.tutor.experience_tutor_note,
    'experience_cram': data.tutor.experience_cram,
    'experience_cram_note': data.tutor.experience_cram_note,
    'experience_none': data.tutor.experience_none,
    'medium': data.tutor.medium,
    'medium_note': data.tutor.medium_note,
    'published': data.tutor.published,
    'information': data.tutor.information,
    'impression': data.tutor.impression,
    'impression_note': data.tutor.impression_note,
    'training': data.tutor.training,
    'training_note': data.tutor.training_note,
    'ssk': data.tutor.ssk,
    'note': data.tutor.note
  }
  console.log(params)
  axios({
    method: 'post',
    params: params,
    url: getAPIURL() + '/api/v1/tutors/',
    withCredentials: true
  }).then(response => {
    tutor_id = response.data.id
    const params2 = {
      'tutor_id': tutor_id,
      'channel_id': data.tutor.medium,
      'registration_date': data.tutor.registration_date
    }
    console.log(params2)
    axios({
      method: 'post',
      params: params2,
      url: getAPIURL() + '/api/v1/tutor_channels/',
      withCredentials: true
    }).then(response => {
      axios({
        method: 'get',
        url: getAPIURL() + '/api/v1/tutors/search?limit=' + settings.LIMIT,
        withCredentials: true
      }).then(response => {
        store.state.list.tutors = response.data.tutor
        data.reset()
        // alert('先生情報を登録しました')
        console.log(tutor_id)
        data.this.$router.push({name: 'tutorindex', params: { id: tutor_id }})
      }).catch(error => {
        console.log(error)
        alert('先生情報を登録できませんした。')
        store.dispatch('loginState')
      })
    }).catch(error => {
      console.log(error)
      alert('先生情報を登録できませんした。')
      store.dispatch('loginState')
    })
  }).catch(error => {
    console.log(error)
    alert('先生情報を登録できませんした。')
    store.dispatch('loginState')
  })
  //   }).catch(error => {
  //     console.log(error)
  //     alert('先生情報を登録できませんした。')
  //     store.dispatch('loginState')
  //   })
  // } else {
  //   return
  // }
}

export const patchTutor = ({ commit }, data) => {
  // let url = 'http://maps.googleapis.com/maps/api/geocode/json?address=' + data.geometry + data.tutor.address1
  // console.log(url)
  // axios({
  //   method: 'get',
  //   url: url
  //   // withCredentials: true
  // }).then(response => {
  //   console.log(data)
  //   if (response.data.results.length === 0) {
  //     alert('Google Mapから住所を取得できませんでした。\n' + data.geometry + data.tutor.address1)
  //   }
  const params = {
    'office_id': data.tutor.office_id,
    'state': data.tutor.state,
    'registration_date': data.tutor.registration_date,
    'f_name': data.tutor.f_name,
    'l_name': data.tutor.l_name,
    'f_name_kana': data.tutor.f_name_kana,
    'l_name_kana': data.tutor.l_name_kana,
    'gender': data.tutor.gender,
    'birthday': data.tutor.birthday,
    'zip': data.tutor.zip,
    'pref': data.tutor.pref,
    'address1': data.tutor.address1,
    'address2': data.tutor.address2,
    // 'lat': response.data.results[0].geometry.location.lat,
    // 'lng': response.data.results[0].geometry.location.lng,
    'tel1': data.tutor.tel1,
    'tel2': data.tutor.tel2,
    'mail1': data.tutor.mail1,
    'mail2': data.tutor.mail2,
    'home_zip': data.tutor.home_zip,
    'home_pref': data.tutor.home_pref,
    'home_address1': data.tutor.home_address1,
    'home_address2': data.tutor.home_address2,
    'home_tel': data.tutor.home_tel,
    'school_stage': data.tutor.school_stage,
    'school_name': data.tutor.school_name,
    'department': data.tutor.department,
    'old_grade': data.tutor.old_grade,
    'grade_flag': data.tutor.grade_flag,
    'department_type': data.tutor.department_type,
    'club': data.tutor.club,
    'transportation_car': data.tutor.transportation_car,
    'transportation_bike': data.tutor.transportation_bike,
    'transportation_scooters': data.tutor.transportation_scooters,
    'transportation_bicycle': data.tutor.transportation_bicycle,
    'transportation_train': data.tutor.transportation_train,
    'transportation_none': data.tutor.transportation_none,
    'nearest_station': data.tutor.nearest_station,
    'high_school_name': data.tutor.high_school_name,
    'high_school_club': data.tutor.high_school_club,
    'exam_s': data.tutor.exam_s,
    'exam_c': data.tutor.exam_c,
    'exam_k': data.tutor.exam_k,
    'exam_d': data.tutor.exam_d,
    'experience_tutor': data.tutor.experience_tutor,
    'experience_tutor_note': data.tutor.experience_tutor_note,
    'experience_cram': data.tutor.experience_cram,
    'experience_cram_note': data.tutor.experience_cram_note,
    'experience_none': data.tutor.experience_none,
    'medium': data.tutor.medium,
    'medium_note': data.tutor.medium_note,
    'published': data.tutor.published,
    'information': data.tutor.information,
    'impression': data.tutor.impression,
    'impression_note': data.tutor.impression_note,
    'training': data.tutor.training,
    'training_note': data.tutor.training_note,
    'ssk': data.tutor.ssk,
    'note': data.tutor.note
  }
  console.log(params)
  axios({
    method: 'patch',
    params: params,
    url: getAPIURL() + '/api/v1/tutors/' + data.tutor.id,
    withCredentials: true
  }).then(response => {
    console.log(response)
    axios({
      method: 'get',
      url: getAPIURL() + '/api/v1/tutors/' + data.tutor.id,
      withCredentials: true
    }).then(response => {
      console.log(response)
      store.state.item.tutor = response.data
      data.edit_id.tutor_id = ''
    }).catch(error => {
      console.log(error)
      alert('先生情報を更新できませんでした。')
      store.dispatch('loginState')
    })
  }).catch(error => {
    console.log(error)
    alert('先生情報を更新できませんでした。')
    store.dispatch('loginState')
  })
  // }).catch(error => {
  //   console.log(error)
  //   alert('先生情報を更新できませんでした。')
  //   store.dispatch('loginState')
  // })
}

export const cancelTutor = ({ commit }, data) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/tutors/' + store.state.item.tutor.id,
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.item.tutor = response.data
    data.edit_id.tutor_id = ''
    // alert('editキャンセルしました')
  })
}

export const patchTutorNote = ({ commit }, data) => {
  function patch () {
    console.log('patch')
    const params = {
      'note': data.list.note
    }
    return axios({
      params: params,
      url: getAPIURL() + '/api/v1/tutors/' + data.list.id,
      method: 'patch',
      withCredentials: true
    })
  }

  function get () {
    console.log('get')
    return axios({
      // url: getAPIURL() + '/api/v1/tutors/search?limit=' + settings.LIMIT,
      url: data.obj.searchUrl,
      method: 'get',
      withCredentials: true
    })
  }

  function stop (e) {
    // console.log(e) // console.logどうやって出すん？
    throw e
  }

  function error (e) {
    // console.log(e) // console.logどうやって出すん？
    alert('エラーです')
  }

  // if (window.confirm('先生リストを更新しますか？')) {
  patch().catch(stop).then(get).catch(stop).then(response => {
    store.state.list.tutors = response.data.tutor
    // alert('先生リストを更新しました')
  }).catch(error)
  // } else {
  //   return
  // }
}

export const deleteStudent = ({ commit }, data) => {
  console.log(data)
  if (window.confirm('生徒情報を削除しますか？')) {
    axios({
      method: 'delete',
      url: getAPIURL() + '/api/v1/students/' + data.student.id,
      withCredentials: true
    }).then(response => {
      console.log(response)
      axios({
        method: 'get',
        url: getAPIURL() + '/api/v1/students/search?limit=' + settings.LIMIT,
        withCredentials: true
      }).then(response => {
        console.log(response)
        store.state.list.students = response.data.student
        data.this.$router.push({name: 'studentsindex'})
        alert('生徒情報を削除しました')
      }).catch(error => {
        console.log(error)
        alert('生徒情報を削除できませんでした。')
        store.dispatch('loginState')
      })
    }).catch(error => {
      console.log(error)
      alert('生徒情報を削除できませんでした。')
      store.dispatch('loginState')
    })
  } else {
    return
  }
}

export const deleteStudentTutor = ({ commit }, list) => {
  if (window.confirm('本当に削除しますか？(先生のデータは削除されません。)')) {
    axios({
      method: 'delete',
      url: getAPIURL() + '/api/v1/student_tutors/' + list.id,
      withCredentials: true
    }).then(response => {
      console.log(response)
      axios({
        method: 'get',
        url: getAPIURL() + '/api/v1/students/' + store.state.item.student.id,
        withCredentials: true
      }).then(response => {
        console.log(response)
        store.state.item.student = response.data
        alert('探しデータを削除しました')
      }).catch(error => {
        console.log(error)
        alert('探しデータを削除できませんでした。')
        store.dispatch('loginState')
      })
    }).catch(error => {
      console.log(error)
      alert('探しデータを削除できませんでした。')
      store.dispatch('loginState')
    })
  } else {
    return
  }
}

export const deleteTutor = ({ commit }, data) => {
  console.log(data)
  if (window.confirm('先生情報を削除しますか？')) {
    axios({
      method: 'delete',
      url: getAPIURL() + '/api/v1/tutors/' + data.tutor.id,
      withCredentials: true
    }).then(response => {
      console.log(response)
      axios({
        method: 'get',
        url: getAPIURL() + '/api/v1/tutors/search?limit=' + settings.LIMIT,
        withCredentials: true
      }).then(response => {
        console.log(response)
        store.state.list.tutors = response.data.tutor
        data.this.$router.push({name: 'tutorsindex'})
        alert('先生情報を削除しました')
      }).catch(error => {
        console.log(error)
        alert('先生情報を削除できませんでした。')
        store.dispatch('loginState')
      })
    }).catch(error => {
      console.log(error)
      alert('先生情報を削除できませんでした。')
      store.dispatch('loginState')
    })
  } else {
    return
  }
}

export const deleteTutorStudent = ({ commit }, list) => {
  if (window.confirm('紐付けを削除しますか？(生徒のデータは削除されません。)')) {
    axios({
      method: 'delete',
      url: getAPIURL() + '/api/v1/student_tutors/' + list.id,
      withCredentials: true
    }).then(response => {
      console.log(response)
      axios({
        method: 'get',
        url: getAPIURL() + '/api/v1/tutors/' + store.state.item.tutor.id,
        withCredentials: true
      }).then(response => {
        console.log(response)
        store.state.item.tutor = response.data
        alert('紐付けを削除しました')
      }).catch(error => {
        console.log(error)
        alert('紐付けを削除できませんでした。')
        store.dispatch('loginState')
      })
    }).catch(error => {
      console.log(error)
      alert('紐付けを削除できませんでした。')
      store.dispatch('loginState')
    })
  } else {
    return
  }
}

export const getTutorsupports = ({ commit }) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/tutorsupports/search?limit=' + settings.LIMIT,
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.list.tutorsupports = response.data.tutorsupport
  }).catch(error => {
    console.log(error)
    // alert('getTutorsupportsに失敗しました')
    store.dispatch('loginState')
  })
}

export const cancelTutorsupport = ({ commit }, data) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/tutors/' + store.state.item.tutor.id,
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.item.tutor = response.data
    data.edit_id.list_id = ''
    // alert("キャンセルしました")
  }).catch(error => {
    console.log(error)
    // alert('get失敗しました')
    store.dispatch('loginState')
  })
}

export const patchTutorsupport = ({ commit }, data) => {
  const params = {
    // 'user_id': store.state.item.user.id,
    'tutor_id': store.state.item.tutor.id,
    'support_date': moment(data.patch.support_date).format(),
    'note': data.list.note
  }
  axios({
    method: 'patch',
    params: params,
    url: getAPIURL() + '/api/v1/tutorsupports/' + data.list.id,
    withCredentials: true
  }).then(response => {
    console.log(response)
    axios({
      method: 'get',
      url: getAPIURL() + '/api/v1/tutors/' + store.state.item.tutor.id,
      withCredentials: true
    }).then(response => {
      console.log(response)
      store.state.item.tutor = response.data
      data.edit_id.list_id = ''
      // alert('対応履歴を更新しました。')
    }).catch(error => {
      console.log(error)
      alert('対応履歴を更新できませんでした。')
      store.dispatch('loginState')
    })
  }).catch(error => {
    console.log(error)
    alert('対応履歴を更新できませんでした。')
    store.dispatch('loginState')
  })
}

export const deleteTutorsupport = ({ commit }, list) => {
  if (window.confirm('対応履歴を削除しますか？')) {
    axios({
      method: 'delete',
      url: getAPIURL() + '/api/v1/tutorsupports/' + list.id,
      withCredentials: true
    }).then(response => {
      console.log(response)
      axios({
        method: 'get',
        url: getAPIURL() + '/api/v1/tutors/' + store.state.item.tutor.id,
        withCredentials: true
      }).then(response => {
        console.log(response)
        store.state.item.tutor = response.data
        alert('対応履歴を削除しました。')
      }).catch(error => {
        console.log(error)
        alert('対応履歴を削除できませんでした。')
        store.dispatch('loginState')
      })
    }).catch(error => {
      console.log(error)
      alert('対応履歴を削除できませんでした。')
      store.dispatch('loginState')
    })
  } else {
    return
  }
}

export const getTutorfiles = ({ commit }) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/tutorfiles/search?limit=' + settings.LIMIT,
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.list.tutorfiles = response.data.tutorfile
  }).catch(error => {
    console.log(error)
    // alert('getTutorfilesに失敗しました')
    store.dispatch('loginState')
  })
}

export const getTutorfile = ({ commit }, data) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/tutorfiles/' + data.id,
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.item.tutorfile = response.data.tutorfile
  }).catch(error => {
    console.log(error)
    // alert('getTutorfileに失敗しました')
    store.dispatch('loginState')
  })
}

export const getTags = ({ commit }) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/tags/search?limit=' + settings.LIMIT,
    withCredentials: true
  }).then(response => {
    // console.log(response)
    store.state.list.tags = response.data.tag
  }).catch(error => {
    console.log(error)
    // alert('getTagsに失敗しました')
    store.dispatch('loginState')
  })
}

export const getTag = ({ commit }, id) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/tags/' + id,
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.item.tag = response.data
  }).catch(error => {
    console.log(error)
    // alert('getTagに失敗しました')
    store.dispatch('loginState')
  })
}

export const postTag = ({ commit }, data) => {
  // if (window.confirm('タグを追加しますか？')) {
  console.log(data)
  const params = {
    'name': data.add.name,
    'color': data.color
  }
  axios({
    method: 'post',
    params: params,
    url: getAPIURL() + '/api/v1/tags/',
    withCredentials: true
  }).then(response => {
    console.log(response)
    axios({
      method: 'get',
      url: getAPIURL() + '/api/v1/tags/search?limit=' + settings.LIMIT,
      withCredentials: true
    }).then(response => {
      console.log(response)
      store.state.list.tags = response.data.tag
      data.add.name = ''
      data.color = ''
      // alert('タグを追加しました。')
    }).catch(error => {
      console.log(error)
      alert('タグを追加できませんでした。')
      store.dispatch('loginState')
    })
  }).catch(error => {
    console.log(error)
    alert('タグを追加できませんでした。')
    store.dispatch('loginState')
  })
  // } else {
  //   return
  // }
}

export const deleteTag = ({ commit }, list) => {
  if (window.confirm('本当に削除しますか？(既存の対応履歴のタグも解除されます。)')) {
    axios({
      method: 'delete',
      url: getAPIURL() + '/api/v1/tags/' + list.id,
      withCredentials: true
    }).then(response => {
      console.log(response)
      axios({
        method: 'get',
        url: getAPIURL() + '/api/v1/tags/search?limit=' + settings.LIMIT,
        withCredentials: true
      }).then(response => {
        console.log(response)
        store.state.list.tags = response.data.tag
        alert('タグを削除しました。')
      }).catch(error => {
        console.log(error)
        alert('タグを削除できませんでした。')
        store.dispatch('loginState')
      })
    }).catch(error => {
      console.log(error)
      alert('タグを削除できませんでした。')
      store.dispatch('loginState')
    })
  } else {
    return
  }
}

export const cancelTag = ({ commit }, data) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/tags/search?limit=' + settings.LIMIT,
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.item.tag = response.data
    data.edit_id.edit_id = ''
    // alert('キャンセルしました')
  }).catch(error => {
    console.log(error)
    // alert('get失敗しました')
    store.dispatch('loginState')
  })
}

export const patchTag = ({ commit }, data) => {
  if (window.confirm('本当に更新しますか？(既存の対応履歴のタグも更新されます。)')) {
    const params = {
      'name': data.list.name,
      'color': data.list.color
    }
    axios({
      method: 'patch',
      params: params,
      url: getAPIURL() + '/api/v1/tags/' + data.list.id,
      withCredentials: true
    }).then(response => {
      console.log(response)
      store.state.item.tag = response.data
      data.edit_id.edit_id = ''
      // alert('タグを更新しました。')
    }).catch(error => {
      console.log(error)
      alert('タグを更新できませんでした。')
      store.dispatch('loginState')
    })
  } else {
    return
  }
}

export const getSupport_tags = ({ commit }) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/support_tags/search?limit=' + settings.LIMIT,
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.list.support_tags = response.data.support_tag
  }).catch(error => {
    console.log(error)
    // alert('getSupport_tagsに失敗しました')
    store.dispatch('loginState')
  })
}

export const getSupport_tag = ({ commit }, id) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/support_tags/' + id,
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.item.support_tag = response.data
  }).catch(error => {
    console.log(error)
    // alert('getSupport_tagに失敗しました')
    store.dispatch('loginState')
  })
}

export const postSupportTag = ({ commit }, data) => {
  console.log(data)
  console.log(data.this.$route)
  // if (window.confirm('タグを追加しますか？')) {
  let params
  if (/appointmentindex/.test(data.this.$route.name)) {
    params = {
      'familysupport_id': data.list.id,
      'tutorsupport_id': null,
      'user_id': store.state.item.user.id,
      'tag_id': data.tag.id
    }
  } else if (/agreementindex/.test(data.this.$route.name)) {
    params = {
      'agreementsupport_id': data.list.id,
      'user_id': store.state.item.user.id,
      'tag_id': data.tag.id
    }
  } else if (/familyindex/.test(data.this.$route.name)) {
    params = {
      'familysupport_id': data.list.id,
      'tutorsupport_id': null,
      'user_id': store.state.item.user.id,
      'tag_id': data.tag.id
    }
  } else if (/studentindex/.test(data.this.$route.name)) {
    params = {
      'familysupport_id': data.list.id,
      'tutorsupport_id': null,
      'user_id': store.state.item.user.id,
      'tag_id': data.tag.id
    }
  } else if (/tutorindex/.test(data.this.$route.name)) {
    params = {
      'familysupport_id': null,
      'tutorsupport_id': data.list.id,
      'user_id': store.state.item.user.id,
      'tag_id': data.tag.id
    }
  } else if (/appointmenthistory/.test(data.this.$route.name)) {
    params = {
      'familysupport_id': data.list.id,
      'tutorsupport_id': null,
      'user_id': store.state.item.user.id,
      'tag_id': data.tag.id
    }
  } else if (/agreementhistory/.test(data.this.$route.name)) {
    params = {
      'agreementsupport_id': data.list.id,
      'user_id': store.state.item.user.id,
      'tag_id': data.tag.id
    }
  } else if (/familyhistory/.test(data.this.$route.name)) {
    params = {
      'familysupport_id': data.list.id,
      'tutorsupport_id': null,
      'user_id': store.state.item.user.id,
      'tag_id': data.tag.id
    }
  } else if (/studenthistory/.test(data.this.$route.name)) {
    params = {
      'familysupport_id': data.list.id,
      'tutorsupport_id': null,
      'user_id': store.state.item.user.id,
      'tag_id': data.tag.id
    }
  } else if (/tutorhistory/.test(data.this.$route.name)) {
    params = {
      'familysupport_id': null,
      'tutorsupport_id': data.list.id,
      'user_id': store.state.item.user.id,
      'tag_id': data.tag.id
    }
  }
  axios({
    method: 'post',
    params: params,
    url: getAPIURL() + '/api/v1/support_tags/',
    withCredentials: true
  }).then(response => {
    console.log(response)
    let url
    if (/appointmentindex/.test(data.this.$route.name)) {
      url = getAPIURL() + '/api/v1/appointments/' + store.state.item.appointment.id
    } else if (/agreementindex/.test(data.this.$route.name)) {
      url = getAPIURL() + '/api/v1/agreements/' + store.state.item.agreement.id
    } else if (/familyindex/.test(data.this.$route.name)) {
      url = getAPIURL() + '/api/v1/families/' + store.state.item.family.id
    } else if (/studentindex/.test(data.this.$route.name)) {
      url = getAPIURL() + '/api/v1/students/' + store.state.item.student.id
    } else if (/tutorindex/.test(data.this.$route.name)) {
      url = getAPIURL() + '/api/v1/tutors/' + store.state.item.tutor.id
    } else if (/appointmenthistory/.test(data.this.$route.name)) {
      url = getAPIURL() + '/api/v1/appointments/' + store.state.item.appointment.id
    } else if (/agreementhistory/.test(data.this.$route.name)) {
      url = getAPIURL() + '/api/v1/agreements/' + store.state.item.agreement.id
    } else if (/familyhistory/.test(data.this.$route.name)) {
      url = getAPIURL() + '/api/v1/families/' + store.state.item.family.id
    } else if (/studenthistory/.test(data.this.$route.name)) {
      url = getAPIURL() + '/api/v1/students/' + store.state.item.student.id
    } else if (/tutorhistory/.test(data.this.$route.name)) {
      url = getAPIURL() + '/api/v1/tutors/' + store.state.item.tutor.id
    }
    axios({
      method: 'get',
      url: url,
      withCredentials: true
    }).then(response => {
      console.log(response)
      if (/appointmentindex/.test(data.this.$route.name)) {
        store.state.item.appointment = response.data
      } else if (/agreementindex/.test(data.this.$route.name)) {
        store.state.item.agreement = response.data
      } else if (/familyindex/.test(data.this.$route.name)) {
        store.state.item.family = response.data
      } else if (/studentindex/.test(data.this.$route.name)) {
        store.state.item.student = response.data
      } else if (/tutorindex/.test(data.this.$route.name)) {
        store.state.item.tutor = response.data
      } else if (/appointmenthistory/.test(data.this.$route.name)) {
        store.state.item.appointment = response.data
      } else if (/agreementhistory/.test(data.this.$route.name)) {
        store.state.item.agreement = response.data
      } else if (/familyhistory/.test(data.this.$route.name)) {
        store.state.item.family = response.data
      } else if (/studenthistory/.test(data.this.$route.name)) {
        store.state.item.student = response.data
      } else if (/tutorhistory/.test(data.this.$route.name)) {
        store.state.item.tutor = response.data
      }
      // alert('タグを追加しました。')
    }).catch(error => {
      console.log(error)
      alert('タグを追加できませんでした。')
      store.dispatch('loginState')
    })
  }).catch(error => {
    console.log(error)
    alert('タグを追加できませんでした。')
    store.dispatch('loginState')
  })
  // } else {
  //   return
  // }
}

export const deleteSupportTag = ({ commit }, data) => {
  console.log(data)
  console.log(data.this.$route)
  if (window.confirm('タグを解除しますか？')) {
    axios({
      method: 'delete',
      url: getAPIURL() + '/api/v1/support_tags/' + data.list.id,
      withCredentials: true
    }).then(response => {
      console.log(response)
      let url
      if (/appointmentindex/.test(data.this.$route.name)) {
        url = getAPIURL() + '/api/v1/appointments/' + store.state.item.appointment.id
      } else if (/agreementindex/.test(data.this.$route.name)) {
        url = getAPIURL() + '/api/v1/agreements/' + store.state.item.agreement.id
      } else if (/familyindex/.test(data.this.$route.name)) {
        url = getAPIURL() + '/api/v1/families/' + store.state.item.family.id
      } else if (/studentindex/.test(data.this.$route.name)) {
        url = getAPIURL() + '/api/v1/students/' + store.state.item.student.id
      } else if (/tutorindex/.test(data.this.$route.name)) {
        url = getAPIURL() + '/api/v1/tutors/' + store.state.item.tutor.id
      } else if (/appointmenthistory/.test(data.this.$route.name)) {
        url = getAPIURL() + '/api/v1/appointments/' + store.state.item.appointment.id
      } else if (/agreementhistory/.test(data.this.$route.name)) {
        url = getAPIURL() + '/api/v1/agreements/' + store.state.item.agreement.id
      } else if (/familyhistory/.test(data.this.$route.name)) {
        url = getAPIURL() + '/api/v1/families/' + store.state.item.family.id
      } else if (/studenthistory/.test(data.this.$route.name)) {
        url = getAPIURL() + '/api/v1/students/' + store.state.item.student.id
      } else if (/tutorhistory/.test(data.this.$route.name)) {
        url = getAPIURL() + '/api/v1/tutors/' + store.state.item.tutor.id
      }
      axios({
        method: 'get',
        url: url,
        withCredentials: true
      }).then(response => {
        console.log(response)
        if (/appointmentindex/.test(data.this.$route.name)) {
          store.state.item.appointment = response.data
        } else if (/agreementindex/.test(data.this.$route.name)) {
          store.state.item.agreement = response.data
        } else if (/familyindex/.test(data.this.$route.name)) {
          store.state.item.family = response.data
        } else if (/studentindex/.test(data.this.$route.name)) {
          store.state.item.student = response.data
        } else if (/tutorindex/.test(data.this.$route.name)) {
          store.state.item.tutor = response.data
        } else if (/appointmenthistory/.test(data.this.$route.name)) {
          store.state.item.appointment = response.data
        } else if (/agreementhistory/.test(data.this.$route.name)) {
          store.state.item.agreement = response.data
        } else if (/familyhistory/.test(data.this.$route.name)) {
          store.state.item.family = response.data
        } else if (/studenthistory/.test(data.this.$route.name)) {
          store.state.item.student = response.data
        } else if (/tutorhistory/.test(data.this.$route.name)) {
          store.state.item.tutor = response.data
        }
        // alert('タグを解除しました。')
      }).catch(error => {
        console.log(error)
        alert('タグを解除できませんでした。')
        store.dispatch('loginstate')
      })
    }).catch(error => {
      console.log(error)
      alert('タグを解除できませんでした。')
      store.dispatch('loginstate')
    })
  } else {
    return
  }
}

export const postAgreementTag = ({ commit }, data) => {
  console.log(data)
  console.log(data.this.$route)
  let params
  if (/agreementindex/.test(data.this.$route.name)) {
    params = {
      'agreement_id': store.state.item.agreement.id,
      'tag_id': data.tag.id
    }
  } else {
    return
  }
  axios({
    method: 'post',
    params: params,
    url: getAPIURL() + '/api/v1/agreement_tags/',
    withCredentials: true
  }).then(response => {
    console.log(response)
    let url
    if (/agreementindex/.test(data.this.$route.name)) {
      url = getAPIURL() + '/api/v1/agreements/' + store.state.item.agreement.id
    } else {
      return
    }
    axios({
      method: 'get',
      url: url,
      withCredentials: true
    }).then(response => {
      console.log(response)
      if (/agreementindex/.test(data.this.$route.name)) {
        store.state.item.agreement = response.data
      } else {
        return
      }
    }).catch(error => {
      console.log(error)
      alert('タグを追加できませんでした。')
      store.dispatch('loginState')
    })
  }).catch(error => {
    console.log(error)
    alert('タグを追加できませんでした。')
    store.dispatch('loginState')
  })
}

export const deleteAgreementTag = ({ commit }, data) => {
  console.log(data)
  console.log(data.this.$route)
  if (window.confirm('タグを解除しますか？')) {
    axios({
      method: 'delete',
      url: getAPIURL() + '/api/v1/agreement_tags/' + data.list.id,
      withCredentials: true
    }).then(response => {
      console.log(response)
      let url
      if (/agreementindex/.test(data.this.$route.name)) {
        url = getAPIURL() + '/api/v1/agreements/' + store.state.item.agreement.id
      } else {
        return
      }
      axios({
        method: 'get',
        url: url,
        withCredentials: true
      }).then(response => {
        console.log(response)
        if (/agreementindex/.test(data.this.$route.name)) {
          store.state.item.agreement = response.data
        } else {
          return
        }
      }).catch(error => {
        console.log(error)
        alert('タグを解除できませんでした。')
        store.dispatch('loginstate')
      })
    }).catch(error => {
      console.log(error)
      alert('タグを解除できませんでした。')
      store.dispatch('loginstate')
    })
  } else {
    return
  }
}

export const getChannels = ({ commit }) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/channels/search?limit=' + settings.LIMIT,
    withCredentials: true
  }).then(response => {
    // console.log(response)
    store.state.list.channels = response.data.channel
  }).catch(error => {
    console.log(error)
    // alert('getChannelsに失敗しました')
    store.dispatch('loginState')
  })
}

export const getChannel = ({ commit }, id) => {
  console.log(id)
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/channels/' + id,
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.item.channel = response.data
  }).catch(error => {
    console.log(error)
    // alert('getChannelに失敗しました')
    store.dispatch('loginState')
  })
}

export const postChannel = ({ commit }, data) => {
  console.log(data)
  const params = {
    'name': data.name
  }
  axios({
    method: 'post',
    params: params,
    url: getAPIURL() + '/api/v1/channels/',
    withCredentials: true
  }).then(response => {
    console.log(response)
    axios({
      method: 'get',
      url: getAPIURL() + '/api/v1/channels/search?limit=' + settings.LIMIT,
      withCredentials: true
    }).then(response => {
      console.log(response)
      store.state.list.channels = response.data.channel
      data.name = ''
    }).catch(error => {
      console.log(error)
      alert('登録媒体を追加できませんでした。')
      store.dispatch('loginState')
    })
  }).catch(error => {
    console.log(error)
    alert('登録媒体を追加できませんでした。')
    store.dispatch('loginState')
  })
}

export const patchChannel = ({ commit }, data) => {
  console.log(data)
  const params = {
    'state': data.list.state,
    'name': data.list.name
  }
  axios({
    method: 'patch',
    params: params,
    url: getAPIURL() + '/api/v1/channels/' + data.list.id,
    withCredentials: true
  }).then(response => {
    console.log(response)
    axios({
      method: 'get',
      url: getAPIURL() + '/api/v1/channels/search?limit=' + settings.LIMIT,
      withCredentials: true
    }).then(response => {
      console.log(response)
      store.state.list.channels = response.data.channel
      data.edit_id.edit_id = ''
    }).catch(error => {
      console.log(error)
      alert('登録媒体を編集できませんでした。')
      store.dispatch('loginState')
    })
  }).catch(error => {
    console.log(error)
    alert('登録媒体を編集できませんでした。')
    store.dispatch('loginState')
  })
}

export const cancelChannel = ({ commit }, data) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/channels/search?limit=' + settings.LIMIT,
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.list.channels = response.data.channel
    data.edit_id.edit_id = ''
  }).catch(error => {
    console.log(error)
    // alert('get error')
    store.dispatch('loginState')
  })
}

export const deleteChannel = ({ commit }, list) => {
  if (window.confirm('本当に削除しますか？(既存の家庭教師に紐づいている登録媒体も削除されます。)')) {
    axios({
      method: 'delete',
      url: getAPIURL() + '/api/v1/channels/' + list.id,
      withCredentials: true
    }).then(response => {
      console.log(response)
      axios({
        method: 'get',
        url: getAPIURL() + '/api/v1/channels/search?limit=' + settings.LIMIT,
        withCredentials: true
      }).then(response => {
        console.log(response)
        store.state.list.channels = response.data.channel
        alert('登録媒体を削除しました。')
      }).catch(error => {
        console.log(error)
        alert('登録媒体を削除できませんでした。')
        store.dispatch('loginState')
      })
    }).catch(error => {
      console.log(error)
      alert('登録媒体を削除できませんでした。')
      store.dispatch('loginState')
    })
  } else {
    return
  }
}

export const getOffice_channels = ({ commit }) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/office_channels/search',
    withCredentials: true
  }).then(response => {
    // console.log(response)
    store.state.list.office_channels = response.data.office_channel
  }).catch(error => {
    console.log(error)
    // alert('getOffice_channelsに失敗しました')
    store.dispatch('loginState')
  })
}

export const getOffice_channel = ({ commit }, id) => {
  console.log(id)
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/office_channels/' + id,
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.item.office_channel = response.data
  }).catch(error => {
    console.log(error)
    // alert('getOffice_channelに失敗しました')
    store.dispatch('loginState')
  })
}

export const postOffice_channel = ({ commit }, data) => {
  console.log(data)
  const params = {
    'office_id': data.office_channel.office_id,
    'channel_id': data.office_channel.channel_id,
    'state': data.office_channel.state
  }
  axios({
    method: 'post',
    params: params,
    url: getAPIURL() + '/api/v1/office_channels/',
    withCredentials: true
  }).then(response => {
    console.log(response)
    axios({
      method: 'get',
      url: getAPIURL() + '/api/v1/office_channels/search',
      withCredentials: true
    }).then(response => {
      console.log(response)
      store.state.list.office_channels = response.data.office_channel
      data.reset_date()
    }).catch(error => {
      console.log(error)
      alert('登録媒体を追加できませんでした。')
      store.dispatch('loginState')
    })
  }).catch(error => {
    console.log(error)
    alert('登録媒体を追加できませんでした。')
    store.dispatch('loginState')
  })
}

export const patchOffice_channel = ({ commit }, data) => {
  console.log(data)
  const params = {
    'state': data.list.state,
    'office_id': data.list.office_id,
    'channel_id': data.list.channel_id
  }
  axios({
    method: 'patch',
    params: params,
    url: getAPIURL() + '/api/v1/office_channels/' + data.list.id,
    withCredentials: true
  }).then(response => {
    console.log(response)
    axios({
      method: 'get',
      url: getAPIURL() + '/api/v1/office_channels/search',
      withCredentials: true
    }).then(response => {
      console.log(response)
      store.state.list.office_channels = response.data.office_channel
      data.edit_id.edit_id = ''
    }).catch(error => {
      console.log(error)
      alert('登録媒体を編集できませんでした。')
      store.dispatch('loginState')
    })
  }).catch(error => {
    console.log(error)
    alert('登録媒体を編集できませんでした。')
    store.dispatch('loginState')
  })
}

export const cancelOffice_channel = ({ commit }, data) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/office_channels/search',
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.list.office_channels = response.data.office_channel
    data.edit_id.edit_id = ''
  }).catch(error => {
    console.log(error)
    // alert('get error')
    store.dispatch('loginState')
  })
}

export const deleteOffice_channel = ({ commit }, list) => {
  if (window.confirm('本当に削除しますか？')) {
    axios({
      method: 'delete',
      url: getAPIURL() + '/api/v1/office_channels/' + list.id,
      withCredentials: true
    }).then(response => {
      console.log(response)
      axios({
        method: 'get',
        url: getAPIURL() + '/api/v1/office_channels/search',
        withCredentials: true
      }).then(response => {
        console.log(response)
        store.state.list.office_channels = response.data.office_channel
        alert('登録媒体を削除しました。')
      }).catch(error => {
        console.log(error)
        alert('登録媒体を削除できませんでした。')
        store.dispatch('loginState')
      })
    }).catch(error => {
      console.log(error)
      alert('登録媒体を削除できませんでした。')
      store.dispatch('loginState')
    })
  } else {
    return
  }
}

export const getAppointment_channels = ({ commit }) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/appointment_channels/search?limit=' + settings.LIMIT,
    withCredentials: true
  }).then(response => {
    // console.log(response)
    store.state.list.appointment_channels = response.data.appointment_channel
  }).catch(error => {
    console.log(error)
    // alert('getAppointment_channelsに失敗しました')
    store.dispatch('loginState')
  })
}

export const getAppointment_channel = ({ commit }, id) => {
  console.log(id)
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/appointment_channels/' + id,
    withCredentials: true
  }).then(response => {
    // console.log(response)
    store.state.item.appointment_channel = response.data
  }).catch(error => {
    console.log(error)
    // alert('getAppointment_channelに失敗しました')
    store.dispatch('loginState')
  })
}

export const getTutor_channels = ({ commit }) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/tutor_channels/search?limit=' + settings.LIMIT,
    withCredentials: true
  }).then(response => {
    // console.log(response)
    store.state.list.tutor_channels = response.data.tutor_channel
    store.state.max = response.data.max
  }).catch(error => {
    console.log(error)
    // alert('getTutor_channelsに失敗しました')
    store.dispatch('loginState')
  })
}

export const getTutor_channel = ({ commit }, id) => {
  console.log(id)
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/tutor_channels/' + id,
    withCredentials: true
  }).then(response => {
    // console.log(response)
    store.state.item.tutor_channel = response.data
  }).catch(error => {
    console.log(error)
    // alert('getTutor_channelに失敗しました')
    store.dispatch('loginState')
  })
}

export const postTutor_channel = ({ commit }, data) => {
  console.log(data)
  console.log(data.tutor_channel.channel_id)
  let params
  if (/tutor_channels/.test(data.this.$route.name)) {
    params = {
      'tutor_id': data.tutor_channel.tutor_id,
      'channel_id': data.tutor_channel.channel_id,
      'registration_date': data.tutor_channel.registration_date
    }
  } else if (/tutormedium/.test(data.this.$route.name)) {
    params = {
      'tutor_id': data.this.tutor.id,
      'channel_id': data.tutor_channel.channel_id,
      'registration_date': data.tutor_channel.registration_date
    }
  }
  axios({
    method: 'post',
    params: params,
    url: getAPIURL() + '/api/v1/tutor_channels/',
    withCredentials: true
  }).then(response => {
    console.log(response)
    let params
    if (/tutor_channels/.test(data.this.$route.name)) {
      params = {
        'registration_date': data.tutor_channel.registration_date
      }
    } else if (/tutormedium/.test(data.this.$route.name)) {
      params = {
        'registration_date': data.tutor_channel.registration_date
      }
    }
    let url
    if (/tutor_channels/.test(data.this.$route.name)) {
      url = getAPIURL() + '/api/v1/tutors/' + data.tutor_channel.tutor_id
    } else if (/tutormedium/.test(data.this.$route.name)) {
      url = getAPIURL() + '/api/v1/tutors/' + data.this.tutor.id
    }
    axios({
      method: 'patch',
      params: params,
      url: url,
      withCredentials: true
    }).then(response => {
      console.log(response)
      let url
      if (/tutor_channels/.test(data.this.$route.name)) {
        url = getAPIURL() + '/api/v1/tutor_channels/search?limit=' + settings.LIMIT
      } else if (/tutormedium/.test(data.this.$route.name)) {
        url = getAPIURL() + '/api/v1/tutors/' + data.this.tutor.id
      }
      axios({
        method: 'get',
        url: url,
        withCredentials: true
      }).then(response => {
        console.log(response)
        if (/tutor_channels/.test(data.this.$route.name)) {
          store.state.list.tutor_channels = response.data.tutor_channel
        } else if (/tutormedium/.test(data.this.$route.name)) {
          store.state.item.tutor = response.data
          data.watch.channel_id = ''
        }
        data.tutor_channel.tutor_id = ''
        data.tutor_channel.channel_id = ''
        data.tutor_channel.registration_date = ''
      }).catch(error => {
        console.log(error)
        alert('登録媒体を追加できませんでした。')
        store.dispatch('loginState')
      })
    }).catch(error => {
      console.log(error)
      alert('登録媒体を追加できませんでした。')
      store.dispatch('loginState')
    })
  }).catch(error => {
    console.log(error)
    alert('登録媒体を追加できませんでした。')
    store.dispatch('loginState')
  })
}

export const patchTutor_channel = ({ commit }, data) => {
  console.log(data)
  let params
  if (/tutor_channels/.test(data.this.$route.name)) {
    params = {
      'tutor_id': data.list.tutor_id,
      'channel_id': data.tutor_channel.channel_id,
      'registration_date': data.list.registration_date
    }
  } else if (/tutormedium/.test(data.this.$route.name)) {
    params = {
      'tutor_id': data.list.tutor_id,
      'channel_id': data.tutor_channel.channel_id,
      'registration_date': data.list.registration_date
    }
  }
  axios({
    method: 'patch',
    params: params,
    url: getAPIURL() + '/api/v1/tutor_channels/' + data.list.id,
    withCredentials: true
  }).then(response => {
    console.log(response)
    let url
    if (/tutor_channels/.test(data.this.$route.name)) {
      url = getAPIURL() + '/api/v1/tutor_channels/search?limit=' + settings.LIMIT
    } else if (/tutormedium/.test(data.this.$route.name)) {
      url = getAPIURL() + '/api/v1/tutors/' + data.this.tutor.id
    }
    axios({
      method: 'get',
      url: url,
      withCredentials: true
    }).then(response => {
      console.log(response)
      if (/tutor_channels/.test(data.this.$route.name)) {
        store.state.list.tutor_channels = response.data.tutor_channel
        data.edit_id.edit_id = ''
      } else if (/tutormedium/.test(data.this.$route.name)) {
        store.state.item.tutor = response.data
        data.edit_id.edit_id = ''
      }
    }).catch(error => {
      console.log(error)
      alert('登録媒体を編集できませんでした。')
      store.dispatch('loginState')
    })
  }).catch(error => {
    console.log(error)
    alert('登録媒体を編集できませんでした。')
    store.dispatch('loginState')
  })
}

export const cancelTutor_channel = ({ commit }, data) => {
  let url
  if (/tutor_channels/.test(data.this.$route.name)) {
    url = getAPIURL() + '/api/v1/tutor_channels/search?limit=' + settings.LIMIT
  } else if (/tutormedium/.test(data.this.$route.name)) {
    url = getAPIURL() + '/api/v1/tutors/' + data.this.tutor.id
  }
  axios({
    method: 'get',
    url: url,
    withCredentials: true
  }).then(response => {
    console.log(response)
    if (/tutor_channels/.test(data.this.$route.name)) {
      store.state.list.tutor_channels = response.data.tutor_channel
      data.edit_id.edit_id = ''
    } else if (/tutormedium/.test(data.this.$route.name)) {
      store.state.item.tutor = response.data
      data.edit_id.edit_id = ''
    }
  }).catch(error => {
    console.log(error)
    // alert('get error')
    store.dispatch('loginState')
  })
}

export const deleteTutor_channel = ({ commit }, data) => {
  if (window.confirm('本当に削除しますか？')) {
    axios({
      method: 'delete',
      url: getAPIURL() + '/api/v1/tutor_channels/' + data.list.id,
      withCredentials: true
    }).then(response => {
      console.log(response)
      let url
      if (/tutor_channels/.test(data.this.$route.name)) {
        url = getAPIURL() + '/api/v1/tutor_channels/search?limit=' + settings.LIMIT
      } else if (/tutormedium/.test(data.this.$route.name)) {
        url = getAPIURL() + '/api/v1/tutors/' + data.this.tutor.id
      }
      axios({
        method: 'get',
        url: url,
        withCredentials: true
      }).then(response => {
        console.log(response)
        if (/tutor_channels/.test(data.this.$route.name)) {
          store.state.list.tutor_channels = response.data.tutor_channel
        } else if (/tutormedium/.test(data.this.$route.name)) {
          store.state.item.tutor = response.data
        }
        alert('登録媒体を削除しました。')
      }).catch(error => {
        console.log(error)
        alert('登録媒体を削除できませんでした。')
        store.dispatch('loginState')
      })
    }).catch(error => {
      console.log(error)
      alert('登録媒体を削除できませんでした。')
      store.dispatch('loginState')
    })
  } else {
    return
  }
}

export const getAppointments = ({ commit }) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/appointments/search?limit=' + settings.LIMIT,
    withCredentials: true
  }).then(response => {
    // console.log(response)
    store.state.list.appointments = response.data.appointment
    store.state.max = response.data.max
  }).catch(error => {
    console.log(error)
    // alert('getAppointmentsに失敗しました')
    store.dispatch('loginState')
  })
}

export const getAppointmentsLimit0 = ({ commit }) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/appointments/search?limit=' + 0,
    withCredentials: true
  }).then(response => {
    // console.log(response)
    store.state.list.appointments = response.data.appointment
  }).catch(error => {
    console.log(error)
    // alert('getAppointmentsに失敗しました')
    store.dispatch('loginState')
  })
}

export const getAppointment = ({ commit }, id) => {
  console.log(id)
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/appointments/' + id,
    withCredentials: true
  }).then(response => {
    // console.log(response)
    store.state.item.appointment = response.data
  }).catch(error => {
    console.log(error)
    // alert('getAppointmentに失敗しました')
    store.dispatch('loginState')
  })
}

export const postAppointment = ({ commit }, data) => {
  console.log(data)
  let appointment_id
  // if (window.confirm('この内容で登録してもよろしいですか？')) {
  console.log(data)
  // let url = 'http://maps.googleapis.com/maps/api/geocode/json?address=' + data.appointment.geometry + data.appointment.address1
  // console.log(url)
  // axios({
  //   method: 'get',
  //   url: url
  //   // withCredentials: true
  // }).then(response => {
  //   console.log(data)
  //   console.log(response)
  //   if (response.data.results.length === 0) {
  //     alert('Google Mapから住所を取得できませんでした。\n' + data.appointment.geometry + data.appointment.address1)
  //   }
  const params = {
    'family_id': data.appointment.family_id,
    'state': data.appointment.state,
    'f_name': data.appointment.f_name,
    'l_name': data.appointment.l_name,
    'f_name_kana': data.appointment.f_name_kana,
    'l_name_kana': data.appointment.l_name_kana,
    'zip': data.appointment.zip,
    'pref': data.appointment.pref,
    'address1': data.appointment.address1,
    'address2': data.appointment.address2,
    // 'lat': response.data.results[0].geometry.location.lat,
    // 'lng': response.data.results[0].geometry.location.lng,
    'tel1': data.appointment.tel1,
    'tel2': data.appointment.tel2,
    'fax': data.appointment.fax,
    'mail': data.appointment.mail,
    'contact_date': data.appointment.contact_date,
    'support': data.appointment.support,
    'missing_detail': data.appointment.missing_detail,
    'contact_later': data.appointment.contact_later,
    'next_contact_date': data.appointment.next_contact_date,
    'next_contact_method': data.appointment.next_contact_method,
    'result': data.appointment.result,
    'acquisition_date': data.appointment.acquisition_date,
    'ap_type': data.appointment.ap_type,
    'medium1': data.appointment.mediumArray[0],
    'medium2': data.appointment.mediumArray[1],
    'medium3': data.appointment.mediumArray[2],
    'hp_type': data.appointment.hp_type,
    'gender': data.appointment.gender,
    'school_type': data.appointment.school_type,
    'school_stage': data.appointment.school_stage,
    'school_name': data.appointment.school_name,
    'grade': data.appointment.grade,
    'memo': data.appointment.memo,
    'dm': data.appointment.dm,
    'dm_information': data.appointment.dm_information,
    'shop_type': data.appointment.shop_type,
    'shop_name': data.appointment.shop_name,
    'contact_method': data.appointment.contact_method,
    'hp_browse': data.appointment.hp_browse,
    'visit_date': data.appointment.visit_date,
    'visit_time': data.appointment.visit_time,
    'request_of_day_of_week': data.appointment.request_of_day_of_week,
    'request_of_day_of_week_note': data.appointment.request_of_day_of_week_note,
    'person': data.appointment.person,
    'note': data.appointment.note,
    'sending_date': data.appointment.sending_date,
    'sending_time': data.appointment.sending_time,
    'contact_person': data.appointment.contact_person,
    'parking': data.appointment.parking,
    'parking_note': data.appointment.parking_note,
    'sub_f_name': data.appointment.sub_f_name,
    'sub_l_name': data.appointment.sub_l_name,
    'sub_f_name_kana': data.appointment.sub_f_name_kana,
    'sub_l_name_kana': data.appointment.sub_l_name_kana,
    'sub_grade': data.appointment.sub_grade,
    'sub_school_type': data.appointment.sub_school_type,
    'sub_school_stage': data.appointment.sub_school_stage,
    'sub_school_name': data.appointment.sub_school_name,
    'sub_gender': data.appointment.sub_gender,
    'achievement': data.appointment.achievement,
    'learning': data.appointment.learning,
    'learning_start_period': data.appointment.learning_start_period,
    'learning_nervous': data.appointment.learning_nervous,
    'learning_result': data.appointment.learning_result,
    'learning_continuation': data.appointment.learning_continuation,
    'sub_achievement': data.appointment.sub_achievement,
    'sub_learning': data.appointment.sub_learning,
    'sub_learning_start_period': data.appointment.sub_learning_start_period,
    'sub_learning_nervous': data.appointment.sub_learning_nervous,
    'sub_learning_result': data.appointment.sub_learning_result,
    'sub_learning_continuation': data.appointment.sub_learning_continuation,
    'attended': data.attended,
    'fathers_involvement': data.appointment.fathers_involvement,
    'notices': data.notices,
    'sending_products': data.sending_products,
    'sending_method': data.appointment.sending_method,
    'confirm_check': data.appointment.confirm_check,
    'preferred_contact': data.appointment.preferred_contact,
    'contact_timezone': data.appointment.contact_timezone,
    'transmission_item_company': data.appointment.transmission_item_company,
    'transmission_item_course': data.appointment.transmission_item_course,
    'transmission_item_visitor': data.appointment.transmission_item_visitor,
    'transmission_item_purpose': data.appointment.transmission_item_purpose,
    'transmission_item_requiredtime': data.appointment.transmission_item_requiredtime
  }
  console.log(params)
  axios({
    method: 'post',
    params: params,
    url: getAPIURL() + '/api/v1/appointments/',
    withCredentials: true
  }).then(response => {
    console.log(response)
    appointment_id = response.data.id
    axios({
      method: 'get',
      url: getAPIURL() + '/api/v1/appointments/search?limit=' + settings.LIMIT,
      withCredentials: true
    }).then(response => {
      console.log(response)
      store.state.list.appointments = response.data.appointment
      data.appointment.family_id = ''
      data.reset()
      data.this.$router.push({name: 'appointmentindex', params: { id: appointment_id }})
      alert('登録完了')
    }).catch(error => {
      console.log(error)
      alert('AP情報を登録できませんでした。')
      store.dispatch('loginState')
    })
  }).catch(error => {
    console.log(error)
    alert('AP情報を登録できませんでした。')
    store.dispatch('loginState')
  })
  //   }).catch(error => {
  //     console.log(error)
  //     alert('AP情報を登録できませんでした。')
  //     store.dispatch('loginState')
  //   })
  // } else {
  //   return
  // }
}

export const delAppointment = ({ commit }, appointment) => {
  if (window.confirm('AP情報を削除しますか？')) {
    axios({
      method: 'delete',
      url: getAPIURL() + '/api/v1/appointments/' + appointment.id,
      withCredentials: true
    }).then(response => {
      console.log(response)
      axios({
        method: 'get',
        url: getAPIURL() + '/api/v1/appointments/search?limit=' + settings.LIMIT,
        withCredentials: true
      }).then(response => {
        console.log(response)
        store.state.list.appointments = response.data.appointment
        alert('AP情報を削除しました。')
      }).catch(error => {
        console.log(error)
        alert('AP情報を削除できませんでした。')
        store.dispatch('loginState')
      })
    }).catch(error => {
      console.log(error)
      alert('AP情報を削除できませんでした。')
      store.dispatch('loginState')
    })
  } else {
    return
  }
}

export const deleteAppointment = ({ commit }, data) => {
  console.log(data)
  if (window.confirm('AP情報を削除しますか？')) {
    axios({
      method: 'delete',
      url: getAPIURL() + '/api/v1/appointments/' + data.appointment.id,
      withCredentials: true
    }).then(response => {
      console.log(response)
      axios({
        method: 'get',
        url: getAPIURL() + '/api/v1/appointments/search?limit=' + settings.LIMIT,
        withCredentials: true
      }).then(response => {
        console.log(response)
        store.state.list.appointments = response.data.appointment
        data.this.$router.push({name: 'appointmentsindex'})
        alert('AP情報を削除しました')
      }).catch(error => {
        console.log(error)
        alert('AP情報を削除できませんでした。')
        store.dispatch('loginState')
      })
    }).catch(error => {
      console.log(error)
      alert('AP情報を削除できませんでした。')
      store.dispatch('loginState')
    })
  } else {
    return
  }
}

export const deleteAppointmentFamily = ({ commit }, data) => {
  if (window.confirm('本当に削除しますか？(家庭のデータが削除されます。)')) {
    console.log(data)
    axios({
      method: 'delete',
      url: getAPIURL() + '/api/v1/families/' + data.id,
      withCredentials: true
    }).then(response => {
      console.log(response)
      axios({
        method: 'get',
        url: getAPIURL() + '/api/v1/appointments/' + store.state.item.appointment.id,
        withCredentials: true
      }).then(response => {
        console.log(response)
        store.state.item.appointment = response.data
        alert('家庭情報を削除しました。')
      }).catch(error => {
        console.log(error)
        alert('家庭情報を削除できませんでした。')
        store.dispatch('loginState')
      })
    }).catch(error => {
      console.log(error)
      alert('家庭情報を削除できませんでした。')
      store.dispatch('loginState')
    })
  } else {
    return
  }
}

export const patchAppointment = ({ commit }, data) => {
  console.log(data)
  // let url = 'http://maps.googleapis.com/maps/api/geocode/json?address=' + data.geometry + data.appointment.address1
  // console.log(url)
  // function getGeo () {
  //   return axios({
  //     method: 'get',
  //     url: url
  //     // withCredentials: true
  //   })
  // }
  function patch (response) {
    console.log(response)
    // if (response.data.results.length === 0) {
    //   alert('Google Mapから住所を取得できませんでした。\n' + data.geometry + data.appointment.address1)
    // }
    let params = {
      'family_id': data.appointment.family_id,
      'state': data.appointment.state,
      'f_name': data.appointment.f_name,
      'l_name': data.appointment.l_name,
      'f_name_kana': data.appointment.f_name_kana,
      'l_name_kana': data.appointment.l_name_kana,
      'zip': data.appointment.zip,
      'pref': data.appointment.pref,
      'address1': data.appointment.address1,
      'address2': data.appointment.address2,
      // 'lat': response.data.results[0].geometry.location.lat,
      // 'lng': response.data.results[0].geometry.location.lng,
      'tel1': data.appointment.tel1,
      'tel2': data.appointment.tel2,
      'fax': data.appointment.fax,
      'mail': data.appointment.mail,
      'contact_date': data.appointment.contact_date,
      'support': data.appointment.support,
      'missing_detail': data.appointment.missing_detail,
      'contact_later': data.appointment.contact_later,
      'next_contact_date': data.appointment.next_contact_date,
      'next_contact_method': data.appointment.next_contact_method,
      'result': data.appointment.result,
      'acquisition_date': data.appointment.acquisition_date,
      'ap_type': data.appointment.ap_type,
      'medium1': data.mediumArray[0],
      'medium2': data.mediumArray[1],
      'medium3': data.mediumArray[2],
      'hp_type': data.appointment.hp_type,
      'office_id': data.appointment.office_id,
      'gender': data.appointment.gender,
      'school_type': data.appointment.school_type,
      'school_stage': data.appointment.school_stage,
      'school_name': data.appointment.school_name,
      'grade': data.appointment.grade,
      'memo': data.appointment.memo,
      'dm': data.appointment.dm,
      'dm_information': data.appointment.dm_information,
      'shop_type': data.appointment.shop_type,
      'shop_name': data.appointment.shop_name,
      'contact_method': data.appointment.contact_method,
      'hp_browse': data.appointment.hp_browse,
      'visit_date': data.appointment.visit_date,
      'visit_time': data.appointment.visit_time,
      'next_visit_date': data.appointment.next_visit_date,
      'next_visit_time': data.appointment.next_visit_time,
      'request_of_day_of_week': data.appointment.request_of_day_of_week,
      'request_of_day_of_week_note': data.appointment.request_of_day_of_week_note,
      'person': data.appointment.person,
      'note': data.appointment.note,
      'sending_date': data.appointment.sending_date,
      'sending_time': data.appointment.sending_time,
      'contact_person': data.appointment.contact_person,
      'parking': data.appointment.parking,
      'parking_note': data.appointment.parking_note,
      'sub_f_name': data.appointment.sub_f_name,
      'sub_l_name': data.appointment.sub_l_name,
      'sub_f_name_kana': data.appointment.sub_f_name_kana,
      'sub_l_name_kana': data.appointment.sub_l_name_kana,
      'sub_grade': data.appointment.sub_grade,
      'sub_school_type': data.appointment.sub_school_type,
      'sub_school_stage': data.appointment.sub_school_stage,
      'sub_school_name': data.appointment.sub_school_name,
      'sub_gender': data.appointment.sub_gender,
      'achievement': data.appointment.achievement,
      'learning': data.appointment.learning,
      'learning_start_period': data.appointment.learning_start_period,
      'learning_nervous': data.appointment.learning_nervous,
      'learning_result': data.appointment.learning_result,
      'learning_continuation': data.appointment.learning_continuation,
      'sub_achievement': data.appointment.sub_achievement,
      'sub_learning': data.appointment.sub_learning,
      'sub_learning_start_period': data.appointment.sub_learning_start_period,
      'sub_learning_nervous': data.appointment.sub_learning_nervous,
      'sub_learning_result': data.appointment.sub_learning_result,
      'sub_learning_continuation': data.appointment.sub_learning_continuation,
      'attended': data.attended,
      'fathers_involvement': data.appointment.fathers_involvement,
      'notices': data.notices,
      'sending_products': data.sending_products,
      'sending_method': data.appointment.sending_method,
      'sending_check': data.appointment.sending_check,
      'confirm_check': data.appointment.confirm_check,
      'preferred_contact': data.appointment.preferred_contact,
      'contact_timezone': data.appointment.contact_timezone,
      'transmission_item_company': data.appointment.transmission_item_company,
      'transmission_item_course': data.appointment.transmission_item_course,
      'transmission_item_visitor': data.appointment.transmission_item_visitor,
      'transmission_item_purpose': data.appointment.transmission_item_purpose,
      'transmission_item_requiredtime': data.appointment.transmission_item_requiredtime
    }
    return axios({
      method: 'patch',
      params: params,
      url: getAPIURL() + '/api/v1/appointments/' + data.appointment.id,
      withCredentials: true
    })
  }
  function get (response) {
    console.log(response)
    return axios({
      method: 'get',
      url: getAPIURL() + '/api/v1/appointments/' + data.appointment.id,
      withCredentials: true
    })
  }
  function stop (e) {
    console.log(e)
    throw e
  }
  function error (e) {
    alert('エラーです')
  }
  // getGeo().catch(stop).then(patch).catch(stop).then(get).catch(stop).then(response => {
  patch().catch(stop).then(get).catch(stop).then(response => {
    store.state.item.appointment = response.data
    data.edit_id.appointment_id = ''
  }).catch(error)
}

export const patchConfirm = ({ commit }, data) => {
  console.log(data)
  function patch () {
    let params = {
      'sending_check': data.list.sending_check.value,
      'confirm_check': data.list.confirm_check.value
    }
    console.log(params)
    return axios({
      method: 'patch',
      params: params,
      url: getAPIURL() + '/api/v1/appointments/' + data.list.id,
      withCredentials: true
    })
  }
  function get (response) {
    console.log(response)
    return axios({
      method: 'get',
      url: getAPIURL() + '/api/v1/appointments/search?limit=' + settings.LIMIT,
      withCredentials: true
    })
  }
  function stop (e) {
    console.log(e)
    throw e
  }
  function error (e) {
    alert('エラーです')
  }
  patch().catch(stop).then(get).catch(stop).then(response => {
    // store.state.list.appointments = response.data.appointment
    alert('ok')
  }).catch(error)
}

export const cancelAppointment = ({ commit }, data) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/appointments/' + store.state.item.appointment.id,
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.item.appointment = response.data
    data.edit_id.appointment_id = ''
    // alert('editキャンセルしました')
  })
}

export const getTodos = ({ commit }) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/todos/search?limit=' + settings.LIMIT,
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.list.todos = response.data.todo
    store.state.max = response.data.max
  }).catch(error => {
    console.log(error)
    // alert('getTodosに失敗しました')
    store.dispatch('loginState')
  })
}

export const getTodo = ({ commit }, id) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/todos/' + id,
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.item.todo = response.data
  }).catch(error => {
    console.log(error)
    // alert('getTodoに失敗しました')
    store.dispatch('loginState')
  })
}

export const postTodo = ({ commit }, data) => {
  function post () {
    console.log(data.todo.state)
    console.log(data.todo.note)
    let params
    if (/todosindex/.test(data.this.$route.name)) {
      params = {
        'state': 0,
        'note': data.todo.note
      }
    }
    return axios({
      method: 'post',
      params: params,
      url: getAPIURL() + '/api/v1/todos',
      withCredentials: true
    })
  }
  let url
  if (/todosindex/.test(data.this.$route.name)) {
    url = getAPIURL() + '/api/v1/todos/search?limit=' + settings.LIMIT
  }
  function get () {
    return axios({
      method: 'get',
      url: url,
      withCredentials: true
    })
  }
  function stop (e) {
    throw e
  }
  function error (e) {
    alert('エラーです')
  }
  // if (window.confirm('Todoを追加しますか？')) {
  post().catch(stop).then(get).catch(stop).then(response => {
    store.state.list.todos = response.data.todo
    data.todo.state = ''
    data.todo.note = ''
    alert('Todoを追加しました。')
  }).catch(error)
  // } else {
  //   return alert('test')
  // }
}

export const deleteTodo = ({ commit }, data) => {
  if (window.confirm('本当に削除しますか？')) {
    axios({
      method: 'delete',
      url: getAPIURL() + '/api/v1/todos/' + data.list.id,
      withCredentials: true
    }).then(response => {
      console.log(response)
      axios({
        method: 'get',
        url: getAPIURL() + '/api/v1/todos/search?limit=' + settings.LIMIT,
        withCredentials: true
      }).then(response => {
        console.log(response)
        store.state.list.todos = response.data.todo
        alert('Todoを削除しました。')
      }).catch(error => {
        console.log(error)
        alert('Todoを削除できませんでした。')
        store.dispatch('loginState')
      })
    }).catch(error => {
      console.log(error)
      alert('Todoを削除できませんでした。')
      store.dispatch('loginState')
    })
  } else {
    return
  }
}

export const patchTodo = ({ commit }, data) => {
  console.log(data)
  function patch () {
    const params = {
      'state': data.list.state,
      'note': data.list.note
    }
    return axios({
      method: 'patch',
      params: params,
      url: getAPIURL() + '/api/v1/todos/' + data.list.id,
      withCredentials: true
    })
  }

  function get () {
    return axios({
      method: 'get',
      url: getAPIURL() + '/api/v1/todos/search?limit=' + settings.LIMIT,
      withCredentials: true
    })
  }

  function stop (e) {
    console.log(e)
    throw e
  }

  function error (e) {
    console.log(e)
    alert('エラーです')
  }

  patch().catch(stop).then(get).catch(stop).then(response => {
    store.state.list.todos = response.data.todo
  }).catch(error)
}

export const changeState = ({ commit }, data) => {
  console.log(data)
  function patch () {
    const params = {
      'state': data.list.state ? 0 : 1
    }
    return axios({
      method: 'patch',
      params: params,
      url: getAPIURL() + '/api/v1/todos/' + data.list.id,
      withCredentials: true
    })
  }

  function get () {
    return axios({
      method: 'get',
      url: getAPIURL() + '/api/v1/todos/search?limit=' + settings.LIMIT,
      withCredentials: true
    })
  }

  function stop (e) {
    console.log(e)
    throw e
  }

  function error (e) {
    console.log(e)
    alert('エラーです')
  }

  patch().catch(stop).then(get).catch(stop).then(response => {
    store.state.list.todos = response.data.todo
  }).catch(error)
}

export const getConditions = ({ commit }) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/conditions/search?limit=' + settings.LIMIT,
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.list.conditions = response.data.condition
  }).catch(error => {
    console.log(error)
    // alert('getConditionsに失敗しました')
    store.dispatch('loginState')
  })
}

export const getCondition = ({ commit }, id) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/conditions/' + id,
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.item.condition = response.data
  }).catch(error => {
    console.log(error)
    // alert('getConditionに失敗しました')
    store.dispatch('loginState')
  })
}

export const postCondition = ({ commit }, add) => {
  // if (window.confirm('条件を追加しますか？')) {
  const params = {
    'name': add.name
  }
  axios({
    method: 'post',
    params: params,
    url: getAPIURL() + '/api/v1/conditions/',
    withCredentials: true
  }).then(response => {
    console.log(response)
    axios({
      method: 'get',
      url: getAPIURL() + '/api/v1/conditions/search?limit=' + settings.LIMIT,
      withCredentials: true
    }).then(response => {
      console.log(response)
      store.state.list.conditions = response.data.condition
      add.name = ''
      // alert('条件を追加しました。')
    }).catch(error => {
      console.log(error)
      alert('条件を追加できませんでした。')
      store.dispatch('loginState')
    })
  }).catch(error => {
    console.log(error)
    alert('条件を追加できませんでした。')
    store.dispatch('loginState')
  })
  // } else {
  //   return
  // }
}

export const deleteCondition = ({ commit }, list) => {
  if (window.confirm('本当に削除しますか？')) {
    axios({
      method: 'delete',
      url: getAPIURL() + '/api/v1/conditions/' + list.id,
      withCredentials: true
    }).then(response => {
      console.log(response)
      axios({
        method: 'get',
        url: getAPIURL() + '/api/v1/conditions/search?limit=' + settings.LIMIT,
        withCredentials: true
      }).then(response => {
        console.log(response)
        store.state.list.conditions = response.data.condition
        alert('条件を削除しました。')
      }).catch(error => {
        console.log(error)
        alert('条件を削除できませんでした。')
        store.dispatch('loginState')
      })
    }).catch(error => {
      console.log(error)
      alert('条件を削除できませんでした。')
      store.dispatch('loginState')
    })
  } else {
    return
  }
}

export const editCondition = ({ commit }, data) => {
  console.log(data)
  axios({
    // multipatchの場合、編集、編集で押されると加工したオブジェクトが見えてしまう為get
    method: 'get',
    url: getAPIURL() + '/api/v1/conditions/search?limit=' + settings.LIMIT,
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.list.conditions = response.data.condition
    data.edit_id.edit_id = data.list.id
    // alert('キャンセルしました')
    store.dispatch('loginState')
  }).catch(error => {
    console.log(error)
    // alert('getに失敗しました')
    store.dispatch('loginState')
  })
}

export const cancelCondition = ({ commit }, data) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/conditions/search?limit=' + settings.LIMIT,
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.item.condition = response.data
    data.edit_id.edit_id = ''
  }).catch(error => {
    console.log(error)
    // alert('get失敗しました')
    store.dispatch('loginState')
  })
}

export const patchCondition = ({ commit }, data) => {
  // if (window.confirm('本当に更新しますか？')) {
  const params = {
    'name': data.list.name
  }
  axios({
    method: 'patch',
    params: params,
    url: getAPIURL() + '/api/v1/conditions/' + data.list.id,
    withCredentials: true
  }).then(response => {
    console.log(response)
    axios({
      method: 'get',
      url: getAPIURL() + '/api/v1/conditions/search?limit=' + settings.LIMIT,
      withCredentials: true
    }).then(response => {
      console.log(response)
      store.state.item.condition = response.data
      data.edit_id.edit_id = ''
      // alert('条件を更新しました｡')
    }).catch(error => {
      console.log(error)
      alert('条件を更新できませんでした。')
      store.dispatch('loginState')
    })
  }).catch(error => {
    console.log(error)
    alert('条件を更新できませんでした。')
    store.dispatch('loginState')
  })
  // } else {
  //   return
  // }
}

export const getStudent_conditions = ({ commit }) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/student_conditions/search?limit=' + settings.LIMIT,
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.list.student_conditions = response.data.student_condition
  }).catch(error => {
    console.log(error)
    // alert('getStudent_conditionsに失敗しました')
    store.dispatch('loginState')
  })
}

export const getStudent_condition = ({ commit }, id) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/student_conditions/' + id,
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.item.student_condition = response.data
  }).catch(error => {
    console.log(error)
    // alert('getStudent_conditionに失敗しました')
    store.dispatch('loginState')
  })
}

export const postStudent_condition = ({ commit }, add) => {
  // if (window.confirm('生徒条件を追加しますか？')) {
  const params = {
    'note': add.note
  }
  axios({
    method: 'post',
    params: params,
    url: getAPIURL() + '/api/v1/student_conditions/',
    withCredentials: true
  }).then(response => {
    console.log(response)
    axios({
      method: 'get',
      url: getAPIURL() + '/api/v1/student_conditions/search?limit=' + settings.LIMIT,
      withCredentials: true
    }).then(response => {
      console.log(response)
      store.state.list.student_conditions = response.data.student_condition
      add.name = ''
      // alert('生徒条件を追加しました。')
    }).catch(error => {
      console.log(error)
      alert('生徒条件を追加できませんでした。')
      store.dispatch('loginState')
    })
  }).catch(error => {
    console.log(error)
    alert('生徒条件を追加できませんでした。')
    store.dispatch('loginState')
  })
  // } else {
  //   return
  // }
}

export const deleteStudent_condition = ({ commit }, list) => {
  if (window.confirm('本当に削除しますか？')) {
    axios({
      method: 'delete',
      url: getAPIURL() + '/api/v1/student_conditions/' + list.id,
      withCredentials: true
    }).then(response => {
      console.log(response)
      axios({
        method: 'get',
        url: getAPIURL() + '/api/v1/student_conditions/search?limit=' + settings.LIMIT,
        withCredentials: true
      }).then(response => {
        console.log(response)
        store.state.list.student_conditions = response.data.student_condition
        alert('生徒条件を削除しました。')
      }).catch(error => {
        console.log(error)
        alert('生徒条件を削除できませんでした。')
        store.dispatch('loginState')
      })
    }).catch(error => {
      console.log(error)
      alert('生徒条件を削除できませんでした。')
      store.dispatch('loginState')
    })
  } else {
    return
  }
}

export const editStudent_condition = ({ commit }, data) => {
  console.log(data)
  axios({
    // multipatchの場合、編集、編集で押されると加工したオブジェクトが見えてしまう為get
    method: 'get',
    url: getAPIURL() + '/api/v1/student_conditions/search?limit=' + settings.LIMIT,
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.list.student_conditions = response.data.student_condition
    data.edit_id.edit_id = data.list.id
    // alert('キャンセルしました')
    store.dispatch('loginState')
  }).catch(error => {
    console.log(error)
    // alert('getに失敗しました')
    store.dispatch('loginState')
  })
}

export const cancelStudent_condition = ({ commit }, data) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/student_conditions/search?limit=' + settings.LIMIT,
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.item.student_condition = response.data
    data.edit_id.edit_id = ''
  }).catch(error => {
    console.log(error)
    // alert('get失敗しました')
    store.dispatch('loginState')
  })
}

export const patchStudent_condition = ({ commit }, data) => {
  // if (window.confirm('本当に更新しますか？')) {
  const params = {
    'note': data.list.note
  }
  axios({
    method: 'patch',
    params: params,
    url: getAPIURL() + '/api/v1/student_conditions/' + data.list.id,
    withCredentials: true
  }).then(response => {
    console.log(response)
    axios({
      methodd: 'get',
      url: getAPIURL() + '/api/v1/student_conditions/search?limit=' + settings.LIMIT,
      withCredentials: true
    }).then(response => {
      console.log(response)
      store.state.item.student_condition = response.data
      data.edit_id.edit_id = ''
      // alert('生徒条件を更新しました。')
    }).catch(error => {
      console.log(error)
      alert('生徒条件を更新できませんでした。')
      store.dispatch('loginstate')
    })
  }).catch(error => {
    console.log(error)
    alert('生徒条件を更新できませんでした。')
    store.dispatch('loginstate')
  })
  // } else {
  //   return
  // }
}

export const getTutor_conditions = ({ commit }) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/tutor_conditions/search?limit=' + settings.LIMIT,
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.list.tutor_conditions = response.data.tutor_condition
  }).catch(error => {
    console.log(error)
    // alert('getTutor_conditionsに失敗しました')
    store.dispatch('loginState')
  })
}

export const getTutor_condition = ({ commit }, id) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/tutor_conditions/' + id,
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.item.tutor_condition = response.data
  }).catch(error => {
    console.log(error)
    // alert('getTutor_conditionに失敗しました')
    store.dispatch('loginState')
  })
}

export const postTutor_condition = ({ commit }, add) => {
  // if (window.confirm('先生条件を追加しますか？')) {
  const params = {
    'note': add.note
  }
  axios({
    method: 'post',
    params: params,
    url: getAPIURL() + '/api/v1/tutor_conditions/',
    withCredentials: true
  }).then(response => {
    console.log(response)
    axios({
      method: 'get',
      url: getAPIURL() + '/api/v1/tutor_conditions/search?limit=' + settings.LIMIT,
      withCredentials: true
    }).then(response => {
      console.log(response)
      store.state.list.tutor_conditions = response.data.tutor_condition
      add.name = ''
      // alert('先生条件を追加しました。')
    }).catch(error => {
      console.log(error)
      alert('生徒条件を追加できませんでした。')
      store.dispatch('loginState')
    })
  }).catch(error => {
    console.log(error)
    alert('生徒条件を追加できませんでした。')
    store.dispatch('loginState')
  })
  // } else {
  //   return
  // }
}

export const deleteTutor_condition = ({ commit }, list) => {
  if (window.confirm('本当に削除しますか？')) {
    axios({
      method: 'delete',
      url: getAPIURL() + '/api/v1/tutor_conditions/' + list.id,
      withCredentials: true
    }).then(response => {
      console.log(response)
      axios({
        method: 'get',
        url: getAPIURL() + '/api/v1/tutor_conditions/search?limit=' + settings.LIMIT,
        withCredentials: true
      }).then(response => {
        console.log(response)
        store.state.list.tutor_conditions = response.data.tutor_condition
        alert('先生条件を削除しました。')
      }).catch(error => {
        console.log(error)
        alert('生徒条件を削除できませんでした。')
        store.dispatch('loginState')
      })
    }).catch(error => {
      console.log(error)
      alert('生徒条件を削除できませんでした。')
      store.dispatch('loginState')
    })
  } else {
    return
  }
}

export const editTutor_condition = ({ commit }, data) => {
  console.log(data)
  axios({
    // multipatchの場合、編集、編集で押されると加工したオブジェクトが見えてしまう為get
    method: 'get',
    url: getAPIURL() + '/api/v1/tutor_conditions/search?limit=' + settings.LIMIT,
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.list.tutor_conditions = response.data.tutor_condition
    data.edit_id.edit_id = data.list.id
    // alert('キャンセルしました')
    store.dispatch('loginState')
  }).catch(error => {
    console.log(error)
    // alert('getに失敗しました')
    store.dispatch('loginState')
  })
}

export const cancelTutor_condition = ({ commit }, data) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/tutor_conditions/search?limit=' + settings.LIMIT,
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.item.tutor_condition = response.data
    data.edit_id.edit_id = ''
  }).catch(error => {
    console.log(error)
    // alert('get失敗しました')
    store.dispatch('loginState')
  })
}

export const patchTutor_condition = ({ commit }, data) => {
  // if (window.confirm('本当に更新しますか？')) {
  const params = {
    'note': data.list.note
  }
  axios({
    method: 'patch',
    params: params,
    url: getAPIURL() + '/api/v1/tutor_conditions/' + data.list.id,
    withCredentials: true
  }).then(response => {
    console.log(response)
    axios({
      methodd: 'get',
      url: getAPIURL() + '/api/v1/tutor_conditions/search?limit=' + settings.LIMIT,
      withCredentials: true
    }).then(response => {
      console.log(response)
      store.state.item.tutor_condition = response.data
      data.edit_id.edit_id = ''
      // alert('先生条件を更新しました。')
    }).catch(error => {
      console.log(error)
      alert('先生条件を更新できませんでした。')
      store.dispatch('loginstate')
    })
  }).catch(error => {
    console.log(error)
    alert('先生条件を更新できませんでした。')
    store.dispatch('loginstate')
  })
  // } else {
  //   return
  // }
}

export const postST = ({ commit }, data) => {
  function post () {
    const params = {
      'student_id': data.student_tutor.student_id,
      // 'office_id': '',
      'tutor_id': data.student_tutor.tutor_id,
      // 'user_id': '',
      'guidance_period_start': data.student_tutor.guidance_period_start,
      'guidance_period_end': data.student_tutor.guidance_period_end,
      'filing_date': data.student_tutor.filing_date,
      'matching_type': data.student_tutor.matching_type,
      'matching_date': data.student_tutor.matching_date,
      'change_reason': data.student_tutor.change_reason,
      'matching_month': data.student_tutor.matching_month,
      'state': data.student_tutor.state,
      'charge_person': data.student_tutor.charge_person,
      'decision_person': data.student_tutor.decision_person,
      'seven_days_tel': data.student_tutor.seven_days_tel,
      'ten_days_tel': data.student_tutor.ten_days_tel,
      'fourteen_days_tel': data.student_tutor.fourteen_days_tel,
      'training_date': data.student_tutor.training_date,
      'training_check': data.student_tutor.training_check,
      'document': data.student_tutor.document,
      'first_day_limit': data.student_tutor.first_day_limit,
      'first_day_check': data.student_tutor.first_day_check,
      'first_day': data.student_tutor.first_day,
      'hold_person': data.student_tutor.hold_person,
      'family_tel_limit': data.student_tutor.family_tel_limit,
      'note': data.student_tutor.note,
      'note2': data.student_tutor.note2,

      'keep_id1': data.student_tutor.keep_id1,
      'keep_id2': data.student_tutor.keep_id2,
      'keep_id3': data.student_tutor.keep_id3,
      'keep_tel1': data.student_tutor.keep_tel1,
      'keep_tel2': data.student_tutor.keep_tel2,
      'keep_tel3': data.student_tutor.keep_tel3,
      'keep_f_name1': data.student_tutor.keep_f_name1,
      'keep_f_name2': data.student_tutor.keep_f_name2,
      'keep_f_name3': data.student_tutor.keep_f_name3,
      'keep_l_name1': data.student_tutor.keep_l_name1,
      'keep_l_name2': data.student_tutor.keep_l_name2,
      'keep_l_name3': data.student_tutor.keep_l_name3
    }
    return axios({
      method: 'post',
      params: params,
      url: getAPIURL() + '/api/v1/student_tutors/',
      withCredentials: true
    })
  }

  function get () {
    return axios({
      url: getAPIURL() + '/api/v1/student_tutors/search?limit=' + settings.LIMIT,
      method: 'get',
      withCredentials: true
    })
  }

  function stop (e) {
    throw e
  }

  function error (e) {
    alert('エラーです')
  }

  // if (window.confirm('探しデータを作成しますか？')) {
  post().catch(stop
  ).then(get).catch(stop).then(response => {
    store.state.list.student_tutors = response.data.student_tutor
    data.student_tutor.student_id = ''
    data.condition.condition = false
    data.modal.list = response.data.student_tutor[0]
    data.modal.condition = true
    // alert('探しデータを作成しました。')
  }).catch(error)
  // } else {
  //   return
  // }
}

export const deleteST = ({ commit }, data) => {
  function del () {
    return axios({
      method: 'delete',
      url: getAPIURL() + '/api/v1/student_tutors/' + data.modal.list.id,
      withCredentials: true
    })
  }

  function get () {
    return axios({
      method: 'get',
      url: getAPIURL() + '/api/v1/student_tutors/search?limit=' + settings.LIMIT,
      withCredentials: true
    })
  }

  function stop (e) {
    throw e
  }

  function error (e) {
    alert('エラーです')
  }

  if (window.confirm('探しデータを削除しますか？(生徒と先生の紐付けも削除されます)')) {
    del().catch(stop).then(get).catch(stop).then(response => {
      store.state.list.student_tutors = response.data.student_tutor
      data.modal.condition = false
      alert('探しデータを削除しました')
    }).catch(error)
  } else {
    return
  }
}

export const patchStudent_tutor = ({ commit }, data) => {
  console.log(data)
  function patch () {
    const params = {
      'filing_date': data.list.filing_date,
      'matching_type': data.list.matching_type,
      'change_reason': data.list.change_reason,
      'matching_month': data.list.matching_month,
      'matching_date': data.list.matching_date,
      // 'student_id': '',
      // 'tutor_id': '',
      'note': data.list.note,
      'guidance_period_start': data.list.guidance_period_start,
      'guidance_period_end': data.list.guidance_period_end
    }
    return axios({
      method: 'patch',
      params: params,
      url: getAPIURL() + '/api/v1/student_tutors/' + data.list.id,
      withCredentials: true
    })
  }

  function get () {
    let url
    if (/studentindex/.test(data.this.$route.name)) {
      // studentindex
      url = getAPIURL() + '/api/v1/students/' + data.this.student.id
    } else if (/tutorindex/.test(data.this.$route.name)) {
      // tutorindex
      url = getAPIURL() + '/api/v1/tutors/' + data.this.tutor.id
    }
    return axios({
      method: 'get',
      url: url,
      withCredentials: true
    })
  }

  function stop (e) {
    throw e
  }

  function error (e) {
    alert('エラーです')
  }

  // if (window.confirm('探しデータを更新しますか？')) {
  patch().catch(stop).then(get).catch(stop).then(response => {
    console.log(data.this.$route.name)
    if (/studentindex/.test(data.this.$route.name)) {
      // studentindex
      console.log('student')
      store.state.item.student = response.data
    } else if (/tutorindex/.test(data.this.$route.name)) {
      // tutorindex
      console.log('tutor')
      store.state.item.tutor = response.data
    }
    data.edit_id.edit_id = ''
    // alert('探しデータを更新しました。')
  }).catch(error)
  // } else {
  //   return
  // }
}

export const cancelStudent_tutor = ({ commit }, data) => {
  console.log(data)
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/students/' + data.this.student.id,
    withCredentials: true
  }).then(res => {
    console.log(res)
    store.state.item.student = res.data
    data.edit_id.edit_id = ''
  }).catch(error => {
    console.log(error)
    // alert('get失敗しました')
    store.dispatch('loginState')
  })
}

export const patchST = ({ commit }, data) => {
  function patch () {
    console.log(data)
    const params = {
      // 'office_id': data.student_tutor.office_id,
      // 'student_id': '',
      // 'tutor_id': '',
      // 'user_id': data.modal.list.user_id,
      // 'guidance_period_start': data.modal.list.guidance_period_start,
      // 'guidance_period_end': data.modal.list.guidance_period_end,
      'filing_date': data.modal.list.filing_date,
      'matching_type': data.student_tutor.matching_type,
      'matching_date': data.modal.list.matching_date,
      'change_reason': data.student_tutor.change_reason,
      'matching_month': data.student_tutor.matching_month,
      'state': data.student_tutor.state,
      'charge_person': data.student_tutor.charge_person,
      'decision_person': data.student_tutor.decision_person,
      'seven_days_tel': data.student_tutor.seven_days_tel,
      'ten_days_tel': data.student_tutor.ten_days_tel,
      'fourteen_days_tel': data.student_tutor.fourteen_days_tel,
      'training_date': data.modal.list.training_date,
      'training_check': data.student_tutor.training_check,
      'document': data.student_tutor.document,
      'document_sending_check': data.student_tutor.document_sending_check,
      'document_receipt_check': data.student_tutor.document_receipt_check,
      'first_day_limit': data.modal.list.first_day_limit,
      'first_day_check': data.student_tutor.first_day_check,
      'first_day': data.modal.list.first_day,
      'hold_person': data.student_tutor.hold_person,
      'family_tel_limit': data.modal.list.family_tel_limit,
      'note': data.modal.list.note,
      'note2': data.modal.list.note2,

      'keep_id1': data.modal.list.keep_id1,
      'keep_id2': data.modal.list.keep_id2,
      'keep_id3': data.modal.list.keep_id3,
      'keep_tel1': data.modal.list.keep_tel1,
      'keep_tel2': data.modal.list.keep_tel2,
      'keep_tel3': data.modal.list.keep_tel3,
      'keep_f_name1': data.modal.list.keep_f_name1,
      'keep_f_name2': data.modal.list.keep_f_name2,
      'keep_f_name3': data.modal.list.keep_f_name3,
      'keep_l_name1': data.modal.list.keep_l_name1,
      'keep_l_name2': data.modal.list.keep_l_name2,
      'keep_l_name3': data.modal.list.keep_l_name3
    }
    console.log(params)
    return axios({
      method: 'patch',
      params: params,
      url: getAPIURL() + '/api/v1/student_tutors/' + data.modal.list.id,
      withCredentials: true
    })
  }

  function get (response) {
    console.log(response)
    return axios({
      method: 'get',
      url: data.modal.obj.searchUrl,
      withCredentials: true
    })
  }

  function stop (e) {
    throw e
  }

  function error (e) {
    alert('エラーです')
  }

  // if (window.confirm('探しデータを更新しますか？')) {
  patch().catch(stop).then(get).catch(stop).then(response => {
    store.state.list.student_tutors = response.data.student_tutor
    data.modal.condition = false
    // alert('探しデータを更新しました。')
  }).catch(error)
  // } else {
  //   return
  // }
}

export const patchState = ({ commit }, data) => {
  console.log(data)
  console.log(data.number)
  console.log(data.list.todos[data.number].id)
  function patch () {
    const params = {
      // 'state': list.todos[number].state,
      'state': 1
    }
    return axios({
      method: 'patch',
      params: params,
      url: getAPIURL() + '/api/v1/todos/' + data.list.todos[data.number].id,
      withCredentials: true
    })
  }

  function patch2 () {
    const params = {
      'ymd': data.add.today
    }
    console.log(params.ymd)
    return axios({
      method: 'patch',
      params: params,
      url: getAPIURL() + '/api/v1/completes/' + data.list.todos[data.number].limit.complete.id,
      withCredentials: true
    })
  }

  function get () {
    return axios({
      method: 'get',
      url: getAPIURL() + '/api/v1/student_tutors/search?limit=' + settings.LIMIT,
      withCredentials: true
    })
  }

  function stop (e) {
    throw e
  }

  function error (e) {
    alert('エラーです')
  }

  // if (window.confirm('探しデータを更新しますか？')) {
  patch().catch(stop).then(patch2).catch(stop).then(get).catch(stop).then(response => {
    store.state.list.student_tutors = response.data.student_tutor
    // alert('探しデータを更新しました。')
  }).catch(error)
  // } else {
  //   return
  // }
}

export const SEARCH = ({ commit }, data) => {
  let search = data.this.search
  let route = data.this.$route
  let wait = 500

  // パラメーター格納用オブジェクト
  let params = {}
  // オブジェクトを捜査するための配列を作成

  function searchTable () {
    let paramsList
    if (/^usersindex/.test(route.name)) {
      paramsList = [
        'id',
        'user',
        'name',
        'email',
        'type',
        'office',
        'office_id',
        'created_at',
        'updated_at',
        'hide_flag',

        'not_id',
        'not_user',
        'not_name',
        'not_email',
        'not_type',
        'not_office',
        'not_office_id',
        'not_created_at',
        'not_updated_at',
        'not_hide_flag'
      ]
    } else if (/^documentsindex/.test(route.name)) {
      paramsList = [
        'id',
        'company_id',
        'office_id',
        'user_id',
        'category',
        'title',
        'note',
        'created_at',
        'updated_at',

        'not_id',
        'not_company_id',
        'not_office_id',
        'not_user_id',
        'not_category',
        'not_title',
        'not_note',
        'not_created_at',
        'not_updated_at'
      ]
    } else if (/^documentindex/.test(route.name)) {
      paramsList = [
        'id',
        'company_id',
        'office_id',
        'user_id',
        'category',
        'title',
        'note',
        'created_at',
        'updated_at',

        'not_id',
        'not_company_id',
        'not_office_id',
        'not_user_id',
        'not_category',
        'not_title',
        'not_note',
        'not_created_at',
        'not_updated_at'
      ]
    } else if (/versionsindex/.test(route.name)) {
      paramsList = [
        'id',
        'item_type',
        'item_id',
        'event',
        'whodunnit',
        'created_at',

        'not_id',
        'not_item_type',
        'not_item_id',
        'not_event',
        'not_whodunnit',
        'not_created_at'
      ]
    } else if (/^advisorsindex/.test(route.name)) {
      paramsList = [
        'id',
        'name',
        'kana',
        'office',
        'created_at',
        'updated_at',

        'not_id',
        'not_name',
        'not_kana',
        'not_office',
        'not_created_at',
        'not_updated_at'
      ]
    } else if (/^families/.test(route.name)) {
      if (/add/.test(route.name)) {
        paramsList = [
          'id',
          'family_id',
          'user_id',
          'company_id',
          'state',
          'name',
          'kana',
          'pref',
          'address',
          'tel1',
          'tel2',
          'contact_date',
          'support',
          'acquisition_date',
          'medium1',
          'medium2',
          'medium3',
          'office_id',
          'memo',
          'dm',
          'shop_type',
          'shop_name',
          'hp_browse',
          'visit_date',
          'note',
          'created_at',

          'not_id',
          'not_family_id',
          'not_user_id',
          'not_company_id',
          'not_state',
          'not_nama',
          'not_kana',
          'not_pref',
          'not_address',
          'not_tel1',
          'not_tel2',
          'not_contact_date',
          'not_support',
          'not_acquisition_date',
          'not_medium1',
          'not_medium2',
          'not_medium3',
          'not_memo',
          'not_dm',
          'not_shop_type',
          'not_shop_name',
          'not_hp_browse',
          'not_visit_date',
          'not_note',
          'not_created_at'
        ]
      } else {
        paramsList = [
          'id',
          'company_id',
          'office_id',
          'user_id',
          'state', // students.state
          'latest',
          'name',
          'kana',
          'relationship',
          'zip',
          'pref',
          'address',
          'tel1',
          'tel2',
          'fax',
          'mail',
          'mail2',
          'guidance_type',
          'structure',
          'unit',
          'workplace_contact',
          'preferred_contact',
          'contact_timezone',
          'withdrawal_date',
          'note1',
          'note2',
          'created_at',

          'not_id',
          'not_company_id',
          'not_office_id',
          'not_user_id',
          'not_state', // students.state
          'not_latest',
          'not_name',
          'not_kana',
          'not_relationship',
          'not_zip',
          'not_pref',
          'not_address',
          'not_tel1',
          'not_tel2',
          'not_fax',
          'not_mail',
          'not_mail2',
          'not_guidance_type',
          'not_structure',
          'not_unit',
          'not_workplace_contact',
          'not_preferred_contact',
          'not_contact_timezone',
          'not_withdrawal_date',
          'not_note1',
          'not_note2',
          'not_created_at'
        ]
      }
    } else if (/^studentsindex/.test(route.name)) {
      if (/inheritance/.test(route.name)) {
        // 引継リスト
        paramsList = [
          'id',
          'office_id',
          'user_id',
          'state',
          'address',
          'name',
          'kana',
          'age',
          'grade',
          'takeover_time',
          'inheritance_result',
          'next_contact_date',
          'service_period_start',
          'service_period_end',
          'text_type',
          'created_at',

          'company_id',

          'not_id',
          'not_office_id',
          'not_user_id',
          'not_state',
          'not_address',
          'not_name',
          'not_kana',
          'not_age',
          'not_grade',
          'not_takeover_time',
          'not_inheritance_result',
          'not_next_contact_date',
          'not_service_period_start',
          'not_service_period_end',
          'not_text_type',
          'not_created_at',

          'not_company_id'
        ]
      } else {
        // 生徒リスト
        paramsList = [
          'id',
          'office_id',
          'user_id',
          'zip',
          'pref',
          'address',
          'state',
          'name',
          'kana',
          'age',
          'gender',
          'birthday',
          'age',
          'school_type',
          'school_name',
          'guidance_detail',
          'takeover_time',
          'priority',
          'old_grade',
          'grade',
          'grade_flag',
          'service_period_start',
          'service_period_end',
          'inheritance_result',
          'next_contact_date',
          'note',
          'created_at',

          'company_id',

          'not_id',
          'not_office_id',
          'not_user_id',
          'not_zip',
          'not_pref',
          'not_address',
          'not_state',
          'not_name',
          'not_kana',
          'not_age',
          'not_gender',
          'not_birthday',
          'not_age',
          'not_school_type',
          'not_school_name',
          'not_guidance_detail',
          'not_takeover_time',
          'not_priority',
          'not_old_grade',
          'not_grade',
          'not_grade_flag',
          'not_service_period_start',
          'not_service_period_end',
          'not_inheritance_result',
          'not_next_contact_date',
          'not_note',
          'not_created_at',

          'not_company_id'
        ]
      }
    } else if (/^studentsadd/.test(route.name)) {
      paramsList = [
        'id',
        'user_id',
        'name',
        'kana',
        'relationship',
        'pref',
        'address',
        'tel1',
        'tel2',
        'fax',
        'mail',
        'guidance_type',
        'unit',
        'preferred_contact',
        'created_at',

        'not_id',
        'not_user_id',
        'not_name',
        'not_kana',
        'not_relationship',
        'not_pref',
        'not_address',
        'not_tel1',
        'not_tel2',
        'not_fax',
        'not_mail',
        'not_guidance_type',
        'not_unit',
        'not_preferred_contact',
        'not_created_at'
      ]
    } else if (/^student_tutorsindex/.test(route.name)) {
      paramsList = [
        'id',
        'office_id',
        'student_id',
        'tutor_id',
        'user_id',
        'guidance_period_start',
        'guidance_period_end',
        'filing_date',
        'matching_type',
        'matching_date',
        'change_reason',
        'matching_month',
        'state',
        'charge_person',
        'decision_person',
        'seven_days_tel',
        'ten_days_tel',
        'fourteen_days_tel',
        'training_date',
        'training_check',
        'document',
        'document_sending_check',
        'document_receipt_check',
        'first_day_limit',
        'first_day_check',
        'first_day',
        'hold_person',
        'family_tel_limit',
        'note',
        'created_at',
        'updated_at',
        'grade',
        'student_state',
        'student_name',
        'student_kana',
        'student_grade',
        'family_tel1',
        'family_tel2',
        'family_pref',
        'family_address',
        'tutor_name',
        'tutor_kana',
        'tutor_tel1',
        'tutor_tel2',
        'tutor_pref',
        'tutor_address',
        // 'keep_f_name1',
        // 'keep_f_name2',
        // 'keep_f_name3',

        'not_id',
        'not_office_id',
        'not_student_id',
        'not_tutor_id',
        'not_user_id',
        'not_guidance_period_start',
        'not_guidance_period_end',
        'not_filing_date',
        'not_matching_type',
        'not_matching_date',
        'not_change_reason',
        'not_matching_month',
        'not_state',
        'not_charge_person',
        'not_decision_person',
        'not_seven_days_tel',
        'not_ten_days_tel',
        'not_fourteen_days_tel',
        'not_training_date',
        'not_training_check',
        'not_document',
        'not_document_sending_check',
        'not_document_receipt_check',
        'not_first_day_limit',
        'not_first_day_check',
        'not_first_day',
        'not_hold_person',
        'not_family_tel_limit',
        'not_note',
        'not_created_at',
        'not_updated_at',
        'not_grade',
        'not_student_state',
        'not_student_name',
        'not_student_kana',
        'not_student_grade',
        'not_family_tel1',
        'not_family_tel2',
        'not_family_pref',
        'not_family_address',
        'not_tutor_name',
        'not_tutor_kana',
        'not_tutor_tel1',
        'not_tutor_tel2',
        'not_tutor_pref',
        'not_tutor_address'
        // 'not_keep_f_name1',
        // 'not_keep_f_name2',
        // 'not_keep_f_name3'
      ]
    } else if (/^tutorsindex2/.test(route.name)) {
      paramsList = [
        'id',
        'office_id',
        'user_id',
        'state',
        'registration_date',
        'name',
        'kana',
        'gender',
        'birthday',
        'age',
        'zip',
        'pref',
        'address',
        'tel1',
        'tel2',
        'mail1',
        'mail2',
        'home_zip',
        'home_pref',
        'home_address',
        'home_tel',
        'school_name',
        'school_stage',
        'department',
        'old_grade',
        'grade',
        'grade_flag',
        'department_type',
        'club',
        'transportation_car',
        'transportation_bike',
        'transportation_scooters',
        'transportation_bicycle',
        'transportation_train',
        'transportation_none',
        'nearest_station',
        'high_school_name',
        'high_school_club',
        'exam_s',
        'exam_c',
        'exam_k',
        'exam_d',
        'experience_tutor',
        'experience_tutor_note',
        'experience_cram',
        'experience_cram_note',
        'experience_none',
        'channel_id',
        'medium_note',
        'published',
        'information',
        'impression',
        'impression_note',
        'training',
        'training_note',
        'ssk',
        'note',
        'created_at',

        'not_id',
        'not_office_id',
        'not_user_id',
        'not_state',
        'not_registration_date',
        'not_name',
        'not_kana',
        'not_gender',
        'not_birthday',
        'not_age',
        'not_zip',
        'not_pref',
        'not_address',
        'not_tel1',
        'not_tel2',
        'not_mail1',
        'not_mail2',
        'not_home_zip',
        'not_home_prer',
        'not_home_address',
        'not_home_tel',
        'not_school_name',
        'not_school_stage',
        'not_department',
        'not_old_grade',
        'not_grade',
        'not_grade_flag',
        'not_department_type',
        'not_club',
        'not_transportation_car',
        'not_transportation_bike',
        'not_transportation_scooters',
        'not_transportation_bicycle',
        'not_transportation_train',
        'not_transportation_none',
        'not_nearest_station',
        'not_high_school_name',
        'not_high_school_club',
        'not_exam_s',
        'not_exam_c',
        'not_exam_k',
        'not_exam_d',
        'not_experience_tutor',
        'not_experience_tutor_note',
        'not_experience_cram',
        'not_experience_cram_note',
        'not_experience_none',
        'not_channel_id',
        'not_medium_note',
        'not_published',
        'not_information',
        'not_impression',
        'not_impression_note',
        'not_training',
        'not_training_note',
        'not_ssk',
        'not_note',
        'not_created_at'
      ]
    } else if (/^tutorindex2/.test(route.name)) {
      paramsList = [
        'id',
        'office_id',
        'user_id',
        'state',
        'registration_date',
        'name',
        'kana',
        'gender',
        'birthday',
        'age',
        'zip',
        'pref',
        'address',
        'tel1',
        'tel2',
        'mail1',
        'mail2',
        'home_zip',
        'home_pref',
        'home_address',
        'home_tel',
        'school_name',
        'school_stage',
        'department',
        'old_grade',
        'grade',
        'grade_flag',
        'department_type',
        'club',
        'transportation_car',
        'transportation_bike',
        'transportation_scooters',
        'transportation_bicycle',
        'transportation_train',
        'transportation_none',
        'nearest_station',
        'high_school_name',
        'high_school_club',
        'exam_s',
        'exam_c',
        'exam_k',
        'exam_d',
        'experience_tutor',
        'experience_tutor_note',
        'experience_cram',
        'experience_cram_note',
        'experience_none',
        'channel_id',
        'medium_note',
        'published',
        'information',
        'impression',
        'impression_note',
        'training',
        'training_note',
        'ssk',
        'note',
        'created_at',

        'not_id',
        'not_office_id',
        'not_user_id',
        'not_state',
        'not_registration_date',
        'not_name',
        'not_kana',
        'not_gender',
        'not_birthday',
        'not_age',
        'not_zip',
        'not_pref',
        'not_address',
        'not_tel1',
        'not_tel2',
        'not_mail1',
        'not_mail2',
        'not_home_zip',
        'not_home_prer',
        'not_home_address',
        'not_home_tel',
        'not_school_name',
        'not_school_stage',
        'not_department',
        'not_old_grade',
        'not_grade',
        'not_grade_flag',
        'not_department_type',
        'not_club',
        'not_transportation_car',
        'not_transportation_bike',
        'not_transportation_scooters',
        'not_transportation_bicycle',
        'not_transportation_train',
        'not_transportation_none',
        'not_nearest_station',
        'not_high_school_name',
        'not_high_school_club',
        'not_exam_s',
        'not_exam_c',
        'not_exam_k',
        'not_exam_d',
        'not_experience_tutor',
        'not_experience_tutor_note',
        'not_experience_cram',
        'not_experience_cram_note',
        'not_experience_none',
        'not_channel_id',
        'not_medium_note',
        'not_published',
        'not_information',
        'not_impression',
        'not_impression_note',
        'not_training',
        'not_training_note',
        'not_ssk',
        'not_note',
        'not_created_at'
      ]
    } else if (/^tutorsindex/.test(route.name)) {
      paramsList = [
        'id',
        'office_id',
        'user_id',
        'state',
        'registration_date',
        'name',
        'kana',
        'gender',
        'birthday',
        'age',
        'zip',
        'pref',
        'address',
        'tel1',
        'tel2',
        'mail1',
        'mail2',
        'home_zip',
        'home_pref',
        'home_address',
        'home_tel',
        'school_name',
        'school_stage',
        'department',
        'old_grade',
        'grade',
        'grade_flag',
        'department_type',
        'club',
        'transportation_car',
        'transportation_bike',
        'transportation_scooters',
        'transportation_bicycle',
        'transportation_train',
        'transportation_none',
        'nearest_station',
        'high_school_name',
        'high_school_club',
        'exam_s',
        'exam_c',
        'exam_k',
        'exam_d',
        'experience_tutor',
        'experience_tutor_note',
        'experience_cram',
        'experience_cram_note',
        'experience_none',
        'channel_id',
        'medium_note',
        'published',
        'information',
        'impression',
        'impression_note',
        'training',
        'training_note',
        'ssk',
        'note',
        'created_at',

        'not_id',
        'not_office_id',
        'not_user_id',
        'not_state',
        'not_registration_date',
        'not_name',
        'not_kana',
        'not_gender',
        'not_birthday',
        'not_age',
        'not_zip',
        'not_pref',
        'not_address',
        'not_tel1',
        'not_tel2',
        'not_mail1',
        'not_mail2',
        'not_home_zip',
        'not_home_prer',
        'not_home_address',
        'not_home_tel',
        'not_school_name',
        'not_school_stage',
        'not_department',
        'not_old_grade',
        'not_grade',
        'not_grade_flag',
        'not_department_type',
        'not_club',
        'not_transportation_car',
        'not_transportation_bike',
        'not_transportation_scooters',
        'not_transportation_bicycle',
        'not_transportation_train',
        'not_transportation_none',
        'not_nearest_station',
        'not_high_school_name',
        'not_high_school_club',
        'not_exam_s',
        'not_exam_c',
        'not_exam_k',
        'not_exam_d',
        'not_experience_tutor',
        'not_experience_tutor_note',
        'not_experience_cram',
        'not_experience_cram_note',
        'not_experience_none',
        'not_channel_id',
        'not_medium_note',
        'not_published',
        'not_information',
        'not_impression',
        'not_impression_note',
        'not_training',
        'not_training_note',
        'not_ssk',
        'not_note',
        'not_created_at'
      ]
    } else if (/^tags/.test(route.name)) {
      paramsList = [
        'id',
        'user_id',
        'name',
        'color',
        'created_at',
        'not_id',
        'not_user_id',
        'not_name',
        'not_color',
        'not_created_at'
      ]
    } else if (/^appointmentsupportsindex/.test(route.name)) {
      paramsList = [
        'id',
        'office_id',
        'family_id',
        'user_id',
        'support_date',
        'note',
        'created_at',
        'updated_at',

        'name',
        'kana',
        'address',

        'tag_id',

        'not_id',
        'not_office_id',
        'not_family_id',
        'not_user_id',
        'not_support_date',
        'not_note',
        'not_created_at',
        'not_updated_at',

        'not_name',
        'not_kana',
        'not_address',

        'not_tag_id'
      ]
    } else if (/^familysupportsindex/.test(route.name)) {
      paramsList = [
        'id',
        'company_id',
        'office_id',
        'family_id',
        'user_id',
        'support_date',
        'note',
        'created_at',
        'updated_at',

        'name',
        'kana',
        'address',

        'tag_id',

        'not_id',
        'not_company_id',
        'not_office_id',
        'not_family_id',
        'not_user_id',
        'not_support_date',
        'not_note',
        'not_created_at',
        'not_updated_at',

        'not_name',
        'not_kana',
        'not_address',

        'not_tag_id'
      ]
    } else if (/^tutorsupportsindex/.test(route.name)) {
      paramsList = [
        'id',
        'office_id',
        'tutor_id',
        'user_id',
        'support_date',
        'note',
        'created_at',
        'updated_at',

        'name',
        'kana',
        'address',

        'tag_id',

        'not_id',
        'not_office_id',
        'not_tutor_id',
        'not_user_id',
        'not_support_date',
        'not_note',
        'not_created_at',
        'not_updated_at',

        'not_name',
        'not_kana',
        'not_address',

        'not_tag_id'
      ]
    } else if (/^familyfiles/.test(route.name)) {
      paramsList = [
        'id',
        'family_id',
        'user',
        'file_name',
        'created_at',
        'not_id',
        'not_family_id',
        'not_user',
        'not_file_name',
        'not_created_at'
      ]
    } else if (/^studentfiles/.test(route.name)) {
      paramsList = [
        'id',
        'student_id',
        'student_name',
        'student_kana',
        'state',
        'month',
        'filing_date',
        'note',
        'file_name',
        'points_english',
        'points_mathematics',
        'points_japanese',
        'points_science',
        'points_socialstudies',
        'user',
        'created_at',

        'company_id',

        'not_id',
        'not_student_id',
        'not_student_name',
        'not_student_kana',
        'not_month',
        'not_filing_date',
        'not_note',
        'not_file_name',
        'not_points_english',
        'not_points_mathematics',
        'not_points_japanese',
        'not_points_science',
        'not_points_socialstudies',
        'not_user',
        'not_created_at',

        'not_company_id'
      ]
    } else if (/^tutorfiles/.test(route.name)) {
      paramsList = [
        'id',
        'tutor_id',
        'user',
        'file_name',
        'created_at',
        'not_id',
        'not_tutor_id',
        'not_user',
        'not_file_name',
        'not_created_at'
      ]
    } else if (/^reports/.test(route.name)) {
      paramsList = [
        'id',
        'created_at',
        'updated_at',
        'student_name',
        'student_kana',
        'student_tel1',
        'student_tel2',
        'student_pref',
        'student_address',
        'tutor_name',
        'tutor_kana',
        'tutor_tel1',
        'tutor_tel2',
        'tutor_pref',
        'tutor_address',

        'not_id',
        'not_created_at',
        'not_updated_at',
        'not_student_name',
        'not_student_kana',
        'not_student_tel1',
        'not_student_tel2',
        'not_student_pref',
        'not_student_address',
        'not_tutor_name',
        'not_tutor_kana',
        'not_tutor_tel1',
        'not_tutor_tel2',
        'not_tutor_pref',
        'not_tutor_address'
      ]
    } else if (/^tutor_channels/.test(route.name)) {
      paramsList = [
        'id',
        // 'user',
        'tutor_id',
        'channel_id',
        'medium_note',
        'registration_date',
        'created_at',

        'name',
        'kana',
        'pref',
        'address',

        'not_id',
        // 'not_user',
        'not_tutor_id',
        'not_channel_id',
        'not_medium_note',
        'not_registration_date',
        'not_created_at',

        'not_name',
        'not_kana',
        'not_pref',
        'not_address'
      ]
    } else if (/^office_channels/.test(route.name)) {
      paramsList = [
        'id',
        'user_id',
        'office_id',
        'channel_id',
        'state',
        'created_at',

        'not_id',
        'not_user_id',
        'not_office_id',
        'not_channel_id',
        'not_state',
        'not_created_at'
      ]
    } else if (/^channels/.test(route.name)) {
      paramsList = [
        'id',
        'user',
        'state',
        'name',
        'created_at',

        'not_id',
        'not_user',
        'not_state',
        'not_name',
        'not_created_at'
      ]
    } else if (/^todos/.test(route.name)) {
      paramsList = [
        'id',
        'user',
        'state',
        'note',
        'created_at',
        'updated_at',

        'not_id',
        'not_user',
        'not_state',
        'not_note',
        'not_created_at',
        'not_updated_at'
      ]
    } else if (/^conditions/.test(route.name)) {
      paramsList = [
        'id',
        'user',
        'name',
        'created_at',
        'not_id',
        'not_user',
        'not_name',
        'not_created_at'
      ]
    } else if (/^student_conditions/.test(route.name)) {
      paramsList = [
        'id',
        'user',
        'student_id',
        'condition_id',
        'note',
        'created_at',
        'not_id',
        'not_user',
        'not_student_id',
        'not_condition_id',
        'not_note',
        'not_created_at'
      ]
    } else if (/^tutor_conditions/.test(route.name)) {
      paramsList = [
        'id',
        'user',
        'tutor_id',
        'condition_id',
        'note',
        'created_at',
        'not_id',
        'not_user',
        'not_tutor_id',
        'not_condition_id',
        'not_note',
        'not_created_at'
      ]
    } else if (/^appointmentsindex/.test(route.name) || /^appointmentsindex2/.test(route.name) || /^appointmentindex2/.test(route.name)) {
      paramsList = [
        'id',
        'family_id',
        'user_id',
        'state',
        'name',
        'kana',
        'zip',
        'pref',
        'address',
        'tel1',
        'tel2',
        'fax',
        'mail',
        'contact_date',
        'contact_method',
        'support',
        'missing_detail',
        'contact_later',
        'next_contact_date',
        'next_contact_method',
        'result',
        'acquisition_date',
        'ap_type',
        'medium1',
        'medium2',
        'medium3',
        'hp_type',
        'office_id',
        'gender',
        'school_type',
        'school_stage',
        'grade',
        'memo',
        'dm',
        'dm_information',
        'shop_type',
        'shop_name',
        'hp_browse',
        'visit_date',
        'visit_time',
        'next_visit_date',
        'next_visit_time',
        'request_of_day_of_week',
        'request_of_day_of_week_note',
        'person',
        'note',
        'sending_date',
        'sending_time',
        'contact_person',
        'parking',
        'parking_note',
        'sub_f_name',
        'sub_l_name',
        'sub_f_name_kana',
        'sub_l_name_kana',
        'sub_grade',
        'sub_gender',
        'sub_school_type',
        'sub_school_name',
        'sub_school_stage',
        'achievement',
        'learning',
        'learning_start_period',
        'learning_nervous',
        'learning_result',
        'learning_continuation',
        'sub_achievement',
        'sub_learning',
        'sub_learning_start_period',
        'sub_learning_nervous',
        'sub_learning_result',
        'sub_learning_continuation',
        'attended',
        'fathers_involvement',
        'notices',
        'sending_products',
        'sending_method',
        'preferred_contact',
        'contact_timezone',
        'transmission_item_company',
        'transmission_item_course',
        'transmission_item_visitor',
        'transmission_item_purpose',
        'transmission_item_requiredtime',
        'created_at',

        'not_id',
        'not_family_id',
        'not_user_id',
        'not_state',
        'not_name',
        'not_kana',
        'not_zip',
        'not_pref',
        'not_address',
        'not_tel1',
        'not_tel2',
        'not_fax',
        'not_mail',
        'not_contact_date',
        'not_contact_method',
        'not_support',
        'not_missing_detail',
        'not_contact_later',
        'not_next_contact_date',
        'not_next_contact_method',
        'not_result',
        'not_acquisition_date',
        'not_ap_type',
        'not_medium1',
        'not_medium2',
        'not_medium3',
        'not_hp_type',
        'not_gender',
        'not_school_type',
        'not_school_stage',
        'not_grade',
        'not_memo',
        'not_dm',
        'not_dm_information',
        'not_shop_type',
        'not_shop_name',
        'not_hp_browse',
        'not_visit_date',
        'not_visit_time',
        'not_request_of_day_of_week',
        'not_request_of_day_of_week_note',
        'not_person',
        'not_note',
        'not_sending_date',
        'not_sending_time',
        'not_contact_person',
        'not_parking',
        'not_parking_note',
        'not_sub_f_name',
        'not_sub_l_name',
        'not_sub_f_name_kana',
        'not_sub_l_name_kana',
        'not_sub_grade',
        'not_sub_gender',
        'not_sub_school_type',
        'not_sub_school_name',
        'not_sub_school_stage',
        'not_achievement',
        'not_learning',
        'not_learning_start_period',
        'not_learning_nervous',
        'not_learning_result',
        'not_learning_continuation',
        'not_sub_achievement',
        'not_sub_learning',
        'not_sub_learning_start_period',
        'not_sub_learning_nervous',
        'not_sub_learning_result',
        'not_sub_learning_continuation',
        'not_attended',
        'not_fathers_involvement',
        'not_notices',
        'not_sending_products',
        'not_sending_method',
        'not_preferred_contact',
        'not_contact_timezone',
        'not_transmission_item_company',
        'not_transmission_item_course',
        'not_transmission_item_visitor',
        'not_transmission_item_purpose',
        'not_transmission_item_requiredtime',
        'not_created_at'
      ]
    } else if (/^confirmsindex/.test(route.name)) {
      paramsList = [
        'sending_check',
        'confirm_check',
        'id',
        'family_id',
        'user_id',
        'state',
        'name',
        'kana',
        'zip',
        'pref',
        'address',
        'tel1',
        'tel2',
        'contact_date',
        'support',
        'missing_detail',
        'contact_later',
        'next_contact_date',
        'result',
        'acquisition_date',
        'ap_type',
        'medium1',
        'medium2',
        'medium3',
        'hp_type',
        'office_id',
        'gender',
        'school_type',
        'school_stage',
        'grade',
        'memo',
        'dm',
        'shop_type',
        'shop_name',
        'hp_browse',
        'visit_date',
        'visit_time',
        'next_visit_date',
        'next_visit_time',
        'request_of_day_of_week',
        'request_of_day_of_week_note',
        'note',
        'sending_date',
        'sending_time',
        'contact_person',
        'parking',
        'parking_note',
        'sub_f_name',
        'sub_l_name',
        'sub_f_name_kana',
        'sub_l_name_kana',
        'sub_grade',
        'sub_gender',
        'achievement',
        'learning',
        'learning_start_period',
        'learning_nervous',
        'learning_result',
        'learning_continuation',
        'sub_achievement',
        'sub_learning',
        'sub_learning_start_period',
        'sub_learning_nervous',
        'sub_learning_result',
        'sub_learning_continuation',
        'attended',
        'fathers_involvement',
        'notices',
        'sending_products',
        'sending_method',
        'preferred_contact',
        'contact_timezone',
        'transmission_item_company',
        'transmission_item_course',
        'transmission_item_visitor',
        'transmission_item_purpose',
        'transmission_item_requiredtime',
        'created_at',

        'not_sending_check',
        'not_confirm_check',
        'not_id',
        'not_family_id',
        'not_user_id',
        'not_state',
        'not_name',
        'not_kana',
        'not_zip',
        'not_pref',
        'not_address',
        'not_tel1',
        'not_tel2',
        'not_contact_date',
        'not_support',
        'not_missing_detail',
        'not_contact_later',
        'not_next_contact_date',
        'not_result',
        'not_acquisition_date',
        'not_ap_type',
        'not_medium1',
        'not_medium2',
        'not_medium3',
        'not_hp_type',
        'not_gender',
        'not_school_type',
        'not_school_stage',
        'not_grade',
        'not_memo',
        'not_dm',
        'not_shop_type',
        'not_shop_name',
        'not_hp_browse',
        'not_visit_date',
        'not_visit_time',
        'not_next_visit_date',
        'not_next_visit_time',
        'not_request_of_day_of_week',
        'not_request_of_day_of_week_note',
        'not_note',
        'not_sending_date',
        'not_sending_time',
        'not_contact_person',
        'not_parking',
        'not_parking_note',
        'not_sub_f_name',
        'not_sub_l_name',
        'not_sub_f_name_kana',
        'not_sub_l_name_kana',
        'not_sub_grade',
        'not_sub_gender',
        'not_achievement',
        'not_learning',
        'not_learning_start_period',
        'not_learning_nervous',
        'not_learning_result',
        'not_learning_continuation',
        'not_sub_achievement',
        'not_sub_learning',
        'not_sub_learning_start_period',
        'not_sub_learning_nervous',
        'not_sub_learning_result',
        'not_sub_learning_continuation',
        'not_attended',
        'not_fathers_involvement',
        'not_notices',
        'not_sending_products',
        'not_sending_method',
        'not_preferred_contact',
        'not_contact_timezone',
        'not_transmission_item_company',
        'not_transmission_item_course',
        'not_transmission_item_visitor',
        'not_transmission_item_purpose',
        'not_transmission_item_requiredtime',
        'not_created_at'
      ]
    } else if (/^appointmentindex/.test(route.name)) {
      paramsList = [
        'user',
        'not_user'
      ]
    } else if (/^agreements/.test(route.name)) {
      if (/add/.test(route.name)) {
        paramsList = [
          'id',
          'user_id',
          'name',
          'kana',
          'pref',
          'address',
          'tel1',
          'tel2',
          'fax',
          'mail',
          'created_at',

          'not_id',
          'not_user_id',
          'not_name',
          'not_kana',
          'not_pref',
          'not_address',
          'not_tel1',
          'not_tel2',
          'not_fax',
          'not_mail',
          'not_created_at'
        ]
      } else {
        paramsList = [
          'tag_id',

          'id',
          'student_id',
          'office_id',
          'user_id',
          'payroll_check',
          'contract_type',
          'contract_date',
          'change_date',
          'cancel_type',
          'cancel_date',
          'media',
          'f_name',
          'l_name',
          'f_name_kana',
          'l_name_kana',
          'tel',
          'tel2',
          'address',
          'address2',
          // 'split_commission',
          // 'sales_commission',
          // 'sales_commission_head',
          // 'sales_commission_branch',
          // 'pure_amount_head',
          // 'pure_amount_branch',
          // 'old_amount',
          // 'agency_commission',
          // 'agency_commission_head',
          // 'agency_commission_branch',
          // 'purchase_amount',
          // 'purchase_amount_head',
          // 'purchase_amount_branch',
          // 'only_total_amount',
          // 'only_total_amount_head',
          // 'only_total_amount_branch',
          // 'down_payment',
          // 'deposit_amount',
          'person',
          'product_name',
          'payment_type',
          'text_type',
          'amount',
          'discount',
          'pure_amount',
          'division_commission',
          'total_amount',
          'payments_number',
          'deposit_amount_date',
          'text_payment_period_start',
          'text_payment_period_end',
          'service_period_start',
          'service_period_end',
          // 'administrative_expense',
          // 'first_month_deposit',
          'first_month_deposit_method',
          'first_month_deposit_check',
          'admission_fee',
          'admission_fee_method',
          'admission_fee_check',
          'deposit',
          'deposit_method',
          'deposit_check',
          'bank_number',
          'branch_number',
          'deposit_item',
          'account_number',
          'account_holder',
          'expected_refund_date',
          'deposit_refund_date',
          'approval_date',
          'approval_number',
          'delivery_date',
          'contract_collection_date',
          'factor_collection_date',
          'factor_check',
          'ledger_check',
          'cancel_check',
          'change_check',
          'grade',
          // 'point_s',
          // 'point_c',
          // 'point_k',
          // 'point_s_bulk',
          // 'point_c_bulk',
          // 'point_k_bulk',
          'point_total',
          'note',
          'created_at',
          'updated_at',

          'not_tag_id',

          'not_id',
          'not_student_id',
          'not_office_id',
          'not_user_id',
          'not_payroll_check',
          'not_contract_type',
          'not_contract_date',
          'not_change_date',
          'not_cancel_type',
          'not_cancel_date',
          'not_media',
          'not_f_name',
          'not_l_name',
          'not_f_name_kana',
          'not_l_name_kana',
          'not_tel',
          'not_tel2',
          'not_address',
          'not_address2',
          // 'not_split_commission',
          // 'not_sales_commission',
          // 'not_sales_commission_head',
          // 'not_sales_commission_branch',
          // 'not_pure_amount_head',
          // 'not_pure_amount_branch',
          // 'not_old_amount',
          // 'not_agency_commission',
          // 'not_agency_commission_head',
          // 'not_agency_commission_branch',
          // 'not_purchase_amount',
          // 'not_purchase_amount_head',
          // 'not_purchase_amount_branch',
          // 'not_only_total_amount',
          // 'not_only_total_amount_head',
          // 'not_only_total_amount_branch',
          // 'not_down_payment',
          // 'not_deposit_amount',
          'not_person',
          'not_product_name',
          'not_payment_type',
          'not_text_type',
          'not_amount',
          'not_discount',
          'not_pure_amount',
          'not_division_commission',
          'not_total_amount',
          'not_payments_number',
          'not_deposit_amount_date',
          'not_text_payment_period_start',
          'not_text_payment_period_end',
          'not_service_period_start',
          'not_service_period_end',
          // 'not_administrative_expense',
          // 'not_first_month_deposit',
          'not_first_month_deposit_method',
          'not_first_month_deposit_check',
          'not_admission_fee',
          'not_admission_fee_method',
          'not_admission_fee_check',
          'not_deposit',
          'not_deposit_method',
          'not_deposit_check',
          'not_bank_number',
          'not_branch_number',
          'not_deposit_item',
          'not_account_number',
          'not_account_holder',
          'not_expected_refund_date',
          'not_deposit_refund_date',
          'not_approval_date',
          'not_approval_number',
          'not_delivery_date',
          'not_contract_collection_date',
          'not_factor_collection_date',
          'not_factor_check',
          'not_ledger_check',
          'not_cancel_check',
          'not_change_check',
          'not_grade',
          // 'not_point_s',
          // 'not_point_c',
          // 'not_point_k',
          // 'not_point_s_bulk',
          // 'not_point_c_bulk',
          // 'not_point_k_bulk',
          'not_point_total',
          'not_note',
          'not_created_at',
          'not_updated_at'
        ]
      }
    } else if (/^contracts/.test(route.name)) {
      paramsList = [
        'id',
        'contract_type',
        'contract_date',
        'cancel_type',
        'office_id',
        'created_at',
        'updated_at',
        'not_id',
        'not_contract_type',
        'not_contract_date',
        'not_cancel_type',
        'not_office_id',
        'not_created_at',
        'not_updated_at'
      ]
    } else if (/^paymentdetails2s/.test(route.name)) {
      paramsList = [
        'id',
        'contract_id',
        'contract_type',
        'contract_date',
        'payment_type',
        'cancel_type',
        'company_id',
        'office_id',
        'payments_month',
        'plans_amount',
        'real_amount',
        'real_amount_date',
        'settlement_date',
        'f_name',
        'l_name',
        'unpaid_check',
        'unpaid_type',
        'created_at',
        'updated_at',

        'not_id',
        'not_contract_id',
        'not_contract_type',
        'not_contract_date',
        'not_payment_type',
        'not_cancel_type',
        'not_company_id',
        'not_office_id',
        'not_payments_month',
        'not_plans_amount',
        'not_real_amount',
        'not_real_amount_date',
        'not_settlement_date',
        'not_f_name',
        'not_l_name',
        'not_unpaid_check',
        'not_unpaid_type',
        'not_created_at',
        'not_updated_at'
      ]
    } else if (/^paymentdetails/.test(route.name)) {
      paramsList = [
        'id',
        'contract_id',
        'contract_type',
        'contract_date',
        'payment_type',
        'cancel_type',
        'company_id',
        'office_id',
        'payments_month',
        'plans_amount',
        'real_amount',
        'real_amount_date',
        'settlement_date',
        'f_name',
        'l_name',
        'unpaid_check',
        'unpaid_type',
        'created_at',
        'updated_at',

        'not_id',
        'not_contract_id',
        'not_contract_type',
        'not_contract_date',
        'not_payment_type',
        'not_cancel_type',
        'not_company_id',
        'not_office_id',
        'not_payments_month',
        'not_plans_amount',
        'not_real_amount',
        'not_real_amount_date',
        'not_settlement_date',
        'not_f_name',
        'not_l_name',
        'not_unpaid_check',
        'not_unpaid_type',
        'not_created_at',
        'not_updated_at'
      ]
    } else if (/^ledger-contracts/.test(route.name)) {
      paramsList = [
        'id',
        'real_amount_date',
        'contract_type',
        'contract_date',
        'change_date',
        'cancel_type',
        'cancel_date',
        'media',
        'f_name',
        'l_name',
        'f_name_kana',
        'l_name_kana',
        'tel',
        'tel2',
        'address',
        'address2',
        'payment_type',
        'text_type',
        'amount',
        'discount',
        // 'split_commission',
        // 'sales_commission',
        // 'sales_commission_head',
        // 'sales_commission_branch',
        'pure_amount',
        // 'pure_amount_head',
        // 'pure_amount_branch',
        // 'old_amount',
        'division_commission',
        'total_amount',
        'agency_commission',
        // 'agency_commission_head',
        // 'agency_commission_branch',
        'agency_commission_own_installment',
        // 'purchase_amount',
        // 'purchase_amount_head',
        // 'purchase_amount_branch',
        'only_total_amount',
        // 'only_total_amount_head',
        // 'only_total_amount_branch',
        'deposit_amount',
        'deposit_amount_date',
        'down_payment',
        'company_id',
        'office_id',
        'person',
        'product_name',
        'payments_number',
        'text_payment_period_start',
        'text_payment_period_end',
        'service_period_start',
        'service_period_end',
        'administrative_expense',
        'first_month_deposit',
        'first_month_deposit_method',
        'first_month_deposit_check',
        'admission_fee',
        'admission_fee_method',
        'admission_fee_check',
        'deposit',
        'deposit_method',
        'deposit_check',
        'deposit_refund_date',
        'approval_date',
        'approval_number',
        'delivery_date',
        'contract_collection_date',
        'factor_collection_date',
        'penalty_amount_limit',
        'penalty_plans_amount',
        'penalty_amount_date',
        'penalty_real_amount',
        'grade',
        // 'point_s',
        // 'point_c',
        // 'point_k',
        // 'point_s_bulk',
        // 'point_c_bulk',
        // 'point_k_bulk',
        // 'point_total',
        'note',

        'not_id',
        'not_real_amount_date',
        'not_contract_type',
        'not_contract_date',
        'not_change_date',
        'not_cancel_type',
        'not_cancel_date',
        'not_media',
        'not_f_name',
        'not_l_name',
        'not_f_name_kana',
        'not_l_name_kana',
        'not_tel',
        'not_tel2',
        'not_address',
        'not_address2',
        'not_payment_type',
        'not_text_type',
        'not_amount',
        'not_discount',
        // 'not_split_commission',
        // 'not_sales_commission',
        // 'not_sales_commission_head',
        // 'not_sales_commission_branch',
        'not_pure_amount',
        // 'not_pure_amount_head',
        // 'not_pure_amount_branch',
        // 'not_old_amount',
        'not_division_commission',
        'not_total_amount',
        'not_agency_commission',
        // 'not_agency_commission_head',
        // 'not_agency_commission_branch',
        'not_agency_commission_own_installment',
        // 'not_purchase_amount',
        // 'not_purchase_amount_head',
        // 'not_purchase_amount_branch',
        'not_only_total_amount',
        // 'not_only_total_amount_head',
        // 'not_only_total_amount_branch',
        'not_deposit_amount',
        'not_deposit_amount_date',
        'not_down_payment',
        'not_company_id',
        'not_office_id',
        'not_person',
        'not_product_name',
        'not_payments_number',
        'not_text_payment_period_start',
        'not_text_payment_period_end',
        'not_service_period_start',
        'not_service_period_end',
        'not_administrative_expense',
        'not_first_month_deposit',
        'not_first_month_deposit_method',
        'not_first_month_deposit_check',
        'not_admission_fee',
        'not_admission_fee_method',
        'not_admission_fee_check',
        'not_deposit',
        'not_deposit_method',
        'not_deposit_check',
        'not_deposit_refund_date',
        'not_approval_date',
        'not_approval_number',
        'not_delivery_date',
        'not_contract_collection_date',
        'not_factor_collection_date',
        'not_penalty_amount_limit',
        'not_penalty_plans_amount',
        'not_penalty_amount_date',
        'not_penalty_real_amount',
        'not_grade',
        // 'not_point_s',
        // 'not_point_c',
        // 'not_point_k',
        // 'not_point_s_bulk',
        // 'not_point_c_bulk',
        // 'not_point_k_bulk',
        // 'not_point_total',
        'not_note'
      ]
    }
    paramsList.forEach(function (e) {
      if (search[e]) {
        // console.log('true')
        if (e === 'contract_date') {
          // 期間検索するときは配列をつっこむ // **: [] で設定したものは入力されてなくてもtrueになってるぽい
          if (search[e][1]) {
            params[e] = [search[e][0], search[e][1]]
          } else if (search[e][0]) {
            params[e] = [search[e][0]]
          } else {
            return
          }
        } else if (e === 'not_contract_date') {
          if (search[e][1]) {
            params[e] = [search[e][0], search[e][1]]
          } else if (search[e][0]) {
            params[e] = [search[e][0]]
          } else {
            return
          }
        } else if (e === 'payments_month') {
          if (search[e][1]) {
            params[e] = [search[e][0], search[e][1]]
          } else if (search[e][0]) {
            params[e] = [search[e][0]]
          } else {
            return
          }
        } else if (e === 'not_payments_month') {
          if (search[e][1]) {
            params[e] = [search[e][0], search[e][1]]
          } else if (search[e][0]) {
            params[e] = [search[e][0]]
          } else {
            return
          }
        } else if (e === 'real_amount_date') {
          if (search[e][1]) {
            params[e] = [search[e][0], search[e][1]]
          } else if (search[e][0]) {
            params[e] = [search[e][0]]
          } else {
            return
          }
        } else if (e === 'not_real_amount_date') {
          if (search[e][1]) {
            params[e] = [search[e][0], search[e][1]]
          } else if (search[e][0]) {
            params[e] = [search[e][0]]
          } else {
            return
          }
        // } else if (e === 'settlement_date') {
        //   if (search[e][1]) {
        //     params[e] = [search[e][0], search[e][1]]
        //   } else if (search[e][0]) {
        //     params[e] = [search[e][0]]
        //   } else {
        //     return
        //   }
        // } else if (e === 'not_settlement_date') {
        //   if (search[e][1]) {
        //     params[e] = [search[e][0], search[e][1]]
        //   } else if (search[e][0]) {
        //     params[e] = [search[e][0]]
        //   } else {
        //     return
        //   }
        } else if (e === 'registration_date') {
          if (search[e][1]) {
            params[e] = [search[e][0], search[e][1]]
          } else if (search[e][0]) {
            params[e] = [search[e][0]]
          } else {
            return
          }
        } else if (e === 'not_registration_date') {
          if (search[e][1]) {
            params[e] = [search[e][0], search[e][1]]
          } else if (search[e][0]) {
            params[e] = [search[e][0]]
          } else {
            return
          }
        } else if (e === 'support_date') {
          if (search[e][1]) {
            params[e] = [search[e][0], search[e][1]]
          } else if (search[e][0]) {
            params[e] = [search[e][0]]
          } else {
            return
          }
        } else if (e === 'not_support_date') {
          if (search[e][1]) {
            params[e] = [search[e][0], search[e][1]]
          } else if (search[e][0]) {
            params[e] = [search[e][0]]
          } else {
            return
          }
        } else if (e === 'acquisition_date') {
          if (search[e][1]) {
            params[e] = [search[e][0], search[e][1]]
          } else if (search[e][0]) {
            params[e] = [search[e][0]]
          } else {
            return
          }
        } else if (e === 'not_acquisition_date') {
          if (search[e][1]) {
            params[e] = [search[e][0], search[e][1]]
          } else if (search[e][0]) {
            params[e] = [search[e][0]]
          } else {
            return
          }
        } else if (e === 'age') {
          if (search[e][1]) {
            params[e] = [search[e][0], search[e][1]]
          } else if (search[e][0]) {
            params[e] = [search[e][0]]
          } else {
            return
          }
        } else if (e === 'not_age') {
          if (search[e][1]) {
            params[e] = [search[e][0], search[e][1]]
          } else if (search[e][0]) {
            params[e] = [search[e][0]]
          } else {
            return
          }
        } else if (e === 'created_at') {
          params[e] = [search[e]]
        } else if (e === 'not_created_at') {
          params[e] = [search[e]]
        } else if (e === 'updated_at') {
          params[e] = [search[e]]
        } else if (e === 'not_updated_at') {
          params[e] = [search[e]]
          // Appointments
        } else if (e === 'contact_date') {
          params[e] = [search[e]]
        } else if (e === 'not_contact_date') {
          params[e] = [search[e]]
        } else if (e === 'visit_date') {
          params[e] = [search[e]]
        } else if (e === 'not_visit_date') {
          params[e] = [search[e]]
        } else if (e === 'next_visit_date') {
          params[e] = [search[e]]
        } else if (e === 'not_next_visit_date') {
          params[e] = [search[e]]
        } else if (e === 'sending_date') {
          params[e] = [search[e]]
        } else if (e === 'not_sending_date') {
          params[e] = [search[e]]
        } else if (e === 'birthday') {
          params[e] = [search[e]]
        } else if (e === 'not_birthday') {
          params[e] = [search[e]]
        } else if (e === 'service_period_start') {
          params[e] = [search[e]]
        } else if (e === 'not_service_period_start') {
          params[e] = [search[e]]
        } else if (e === 'service_period_end') {
          params[e] = [search[e]]
        } else if (e === 'not_service_period_end') {
          params[e] = [search[e]]
        } else if (e === 'ymd') {
          params[e] = [search[e]]
        } else if (e === 'not_ymd') {
          params[e] = [search[e]]
        } else if (e === 'filing_date') {
          params[e] = [search[e]]
        } else if (e === 'not_filing_date') {
          params[e] = [search[e]]
        } else if (e === 'matching_date') {
          params[e] = [search[e]]
        } else if (e === 'not_matching_date') {
          params[e] = [search[e]]
        } else if (e === 'change_date') {
          params[e] = [search[e]]
        } else if (e === 'not_change_date') {
          params[e] = [search[e]]
        } else if (e === 'cancel_date') {
          params[e] = [search[e]]
        } else if (e === 'not_cancel_date') {
          params[e] = [search[e]]
        } else if (e === 'approval_date') {
          params[e] = [search[e]]
        } else if (e === 'not_approval_date') {
          params[e] = [search[e]]
        } else if (e === 'delivery_date') {
          params[e] = [search[e]]
        } else if (e === 'not_delivery_date') {
          params[e] = [search[e]]
        } else if (e === 'contract_collection_date') {
          params[e] = [search[e]]
        } else if (e === 'not_contract_collection_date') {
          params[e] = [search[e]]
        } else if (e === 'factor_collection_date') {
          params[e] = [search[e]]
        } else if (e === 'not_factor_collection_date') {
          params[e] = [search[e]]
        } else if (e === 'deposit_amount_date') {
          params[e] = [search[e]]
        } else if (e === 'not_deposit_amount_date') {
          params[e] = [search[e]]
        } else if (e === 'real_amount_date') {
          params[e] = [search[e]]
        } else if (e === 'not_real_amount_date') {
          params[e] = [search[e]]
        } else if (e === 'settlement_date') {
          params[e] = [search[e]]
        } else if (e === 'not_settlement_date') {
          params[e] = [search[e]]
        } else if (e === 'payroll_check') {
          params[e] = [search[e]]
        } else if (e === 'not_payroll_check') {
          params[e] = [search[e]]
          // 設定中
        } else if (e === 'latest') {
          params[e] = [search[e]]
        } else if (e === 'not_latest') {
          params[e] = [search[e]]
          // familysupports
          // tutorsupports
        } else {
          params[e] = search[e]
        }
      } else if (search[e] === 0) {
        params[e] = search[e]
      }
    })

    axios.get(data.obj.url, {params: params, withCredentials: true}).then((response) => {
    // success callback
      store.state.list[data.obj.pageNames] = response.data[data.obj.pageName]
      store.state.max = response.data.max
      store.state.sum = response.data.sum
      store.state.count = response.data.count

      store.state.digestibility = response.data.digestibility

      data.obj.searchUrl = response.request.responseURL
      data.obj.exportUrl = response.request.responseURL.replace('search', 'export').replace('limit=100', '')
      data.obj.COUNT = 1
    }, (response) => {
    // error callback
    })
  }

  if (data.obj.TIMER) {
    clearTimeout(data.obj.TIMER)
    data.obj.TIMER = setTimeout(searchTable, wait)
    return
  }
  data.obj.TIMER = setTimeout(searchTable, wait)
}

export const SCROLL = ({ commit }, data) => {
  // let http = that.$http
  // let store = that.$store
  let wait = 500

  function scrolly () {
    // console.log('LIMIT:' + data.obj.offset)

    var height = data.e.target.lastElementChild.clientHeight
    // console.log('Height:' + (data.e.target.lastElementChild.clientHeight))
    var scrollTop = data.e.target.scrollTop
    // console.log('ScrollTop:' + (data.e.target.scrollTop))

    var URL = data.obj.searchUrl + '&offset=' + data.obj.offset * data.obj.COUNT
    // console.log(URL)

    // offset追加する処理
    if (height - 500 < scrollTop + 1500) {
      // console.log('下まできたから追加するよ')
      axios.get(URL, {withCredentials: true}).then((response) => {
        console.log(response)
        data.obj.max = response.data.max // ここでmaxを書き換えてる
        // console.log('MAXレコード数:' + data.obj.max)
        data.obj.COUNT = data.obj.COUNT + 1
        // ここで追加
        store.state.list[data.obj.pageNames] = store.state.list[data.obj.pageNames].concat(response.data[data.obj.pageName])
      // success callback
      }, (response) => {
      // error callback
        // console.log('mada')
      })
    }

    // maxまで到達したら終わり
    if (data.obj.max < data.obj.offset * data.obj.COUNT) {
      // console.log(data.obj.max)
      // console.log(data.obj.offset * data.obj.COUNT)
      // console.log('終わり')
      return
    }
  }
  if (data.obj.timer) {
    clearTimeout(data.obj.timer)
    data.obj.timer = setTimeout(scrolly, wait)
    return
  }
  data.obj.timer = setTimeout(scrolly, wait)
}

export const SEARCH2 = ({ commit }, data) => {
  console.log(data)
  let search = data.this.search2
  let route = data.this.$route
  let wait = 500

  // パラメーター格納用オブジェクト
  let params = {}
  // オブジェクトを捜査するための配列を作成

  function searchTable () {
    let paramsList
    if (/^familyfiles/.test(route.name)) {
      paramsList = [
        'id',
        'name',
        'kana',
        'pref',
        'address',
        'tel1',
        'created_at',
        'updated_at',
        'not_id',
        'not_name',
        'not_kana',
        'not_pref',
        'not_address',
        'not_tel1',
        'not_created_at',
        'not_updated_at'
      ]
    } else if (/^studentfiles/.test(route.name)) {
      paramsList = [
        'id',
        'family_name',
        'family_kana',
        'name',
        'kana',
        'gender',
        'school_stage',
        'grade',
        'pref',
        'address',
        'tel1',
        'created_at',
        'updated_at',
        'not_id',
        'not_family_name',
        'not_family_kana',
        'not_name',
        'not_kana',
        'not_gender',
        'not_school_stage',
        'not_grade',
        'not_pref',
        'not_address',
        'not_tel1',
        'not_created_at',
        'not_updated_at'
      ]
    } else if (/^tutorfiles/.test(route.name)) {
      paramsList = [
        'id',
        'name',
        'kana',
        'pref',
        'address',
        'tel1',
        'created_at',
        'updated_at',
        'not_id',
        'not_name',
        'not_kana',
        'not_address',
        'not_tel1',
        'not_created_at',
        'not_updated_at'
      ]
    } else if (/^reports/.test(route.name)) {
      paramsList = [
        'id',
        'office_id',
        'student_id',
        'tutor_id',
        'user_id',
        'guidance_period_start',
        'guidance_period_end',
        'filing_date',
        'matching_type',
        'matching_date',
        'change_reason',
        'matching_month',
        'state',
        'charge_person',
        'decision_person',
        'seven_days_tel',
        'ten_days_tel',
        'fourteen_days_tel',
        'document',
        'first_day_limit',
        'first_day_check',
        'first_day',
        'hold_person',
        'family_tel_limit',
        'tutor_tel_limit',
        'family_tel_limit_check',
        'tutor_tel_limit_check',
        'note',
        'created_at',
        'updated_at',
        'grade',
        'student_state',
        'student_name',
        'student_kana',
        'family_tel1',
        'family_tel2',
        'family_pref',
        'family_address',
        'tutor_name',
        'tutor_kana',
        'tutor_tel1',
        'tutor_tel2',
        'tutor_pref',
        'tutor_address',

        'not_id',
        'not_office_id',
        'not_student_id',
        'not_tutor_id',
        'not_user_id',
        'not_guidance_period_start',
        'not_guidance_period_end',
        'not_filing_date',
        'not_matching_type',
        'not_matching_date',
        'not_change_reason',
        'not_matching_month',
        'not_state',
        'not_charge_person',
        'not_decision_person',
        'not_seven_days_tel',
        'not_ten_days_tel',
        'not_fourteen_days_tel',
        'not_document',
        'not_first_day_limit',
        'not_first_day_check',
        'not_first_day',
        'not_hold_person',
        'not_family_tel_limit',
        'not_tutor_tel_limit',
        'not_family_tel_limit_check',
        'not_tutor_tel_limit_check',
        'not_note',
        'not_created_at',
        'not_updated_at',
        'not_grade',
        'not_student_state',
        'not_student_name',
        'not_student_kana',
        'not_family_tel1',
        'not_family_tel2',
        'not_family_pref',
        'not_family_address',
        'not_tutor_name',
        'not_tutor_kana',
        'not_tutor_tel1',
        'not_tutor_tel2',
        'not_tutor_pref',
        'not_tutor_address'
      ]
    } else if (/^paymentdetails/.test(route.name)) {
      paramsList = [
        'id'
      ]
    } else if (/^paymentdetails2s/.test(route.name)) {
      paramsList = [
        'id'
      ]
    }
    paramsList.forEach(function (e) {
      if (search[e]) {
        if (e === 'contract_date') {
          // 期間検索するときは配列をつっこむ // **: [] で設定したものは入力されてなくてもtrueになってるぽい
          if (search[e][1]) {
            params[e] = [search[e][0], search[e][1]]
          } else if (search[e][0]) {
            params[e] = [search[e][0]]
          } else {
            return
          }
        } else if (e === 'not_contract_date') {
          if (search[e][1]) {
            params[e] = [search[e][0], search[e][1]]
          } else if (search[e][0]) {
            params[e] = [search[e][0]]
          } else {
            return
          }
        } else if (e === 'payments_month') {
          if (search[e][1]) {
            params[e] = [search[e][0], search[e][1]]
          } else if (search[e][0]) {
            params[e] = [search[e][0]]
          } else {
            return
          }
        } else if (e === 'not_payments_month') {
          if (search[e][1]) {
            params[e] = [search[e][0], search[e][1]]
          } else if (search[e][0]) {
            params[e] = [search[e][0]]
          } else {
            return
          }
        // } else if (e === 'real_amount_date') {
        //   if (search[e][1]) {
        //     params[e] = [search[e][0], search[e][1]]
        //   } else if (search[e][0]) {
        //     params[e] = [search[e][0]]
        //   } else {
        //     return
        //   }
        // } else if (e === 'not_real_amount_date') {
        //   if (search[e][1]) {
        //     params[e] = [search[e][0], search[e][1]]
        //   } else if (search[e][0]) {
        //     params[e] = [search[e][0]]
        //   } else {
        //     return
        //   }
        // } else if (e === 'settlement_date') {
        //   if (search[e][1]) {
        //     params[e] = [search[e][0], search[e][1]]
        //   } else if (search[e][0]) {
        //     params[e] = [search[e][0]]
        //   } else {
        //     return
        //   }
        // } else if (e === 'not_settlement_date') {
        //   if (search[e][1]) {
        //     params[e] = [search[e][0], search[e][1]]
        //   } else if (search[e][0]) {
        //     params[e] = [search[e][0]]
        //   } else {
        //     return
        //   }
        } else if (e === 'created_at') {
          params[e] = [search[e]]
        } else if (e === 'not_created_at') {
          params[e] = [search[e]]
        } else if (e === 'updated_at') {
          params[e] = [search[e]]
        } else if (e === 'not_updated_at') {
          params[e] = [search[e]]
          // Appointments
        } else if (e === 'contact_date') {
          params[e] = [search[e]]
        } else if (e === 'not_contact_date') {
          params[e] = [search[e]]
        } else if (e === 'visit_date') {
          params[e] = [search[e]]
        } else if (e === 'not_visit_date') {
          params[e] = [search[e]]
        } else if (e === 'next_visit_date') {
          params[e] = [search[e]]
        } else if (e === 'not_next_visit_date') {
          params[e] = [search[e]]
        } else if (e === 'sending_date') {
          params[e] = [search[e]]
        } else if (e === 'not_sending_date') {
          params[e] = [search[e]]
          // Students
        } else if (e === 'birthday') {
          params[e] = [search[e]]
        } else if (e === 'not_birthday') {
          params[e] = [search[e]]
        } else if (e === 'service_period_start') {
          params[e] = [search[e]]
        } else if (e === 'not_service_period_start') {
          params[e] = [search[e]]
        } else if (e === 'service_period_end') {
          params[e] = [search[e]]
        } else if (e === 'not_service_period_end') {
          params[e] = [search[e]]
        } else if (e === 'ymd') {
          params[e] = [search[e]]
        } else if (e === 'not_ymd') {
          params[e] = [search[e]]
        } else if (e === 'filing_date') {
          params[e] = [search[e]]
        } else if (e === 'not_filing_date') {
          params[e] = [search[e]]
        } else if (e === 'matching_date') {
          params[e] = [search[e]]
        } else if (e === 'not_matching_date') {
          params[e] = [search[e]]
        } else if (e === 'change_date') {
          params[e] = [search[e]]
        } else if (e === 'not_change_date') {
          params[e] = [search[e]]
        } else if (e === 'cancel_date') {
          params[e] = [search[e]]
        } else if (e === 'not_cancel_date') {
          params[e] = [search[e]]
        } else if (e === 'approval_date') {
          params[e] = [search[e]]
        } else if (e === 'not_approval_date') {
          params[e] = [search[e]]
        } else if (e === 'delivery_date') {
          params[e] = [search[e]]
        } else if (e === 'not_delivery_date') {
          params[e] = [search[e]]
        } else if (e === 'contract_collection_date') {
          params[e] = [search[e]]
        } else if (e === 'not_contract_collection_date') {
          params[e] = [search[e]]
        } else if (e === 'factor_collection_date') {
          params[e] = [search[e]]
        } else if (e === 'not_factor_collection_date') {
          params[e] = [search[e]]
        } else if (e === 'deposit_amount_date') {
          params[e] = [search[e]]
        } else if (e === 'not_deposit_amount_date') {
          params[e] = [search[e]]
        } else if (e === 'real_amount_date') {
          params[e] = [search[e]]
        } else if (e === 'not_real_amount_date') {
          params[e] = [search[e]]
        } else if (e === 'settlement_date') {
          params[e] = [search[e]]
        } else if (e === 'settlement_date') {
          params[e] = [search[e]]
        } else {
          params[e] = search[e]
        }
      } else if (search[e] === 0) {
        params[e] = search[e]
      }
    })

    axios.get(data.obj.url, {params: params, withCredentials: true}).then((response) => {
    // success callback
      console.log(response)
      store.state.list[data.obj.pageNames] = response.data[data.obj.pageName]
      if (/^familyfiles/.test(route.name) || /^studentfiles/.test(route.name) || /^tutorfiles/.test(route.name) || /^reports/.test(route.name)) {
        store.state.max = response.data.max
        store.state.sum = response.data.sum
        store.state.count = response.data.count
      } else {
        // paymentdetails, paymentdetails2sのgetpreview時に集計上書きされないように。
        return
      }
      data.obj.searchUrl = response.request.responseURL
      data.obj.exportUrl = response.request.responseURL.replace('search', 'export').replace('limit=100', '')
      data.obj.COUNT = 1
    }, (response) => {
    // error callback
    })
  }

  if (data.obj.TIMER) {
    clearTimeout(data.obj.TIMER)
    data.obj.TIMER = setTimeout(searchTable, wait)
    return
  }
  data.obj.TIMER = setTimeout(searchTable, wait)
}

// Contracts
export const getContracts = ({ commit }) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/contracts/search?limit=' + settings.LIMIT,
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.list.contracts = response.data.contract
    store.state.max = response.data.max
    store.state.sum = response.data.sum
  }).catch(error => {
    console.log(error)
    // alert('getに失敗しました')
    store.dispatch('loginState')
  })
}

export const getContract = ({ commit }) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/contract/',
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.item.contract = response.data
  }).catch(error => {
    console.log(error)
    // alert('get失敗しました')
    store.dispatch('loginState')
  })
}

export const postContract = ({ commit }, data) => {
  console.log(data)
  const params = {
    'contract_date': data.contract.contract_date,
    'cancel_type': data.contract.cancel_typ,
    'office': data.contract.office
  }
  console.log(params)
  axios({
    method: 'post',
    params: params,
    url: getAPIURL() + '/api/v1/contracts/',
    withCredentials: true
  }).then(response => {
    console.log(response)
    axios({
      method: 'get',
      url: getAPIURL() + '/api/v1/contracts/search?limit=' + settings.LIMIT,
      withCredentials: true
    }).then(response => {
      console.log(response)
      store.state.list.contracts = response.data.contract
      data.this.$router.push({name: 'contractsindex'})
      alert('Contractを登録しました')
    }).catch(error => {
      console.log(error)
      alert('Contractを登録できませんでした。')
      store.dispatch('loginState')
    })
  }).catch(error => {
    console.log(error)
    alert('Contractを登録できませんでした。')
    store.dispatch('loginState')
  })
}

export const patchContract = ({ commit }, data) => {
  const params = {
    'contract_date': data.list.contract_date,
    'cancel_type': data.list.cancel_type,
    'office': data.list.office
  }
  axios({
    method: 'patch',
    params: params,
    url: getAPIURL() + '/api/v1/contracts/' + data.list.id,
    withCredentials: true
  }).then(response => {
    console.log(response)
    axios({
      method: 'get',
      url: getAPIURL() + '/api/v1/contracts/' + data.list.id,
      withCredentials: true
    }).then(response => {
      console.log(response)
      store.state.item.contract = response.data
      data.edit_id.edit_id = ''
    }).catch(error => {
      console.log(error)
      alert('編集を保存できませんでした。')
      store.dispatch('loginState')
    })
  }).catch(error => {
    console.log(error)
    alert('編集を保存できませんでした。')
    store.dispatch('loginState')
  })
}

export const cancelContract = ({ commit }, data) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/contracts/' + store.state.item.contract.id,
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.item.contract = response.data
    data.edit_id.edit_id = ''
    // alert('editキャンセルしました')
  })
}

export const deleteContract = ({ commit }, data) => {
  console.log(data)
  if (window.confirm('Contractを削除しますか？')) {
    axios({
      method: 'delete',
      url: getAPIURL() + '/api/v1/contracts/' + data.contract.id,
      withCredentials: true
    }).then(response => {
      console.log(response)
      axios({
        method: 'get',
        url: getAPIURL() + '/api/v1/contracts/search?limit=' + settings.LIMIT,
        withCredentials: true
      }).then(response => {
        console.log(response)
        store.state.list.contracts = response.data.contract
        data.this.$router.push({name: 'contractsindex'})
        alert('Contractを削除しました')
      }).catch(error => {
        console.log(error)
        alert('Contractを削除できませんでした。')
        store.dispatch('loginState')
      })
    }).catch(error => {
      console.log(error)
      alert('Contractを削除できませんでした。')
      store.dispatch('loginState')
    })
  } else {
    return
  }
}

// Paymentdetails
export const getPaymentdetails = ({ commit }) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/paymentdetails/search?limit=' + settings.LIMIT,
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.list.paymentdetails = response.data.data
    store.state.max = response.data.max
    store.state.sum = response.data.sum
    store.state.count = response.data.count
  }).catch(error => {
    console.log(error)
    // alert('getに失敗しました')
    store.dispatch('loginState')
  })
}

export const getPaymentdetail = ({ commit }) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/paymentdetail/',
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.item.paymentdetail = response.data
  }).catch(error => {
    console.log(error)
    // alert('get失敗しました')
    store.dispatch('loginState')
  })
}

export const getPaymentdetailsDelinquent_month = ({ commit }) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/paymentdetails/delinquent_month?limit=' + settings.LIMIT,
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.list.paymentdetailsDelinquent_month = response.data.data
    store.state.max = response.data.max
    store.state.sum = response.data.sum
    store.state.count = response.data.count
  }).catch(error => {
    console.log(error)
    // alert('getに失敗しました')
    store.dispatch('loginState')
  })
}

export const getPaymentdetailsDelinquent_two_month = ({ commit }) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/paymentdetails/delinquent_two_month?limit=' + settings.LIMIT,
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.list.paymentdetailsDelinquent_two_month = response.data.data
    store.state.max = response.data.max
    store.state.sum = response.data.sum
    store.state.count = response.data.count
  }).catch(error => {
    console.log(error)
    // alert('getに失敗しました')
    store.dispatch('loginState')
  })
}

export const patchPaymentdetail = ({ commit }, data) => {
  const params = {
    'payments_month': data.list.payments_month,
    'plans_amount': data.list.plans_amount,
    'real_amount': data.list.real_amount,
    // 'real_amount_date': data.list.real_amount_date,
    // 'settlement_date': data.list.settlement_date,
    'unpaid_check': data.list.patchUnpaid_check.value,
    'unpaid_type': data.list.patchUnpaid_type.value
  }
  axios({
    method: 'patch',
    params: params,
    url: getAPIURL() + '/api/v1/paymentdetails/' + data.list.id,
    withCredentials: true
  }).then(response => {
    console.log(response)
    axios({
      method: 'get',
      url: data.obj.searchUrl,
      withCredentials: true
    }).then(response => {
      console.log(response)
      store.state.list.paymentdetails = response.data.data
    }).catch(error => {
      console.log(error)
      alert('編集を保存できませんでした。')
      store.dispatch('loginState')
    })
  }).catch(error => {
    console.log(error)
    alert('編集を保存できませんでした。')
    store.dispatch('loginState')
  })
}

// Paymentdetails2s
export const getPaymentdetails2s = ({ commit }) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/paymentdetails2s/search?limit=' + settings.LIMIT,
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.list.paymentdetails2s = response.data.data
    store.state.max = response.data.max
    store.state.sum = response.data.sum
    store.state.count = response.data.count
  }).catch(error => {
    console.log(error)
    // alert('getに失敗しました')
    store.dispatch('loginState')
  })
}

export const getPaymentdetails2 = ({ commit }) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/paymentdetails2/',
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.item.paymentdetails2 = response.data
  }).catch(error => {
    console.log(error)
    // alert('get失敗しました')
    store.dispatch('loginState')
  })
}

export const getPaymentdetails2sDelinquent_month = ({ commit }) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/paymentdetails2s/delinquent_month?limit=' + settings.LIMIT,
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.list.paymentdetails2sDelinquent_month = response.data.data
    store.state.max = response.data.max
    store.state.sum = response.data.sum
    store.state.count = response.data.count
  }).catch(error => {
    console.log(error)
    // alert('getに失敗しました')
    store.dispatch('loginState')
  })
}

export const getPaymentdetails2sDelinquent_two_month = ({ commit }) => {
  axios({
    method: 'get',
    url: getAPIURL() + '/api/v1/paymentdetails2s/delinquent_two_month?limit=' + settings.LIMIT,
    withCredentials: true
  }).then(response => {
    console.log(response)
    store.state.list.paymentdetails2sDelinquent_two_month = response.data.data
    store.state.max = response.data.max
    store.state.sum = response.data.sum
    store.state.count = response.data.count
  }).catch(error => {
    console.log(error)
    // alert('getに失敗しました')
    store.dispatch('loginState')
  })
}

export const patchPaymentdetails2 = ({ commit }, data) => {
  const params = {
    'payments_month': data.list.payments_month,
    'plans_amount': data.list.plans_amount,
    'real_amount': data.list.real_amount,
    // 'real_amount_date': data.list.real_amount_date,
    // 'settlement_date': data.list.settlement_date,
    'unpaid_check': data.list.patchUnpaid_check.value,
    'unpaid_type': data.list.patchUnpaid_type.value
  }
  axios({
    method: 'patch',
    params: params,
    url: getAPIURL() + '/api/v1/paymentdetails2s/' + data.list.id,
    withCredentials: true
  }).then(response => {
    console.log(response)
    axios({
      method: 'get',
      url: data.obj.searchUrl,
      withCredentials: true
    }).then(response => {
      console.log(response)
      store.state.list.paymentdetails2s = response.data.data
    }).catch(error => {
      console.log(error)
      alert('編集を保存できませんでした。')
      store.dispatch('loginState')
    })
  }).catch(error => {
    console.log(error)
    alert('編集を保存できませんでした。')
    store.dispatch('loginState')
  })
}



// WEBPACK FOOTER //
// ./src/store/actions.js